(function () {
  const products = document.querySelectorAll('[data-fd-product]');
  if (!products.length) return;

  const observeElement = (observer, target, options) => {
    if (!observer || !target || target.nodeType !== 1 || typeof observer.observe !== 'function') return false;
    try {
      observer.observe(target, options);
      return true;
    } catch (_error) {
      return false;
    }
  };

  const targetBcpoMainImageLinkHandles = new Set([
    'outdoor-curtain-custom-linen-curtains-chevrons',
    'sheer-cafe-curtains-for-small-windows',
    'sheer-cafe-curtains-for-white-kitchen',
    'custom-linen-curtains-bolonia',
    'heavy-duty-long-curtains-for-bathroom-showers-bolonia',
    'modern-curtains-for-bedroom-bolonia',
    'outdoor-curtain-bedroom-window-curtains-bolonia',
    'room-divider-curtain-bedroom-window-curtains-bolonia',
    'window-shades-for-baby-room-dp60-01-23',
    'velvet-christmas-kitchen-curtains-for-holiday',
    'velvet-kitchen-window-cafe-curtains',
    'outdoor-curtain-sliding-patio-door-curtains-hundred'
  ]);

  const forceTopGeneratedColorFieldHandles = new Set([
    'custom-natural-3-shades-on-1-headrail-nu-01-bamboo-shades',
    'custom-ramie-reed-top-down-bottom-up-alum-headrail-rs408-1-bamboo-shades'
  ]);

  const neutralBambooStandardSwatchAssetFilenames = Object.freeze({
    hazel: Object.freeze({
      'Ashwood Pine H11-8': 'fd-own-material_closeup-solenne-h11-8.jpg',
      'Buttercream H11-6': 'fd-own-material_closeup-solenne-h11-6.jpg',
      'Chestnut H11-2': 'fd-own-material_closeup-solenne-h11-2.jpg',
      'Inkwell Oak H11-10': 'fd-own-material_closeup-solenne-h11-10.jpg',
      'Misty Sage H11-7': 'fd-own-material_closeup-solenne-h11-7.jpg',
      'Olive Ash H11-9': 'fd-own-material_closeup-solenne-h11-9.jpg',
      'Pale Almond H11-4': 'fd-own-material_closeup-solenne-h11-4.jpg',
      'Pale Wheat H11-5': 'fd-own-material_closeup-solenne-h11-5.jpg',
      'Pecan H11-1': 'fd-own-material_closeup-solenne-h11-1.jpg',
      'Warm Beige H11-3': 'fd-own-material_closeup-solenne-h11-3.jpg'
    }),
    ivy: Object.freeze({
      'Amber DXP-03': 'fd-own-material_closeup-orelle-dxp-03.jpg',
      'Backgammon M-2023': 'fd-own-material_closeup-orelle-m-2023.jpg',
      'Black Brown DZH-88': 'fd-own-material_closeup-orelle-dzh-88.jpg',
      'Bone White DP60-01': 'fd-own-material_closeup-orelle-dp60-01.jpg',
      'Freckle M-2002': 'fd-own-material_closeup-orelle-m-2002.jpg',
      'Marble DC07-22': 'fd-own-material_closeup-orelle-dc07-22.jpg',
      'Mist Gray 103-22': 'fd-own-material_closeup-orelle-103-22.jpg',
      'Moss DXS-09': 'fd-own-material_closeup-orelle-dxs-09.jpg',
      'Off White SLR06-02': 'fd-own-material_closeup-orelle-slr06-02.jpg',
      'Olive Green SLJU-22': 'fd-own-material_closeup-orelle-slju-22.jpg',
      'Snow DC01-01': 'fd-own-material_closeup-orelle-dc01-01.jpg',
      'Tawny 103-21': 'fd-own-material_closeup-orelle-103-21.jpg'
    }),
    natural: Object.freeze({
      'Black Gold NU-03': 'fd-own-material_closeup-natural-nu-03.jpg',
      'Black Gray NU-04': 'fd-own-material_closeup-natural-nu-04.jpg',
      'Caramel Stripes NU-05': 'fd-own-material_closeup-natural-nu-05.jpg',
      'Coconut White NU-02': 'fd-own-material_closeup-natural-nu-02.jpg',
      'Enchanted Meadow NU-06': 'fd-own-material_closeup-natural-nu-06.jpg',
      'Ginkgo NU-08': 'fd-own-material_closeup-natural-nu-08.jpg',
      'Grassland NU-09': 'fd-own-material_closeup-natural-nu-09.jpg',
      'Oatmeal Yellow NU-01': 'fd-own-material_closeup-natural-nu-01.jpg',
      'Prairie NU-07': 'fd-own-material_closeup-natural-nu-07.jpg',
      'Sesame Gray NU-10': 'fd-own-material_closeup-natural-nu-10.jpg'
    }),
    nomi: Object.freeze({
      'Avocado NA1323': 'fd-own-material_closeup-auvia-na1323.jpg',
      'Birch Forest NA0801': 'fd-own-material_closeup-auvia-na0801.jpg',
      'Brown NA2003': 'fd-own-material_closeup-auvia-na2003.jpg',
      'Butter NA0705': 'fd-own-material_closeup-auvia-na0705.jpg',
      'Cheese NA0201': 'fd-own-material_closeup-auvia-na0201.jpg',
      'Cobblestone NA5302': 'fd-own-material_closeup-auvia-na5302.jpg',
      'Coffee NA019': 'fd-own-material_closeup-auvia-na019.jpg',
      'Grayish Blue NA0822': 'fd-own-material_closeup-auvia-na0822.jpg',
      'Hemp Grass NA0212': 'fd-own-material_closeup-auvia-na0212.jpg',
      'Light Brown NA0812': 'fd-own-material_closeup-auvia-na0812.jpg',
      'Sandstone NA002': 'fd-own-material_closeup-auvia-na002.jpg',
      'Tree Bark NA1903': 'fd-own-material_closeup-auvia-na1903.jpg'
    }),
    ramie: Object.freeze({
      'Almond E427': 'fd-own-material_closeup-tessora-e427.jpg',
      'Beige 390': 'fd-own-material_closeup-tessora-390.jpg',
      'Beige Brown DHZ-01': 'fd-own-material_closeup-tessora-dhz-01.jpg',
      'Beige White 390-02': 'fd-own-material_closeup-tessora-390-02.jpg',
      'Cashew D11-01': 'fd-own-material_closeup-tessora-d11-01.jpg',
      'Cinnamon 0833N': 'fd-own-material_closeup-tessora-0833n.jpg',
      'Coconut JU-04': 'fd-own-material_closeup-tessora-ju-04.jpg',
      'Cream D13-02': 'fd-own-material_closeup-tessora-d13-02.jpg',
      'Honeynut D15-04': 'fd-own-material_closeup-tessora-d15-04.jpg',
      'Ivory JU-01': 'fd-own-material_closeup-tessora-ju-01.jpg',
      'Marble White DMC02-01': 'fd-own-material_closeup-tessora-dmc02-01.jpg',
      'Woven 9077K': 'fd-own-material_closeup-tessora-9077k.jpg'
    }),
    willow: Object.freeze({
      'Buff W07-11': 'fd-own-material_closeup-velune-w07-11.jpg',
      'Cream W07-7': 'fd-own-material_closeup-velune-w07-7.jpg',
      'Flax W07-4': 'fd-own-material_closeup-velune-w07-4.jpg',
      'Gray Green W07-2': 'fd-own-material_closeup-velune-w07-2.jpg',
      'Light Brown W07-6': 'fd-own-material_closeup-velune-w07-6.jpg',
      'Marble White W07-9': 'fd-own-material_closeup-velune-w07-9.jpg',
      'Oat W07-8': 'fd-own-material_closeup-velune-w07-8.jpg',
      'Olive W07-5': 'fd-own-material_closeup-velune-w07-5.jpg',
      'Sand W07-10': 'fd-own-material_closeup-velune-w07-10.jpg',
      'Straw W07-3': 'fd-own-material_closeup-velune-w07-3.jpg',
      'Wheat W07-1': 'fd-own-material_closeup-velune-w07-1.jpg'
    })
  });

  const targetBambooGuideHandles = new Set([
    'custom-hazel-2-shades-on-1-headrail-h11-1-bamboo-shades',
    'custom-hazel-3-shades-on-1-headrail-h11-1-bamboo-shades',
    'custom-hazel-ashwood-pine-h11-8-top-down-bottom-up-bamboo-shades',
    'custom-hazel-ashwood-pine-h11-8-woven-bamboo-shades',
    'custom-hazel-buttercream-h11-6-top-down-bottom-up-bamboo-shades',
    'custom-hazel-buttercream-h11-6-woven-bamboo-shades',
    'custom-hazel-chestnut-h11-2-top-down-bottom-up-bamboo-shades',
    'custom-hazel-chestnut-h11-2-woven-bamboo-shades',
    'custom-hazel-french-door-h11-1-bamboo-shades',
    'custom-hazel-inkwell-oak-h11-10-top-down-bottom-up-bamboo-shades',
    'custom-hazel-inkwell-oak-h11-10-woven-bamboo-shades',
    'custom-hazel-misty-sage-h11-7-top-down-bottom-up-bamboo-shades',
    'custom-hazel-misty-sage-h11-7-woven-bamboo-shades',
    'custom-hazel-motorized-bamboo-shades-blinds',
    'custom-hazel-olive-ash-h11-9-top-down-bottom-up-bamboo-shades',
    'custom-hazel-olive-ash-h11-9-woven-bamboo-shades',
    'custom-hazel-pale-almond-h11-4-top-down-bottom-up-bamboo-shades',
    'custom-hazel-pale-almond-h11-4-woven-bamboo-shades',
    'custom-hazel-pale-wheat-h11-5-top-down-bottom-up-bamboo-shades',
    'custom-hazel-pale-wheat-h11-5-woven-bamboo-shades',
    'custom-hazel-pecan-h11-1-top-down-bottom-up-bamboo-shades',
    'custom-hazel-pecan-h11-1-woven-bamboo-shades',
    'custom-hazel-warm-beige-h11-3-top-down-bottom-up-bamboo-shades',
    'custom-hazel-warm-beige-h11-3-woven-bamboo-shades',
    'custom-ivy-2-shades-on-1-headrail-dc01-01-bamboo-shades',
    'custom-ivy-3-shades-on-1-headrail-dc01-01-bamboo-shades',
    'custom-ivy-amber-dxp-03-top-down-bottom-up-bamboo-shades',
    'custom-ivy-amber-dxp-03-woven-bamboo-shades',
    'custom-ivy-backgammon-m-2023-top-down-bottom-up-bamboo-shades',
    'custom-ivy-backgammon-m-2023-woven-bamboo-shades',
    'custom-ivy-black-brown-dzh-88-top-down-bottom-up-bamboo-shades',
    'custom-ivy-black-brown-dzh-88-woven-bamboo-shades',
    'custom-ivy-bone-white-dp60-01-top-down-bottom-up-bamboo-shades',
    'custom-ivy-bone-white-dp60-01-woven-bamboo-shades',
    'custom-ivy-freckle-m-2002-top-down-bottom-up-bamboo-shades',
    'custom-ivy-freckle-m-2002-woven-bamboo-shades',
    'custom-ivy-french-door-dc01-01-bamboo-shades',
    'custom-ivy-marble-dc07-22-top-down-bottom-up-bamboo-shades',
    'custom-ivy-marble-dc07-22-woven-bamboo-shades',
    'custom-ivy-mist-gray-103-22-top-down-bottom-up-bamboo-shades',
    'custom-ivy-mist-gray-103-22-woven-bamboo-shades',
    'custom-ivy-moss-dxs-09-top-down-bottom-up-bamboo-shades',
    'custom-ivy-moss-dxs-09-woven-bamboo-shades',
    'custom-ivy-motorized-bamboo-shades-blinds',
    'custom-ivy-off-white-slr06-02-top-down-bottom-up-bamboo-shades',
    'custom-ivy-off-white-slr06-02-woven-bamboo-shades',
    'custom-ivy-olive-green-slju-22-top-down-bottom-up-bamboo-shades',
    'custom-ivy-olive-green-slju-22-woven-bamboo-shades',
    'custom-ivy-snow-dc01-01-top-down-bottom-up-bamboo-shades',
    'custom-ivy-snow-dc01-01-woven-bamboo-shades',
    'custom-ivy-tawny-103-21-top-down-bottom-up-bamboo-shades',
    'custom-ivy-tawny-103-21-woven-bamboo-shades',
    'custom-natural-2-shades-on-1-headrail-nu-01-bamboo-shades',
    'custom-natural-black-gold-nu-03-top-down-bottom-up-bamboo-shades',
    'custom-natural-black-gold-nu-03-woven-bamboo-shades',
    'custom-natural-black-gray-nu-04-top-down-bottom-up-bamboo-shades',
    'custom-natural-black-gray-nu-04-woven-bamboo-shades',
    'custom-natural-caramel-stripes-nu-05-top-down-bottom-up-bamboo-shades',
    'custom-natural-caramel-stripes-nu-05-woven-bamboo-shades',
    'custom-natural-coconut-white-nu-02-top-down-bottom-up-bamboo-shades',
    'custom-natural-coconut-white-nu-02-woven-bamboo-shades',
    'custom-natural-enchanted-meadow-nu-06-top-down-bottom-up-bamboo-shades',
    'custom-natural-enchanted-meadow-nu-06-woven-bamboo-shades',
    'custom-natural-french-door-nu-01-bamboo-shades',
    'custom-natural-ginkgo-nu-08-top-down-bottom-up-bamboo-shades',
    'custom-natural-ginkgo-nu-08-woven-bamboo-shades',
    'custom-natural-grassland-nu-09-top-down-bottom-up-bamboo-shades',
    'custom-natural-grassland-nu-09-woven-bamboo-shades',
    'custom-natural-motorized-bamboo-shades-blinds',
    'custom-natural-oatmeal-yellow-nu-01-3-shades-on-1-headrail-bamboo-shades',
    'custom-natural-oatmeal-yellow-nu-01-top-down-bottom-up-bamboo-shades',
    'custom-natural-oatmeal-yellow-nu-01-woven-bamboo-shades',
    'custom-natural-prairie-nu-07-top-down-bottom-up-bamboo-shades',
    'custom-natural-prairie-nu-07-woven-bamboo-shades',
    'custom-natural-sesame-gray-nu-10-top-down-bottom-up-bamboo-shades',
    'custom-natural-sesame-gray-nu-10-woven-bamboo-shades',
    'custom-nomi-2-shades-on-1-headrail-na1323-bamboo-shades',
    'custom-nomi-3-shades-on-1-headrail-na1323-bamboo-shades',
    'custom-nomi-avocado-na1323-top-down-bottom-up-bamboo-shades',
    'custom-nomi-avocado-na1323-woven-bamboo-shades',
    'custom-nomi-birch-forest-na0801-top-down-bottom-up-bamboo-shades',
    'custom-nomi-birch-forest-na0801-woven-bamboo-shades',
    'custom-nomi-brown-na2003-top-down-bottom-up-bamboo-shades',
    'custom-nomi-brown-na2003-woven-bamboo-shades',
    'custom-nomi-butter-na0705-top-down-bottom-up-bamboo-shades',
    'custom-nomi-butter-na0705-woven-bamboo-shades',
    'custom-nomi-cheese-na0201-top-down-bottom-up-bamboo-shades',
    'custom-nomi-cheese-na0201-woven-bamboo-shades',
    'custom-nomi-cobblestone-na5302-top-down-bottom-up-bamboo-shades',
    'custom-nomi-cobblestone-na5302-woven-bamboo-shades',
    'custom-nomi-coffee-na019-top-down-bottom-up-bamboo-shades',
    'custom-nomi-coffee-na019-woven-bamboo-shades',
    'custom-nomi-french-door-na1323-bamboo-shades',
    'custom-nomi-grayish-blue-na0822-top-down-bottom-up-bamboo-shades',
    'custom-nomi-grayish-blue-na0822-woven-bamboo-shades',
    'custom-nomi-hemp-grass-na0212-top-down-bottom-up-bamboo-shades',
    'custom-nomi-hemp-grass-na0212-woven-bamboo-shades',
    'custom-nomi-light-brown-na0812-top-down-bottom-up-bamboo-shades',
    'custom-nomi-light-brown-na0812-woven-bamboo-shades',
    'custom-nomi-motorized-bamboo-shades-blinds',
    'custom-nomi-sandstone-na002-top-down-bottom-up-bamboo-shades',
    'custom-nomi-sandstone-na002-woven-bamboo-shades',
    'custom-nomi-tree-bark-na1903-top-down-bottom-up-bamboo-shades',
    'custom-nomi-tree-bark-na1903-woven-bamboo-shades',
    'custom-ramie-2-shades-on-1-headrail-d15-04-bamboo-shades',
    'custom-ramie-3-shades-on-1-headrail-d15-04-bamboo-shades',
    'custom-ramie-almond-e427-top-down-bottom-up-bamboo-shades',
    'custom-ramie-almond-e427-woven-bamboo-shades',
    'custom-ramie-beige-390-top-down-bottom-up-bamboo-shades',
    'custom-ramie-beige-390-woven-bamboo-shades',
    'custom-ramie-beige-brown-dhz-01-top-down-bottom-up-bamboo-shades',
    'custom-ramie-beige-brown-dhz-01-woven-bamboo-shades',
    'custom-ramie-beige-white-390-02-top-down-bottom-up-bamboo-shades',
    'custom-ramie-beige-white-390-02-woven-bamboo-shades',
    'custom-ramie-cashew-d11-01-top-down-bottom-up-bamboo-shades',
    'custom-ramie-cashew-d11-01-woven-bamboo-shades',
    'custom-ramie-cinnamon-0833n-top-down-bottom-up-bamboo-shades',
    'custom-ramie-cinnamon-0833n-woven-bamboo-shades',
    'custom-ramie-coconut-ju-04-top-down-bottom-up-bamboo-shades',
    'custom-ramie-coconut-ju-04-woven-bamboo-shades',
    'custom-ramie-cream-d13-02-top-down-bottom-up-bamboo-shades',
    'custom-ramie-cream-d13-02-woven-bamboo-shades',
    'custom-ramie-french-door-d15-04-bamboo-shades',
    'custom-ramie-honeynut-d15-04-top-down-bottom-up-bamboo-shades',
    'custom-ramie-honeynut-d15-04-woven-bamboo-shades',
    'custom-ramie-ivory-ju-01-top-down-bottom-up-bamboo-shades',
    'custom-ramie-ivory-ju-01-woven-bamboo-shades',
    'custom-ramie-marble-white-dmc02-01-top-down-bottom-up-bamboo-shades',
    'custom-ramie-marble-white-dmc02-01-woven-bamboo-shades',
    'custom-ramie-motorized-bamboo-shades-blinds',
    'custom-ramie-reed-aluminum-headrail-rs408-1-bamboo-shades',
    'custom-ramie-reed-french-door-rs408-1-bamboo-shades',
    'custom-ramie-reed-motorized-rs408-1-bamboo-shades',
    'custom-ramie-reed-top-down-bottom-up-alum-headrail-rs408-1-bamboo-shades',
    'custom-ramie-reed-top-down-bottom-up-wooden-headrail-rs408-1-bamboo-shades',
    'custom-ramie-reed-wooden-headrail-rs408-1-bamboo-shades',
    'custom-ramie-woven-9077k-top-down-bottom-up-bamboo-shades',
    'custom-ramie-woven-9077k-woven-bamboo-shades',
    'custom-willow-2-shades-on-1-headrail-w07-1-bamboo-shades',
    'custom-willow-3-shades-on-1-headrail-w07-1-bamboo-shades',
    'custom-willow-buff-w07-11-top-down-bottom-up-bamboo-shades',
    'custom-willow-buff-w07-11-woven-bamboo-shades',
    'custom-willow-cream-w07-7-top-down-bottom-up-bamboo-shades',
    'custom-willow-cream-w07-7-woven-bamboo-shades',
    'custom-willow-flax-w07-4-top-down-bottom-up-bamboo-shades',
    'custom-willow-flax-w07-4-woven-bamboo-shades',
    'custom-willow-french-door-w07-1-bamboo-shades',
    'custom-willow-gray-green-w07-2-top-down-bottom-up-bamboo-shades',
    'custom-willow-gray-green-w07-2-woven-bamboo-shades',
    'custom-willow-light-brown-w07-6-top-down-bottom-up-bamboo-shades',
    'custom-willow-light-brown-w07-6-woven-bamboo-shades',
    'custom-willow-marble-white-w07-9-top-down-bottom-up-bamboo-shades',
    'custom-willow-marble-white-w07-9-woven-bamboo-shades',
    'custom-willow-motorized-bamboo-shades-blinds',
    'custom-willow-oat-w07-8-top-down-bottom-up-bamboo-shades',
    'custom-willow-oat-w07-8-woven-bamboo-shades',
    'custom-willow-olive-w07-5-top-down-bottom-up-bamboo-shades',
    'custom-willow-olive-w07-5-woven-bamboo-shades',
    'custom-willow-sand-w07-10-top-down-bottom-up-bamboo-shades',
    'custom-willow-sand-w07-10-woven-bamboo-shades',
    'custom-willow-straw-w07-3-top-down-bottom-up-bamboo-shades',
    'custom-willow-straw-w07-3-woven-bamboo-shades',
    'custom-willow-wheat-w07-1-top-down-bottom-up-bamboo-shades',
    'custom-willow-wheat-w07-1-woven-bamboo-shades',
  ]);

  const bambooTdbuCrosslinks = {
    'custom-hazel-ashwood-pine-h11-8-woven-bamboo-shades': { handle: 'custom-hazel-ashwood-pine-h11-8-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=89e59fca39eaa76c28cf7dcf6f6b1984' },
    'custom-hazel-buttercream-h11-6-woven-bamboo-shades': { handle: 'custom-hazel-buttercream-h11-6-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=177db5fd9a30d2426195ab2ab0e2047d' },
    'custom-hazel-chestnut-h11-2-woven-bamboo-shades': { handle: 'custom-hazel-chestnut-h11-2-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=411ff345ebad1f7babaf957f66a9c6a9' },
    'custom-hazel-inkwell-oak-h11-10-woven-bamboo-shades': { handle: 'custom-hazel-inkwell-oak-h11-10-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=ac59cacda0aab62a63563087b88787ee' },
    'custom-hazel-misty-sage-h11-7-woven-bamboo-shades': { handle: 'custom-hazel-misty-sage-h11-7-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=7bc79fc90cbb10d6334139946a1762c7' },
    'custom-hazel-olive-ash-h11-9-woven-bamboo-shades': { handle: 'custom-hazel-olive-ash-h11-9-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=5b51e1cc9c95b9ee6b7f3faa23c5f197' },
    'custom-hazel-pale-almond-h11-4-woven-bamboo-shades': { handle: 'custom-hazel-pale-almond-h11-4-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=5704b360c290e1833826697090576659' },
    'custom-hazel-pale-wheat-h11-5-woven-bamboo-shades': { handle: 'custom-hazel-pale-wheat-h11-5-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=3445ff2126dcc3d66c29ef9a41c325ff' },
    'custom-hazel-pecan-h11-1-woven-bamboo-shades': { handle: 'custom-hazel-pecan-h11-1-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=96ba1782c453c4b666eb51c26a12cae0' },
    'custom-hazel-warm-beige-h11-3-woven-bamboo-shades': { handle: 'custom-hazel-warm-beige-h11-3-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=7ac53f25c69655d0fb51979e317583aa' },
    'custom-ivy-amber-dxp-03-woven-bamboo-shades': { handle: 'custom-ivy-amber-dxp-03-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=27c85e965abd6e5f2b80b506363d3e47' },
    'custom-ivy-backgammon-m-2023-woven-bamboo-shades': { handle: 'custom-ivy-backgammon-m-2023-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=5b1e808f8711a2f7a57bfda481a0795d' },
    'custom-ivy-black-brown-dzh-88-woven-bamboo-shades': { handle: 'custom-ivy-black-brown-dzh-88-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=d590739a44d7fc3e771078cc78a16b3c' },
    'custom-ivy-bone-white-dp60-01-woven-bamboo-shades': { handle: 'custom-ivy-bone-white-dp60-01-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=c489a64fc7fad24aac73904c406cf63b' },
    'custom-ivy-freckle-m-2002-woven-bamboo-shades': { handle: 'custom-ivy-freckle-m-2002-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=bba051f4d032d21c9d8369a2b6601df1' },
    'custom-ivy-marble-dc07-22-woven-bamboo-shades': { handle: 'custom-ivy-marble-dc07-22-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=081e0b6fd7a4f562688648345e2e0013' },
    'custom-ivy-mist-gray-103-22-woven-bamboo-shades': { handle: 'custom-ivy-mist-gray-103-22-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=768b53c50586a6c07b8a770363ddef20' },
    'custom-ivy-moss-dxs-09-woven-bamboo-shades': { handle: 'custom-ivy-moss-dxs-09-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=e9827710c892a373588258dff10877c3' },
    'custom-ivy-off-white-slr06-02-woven-bamboo-shades': { handle: 'custom-ivy-off-white-slr06-02-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=1d5360dbd677472b45469446cffbb5af' },
    'custom-ivy-olive-green-slju-22-woven-bamboo-shades': { handle: 'custom-ivy-olive-green-slju-22-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=74b81e0f0b6df5019fdd5d311eb82a90' },
    'custom-ivy-snow-dc01-01-woven-bamboo-shades': { handle: 'custom-ivy-snow-dc01-01-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=5259f5bb2d683afd8a042a96bfa7bb38' },
    'custom-ivy-tawny-103-21-woven-bamboo-shades': { handle: 'custom-ivy-tawny-103-21-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=feac4619b30dae92cd85b27b8ee18340' },
    'custom-natural-black-gold-nu-03-woven-bamboo-shades': { handle: 'custom-natural-black-gold-nu-03-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=f9624d5e2ad570a83256f20c7b04a5fe' },
    'custom-natural-black-gray-nu-04-woven-bamboo-shades': { handle: 'custom-natural-black-gray-nu-04-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=429c37520e1c3c4b63d73c41e342179e' },
    'custom-natural-caramel-stripes-nu-05-woven-bamboo-shades': { handle: 'custom-natural-caramel-stripes-nu-05-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=c427278058fc6b34f2a88f9385b9d1d9' },
    'custom-natural-coconut-white-nu-02-woven-bamboo-shades': { handle: 'custom-natural-coconut-white-nu-02-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=f9b9f6564730d5a04519274f38d85c80' },
    'custom-natural-enchanted-meadow-nu-06-woven-bamboo-shades': { handle: 'custom-natural-enchanted-meadow-nu-06-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=c91ac51ecd7cee4b43bf3dc7a4fab95c' },
    'custom-natural-ginkgo-nu-08-woven-bamboo-shades': { handle: 'custom-natural-ginkgo-nu-08-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=015b0132abf9d9475c726d1a42fd1dfa' },
    'custom-natural-grassland-nu-09-woven-bamboo-shades': { handle: 'custom-natural-grassland-nu-09-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=d289597ec0ff53f55586eb42e49e1a7c' },
    'custom-natural-oatmeal-yellow-nu-01-woven-bamboo-shades': { handle: 'custom-natural-oatmeal-yellow-nu-01-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=3f6d5859a353d116f5d6f5bb5440dc18' },
    'custom-natural-prairie-nu-07-woven-bamboo-shades': { handle: 'custom-natural-prairie-nu-07-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=e92ca92182b4083c8aeb7bd982b65fa6' },
    'custom-natural-sesame-gray-nu-10-woven-bamboo-shades': { handle: 'custom-natural-sesame-gray-nu-10-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=47dd172d51b4c4185f587deb5fee4bd4' },
    'custom-nomi-avocado-na1323-woven-bamboo-shades': { handle: 'custom-nomi-avocado-na1323-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=8892ae8c3f84faffff75b3f670e4ef85' },
    'custom-nomi-birch-forest-na0801-woven-bamboo-shades': { handle: 'custom-nomi-birch-forest-na0801-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=39e36b9cb6ce76e067fa99d7682236d7' },
    'custom-nomi-brown-na2003-woven-bamboo-shades': { handle: 'custom-nomi-brown-na2003-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=eccf737ebcaa31c7f65091de4829cee9' },
    'custom-nomi-butter-na0705-woven-bamboo-shades': { handle: 'custom-nomi-butter-na0705-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=2da7e74f114e21ee306210f1f3b18483' },
    'custom-nomi-cheese-na0201-woven-bamboo-shades': { handle: 'custom-nomi-cheese-na0201-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=c467be76f5a2a16c4d6e4a8a7fdaf8c9' },
    'custom-nomi-cobblestone-na5302-woven-bamboo-shades': { handle: 'custom-nomi-cobblestone-na5302-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=29f3758de7d0dc7dd825ffeda4c3f149' },
    'custom-nomi-coffee-na019-woven-bamboo-shades': { handle: 'custom-nomi-coffee-na019-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=752a76fbe45602db7a6d032636f418c6' },
    'custom-nomi-grayish-blue-na0822-woven-bamboo-shades': { handle: 'custom-nomi-grayish-blue-na0822-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=cf409e35e37af306f72d62dfc16d41c5' },
    'custom-nomi-hemp-grass-na0212-woven-bamboo-shades': { handle: 'custom-nomi-hemp-grass-na0212-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=7595cfc9cd2a9d63e13ff18f1ff75bf3' },
    'custom-nomi-light-brown-na0812-woven-bamboo-shades': { handle: 'custom-nomi-light-brown-na0812-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=444918426a3270df14d75c0d219419be' },
    'custom-nomi-sandstone-na002-woven-bamboo-shades': { handle: 'custom-nomi-sandstone-na002-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=19fcf53c8eba3fcfe2d58e5a242e90ab' },
    'custom-nomi-tree-bark-na1903-woven-bamboo-shades': { handle: 'custom-nomi-tree-bark-na1903-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=af41245e8696e2dde47575a9ef354412' },
    'custom-ramie-almond-e427-woven-bamboo-shades': { handle: 'custom-ramie-almond-e427-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=d2f3ff01da37a209765eb02652160f9d' },
    'custom-ramie-beige-390-woven-bamboo-shades': { handle: 'custom-ramie-beige-390-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=898d0b0350e676c107a86295bfbfda78' },
    'custom-ramie-beige-brown-dhz-01-woven-bamboo-shades': { handle: 'custom-ramie-beige-brown-dhz-01-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=3e0d452b3c9ecc7196e095fff9a6f699' },
    'custom-ramie-beige-white-390-02-woven-bamboo-shades': { handle: 'custom-ramie-beige-white-390-02-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=4c286f2de9422eda1526bf0e61c4e3a0' },
    'custom-ramie-cashew-d11-01-woven-bamboo-shades': { handle: 'custom-ramie-cashew-d11-01-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=f37b7c66846c25156ad86d21d29345f9' },
    'custom-ramie-cinnamon-0833n-woven-bamboo-shades': { handle: 'custom-ramie-cinnamon-0833n-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=a33e27817189d72f66e5858fb79f22cb' },
    'custom-ramie-coconut-ju-04-woven-bamboo-shades': { handle: 'custom-ramie-coconut-ju-04-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=9703a3aafba2f43c47adf4581ee4ab7d' },
    'custom-ramie-cream-d13-02-woven-bamboo-shades': { handle: 'custom-ramie-cream-d13-02-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=5888cea8880bd602207ec05e8dd14c55' },
    'custom-ramie-honeynut-d15-04-woven-bamboo-shades': { handle: 'custom-ramie-honeynut-d15-04-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=bb379e0ff35c9a2365c6d8dca0e642f6' },
    'custom-ramie-ivory-ju-01-woven-bamboo-shades': { handle: 'custom-ramie-ivory-ju-01-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=0701dd368b04c6760027afe5d0211867' },
    'custom-ramie-marble-white-dmc02-01-woven-bamboo-shades': { handle: 'custom-ramie-marble-white-dmc02-01-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=a07bc4131869049b84842df493f24a46' },
    'custom-ramie-reed-aluminum-headrail-rs408-1-bamboo-shades': { handle: 'custom-ramie-reed-top-down-bottom-up-alum-headrail-rs408-1-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=a879bec8ec963e74351d75599615ee55' },
    'custom-ramie-reed-wooden-headrail-rs408-1-bamboo-shades': { handle: 'custom-ramie-reed-top-down-bottom-up-wooden-headrail-rs408-1-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=b385cec0d9a8a99ae6b7eb8f022da2a1' },
    'custom-ramie-woven-9077k-woven-bamboo-shades': { handle: 'custom-ramie-woven-9077k-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=af4891c00e0faea5a63ea92f68314175' },
    'custom-willow-buff-w07-11-woven-bamboo-shades': { handle: 'custom-willow-buff-w07-11-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=58f3470c2bf3ac7b6cd952bf695911b0' },
    'custom-willow-cream-w07-7-woven-bamboo-shades': { handle: 'custom-willow-cream-w07-7-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=ea303be1e08fbb0cc205a8f47212086e' },
    'custom-willow-flax-w07-4-woven-bamboo-shades': { handle: 'custom-willow-flax-w07-4-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=a8d1e69cf3355570a5cf70a414eb0b02' },
    'custom-willow-gray-green-w07-2-woven-bamboo-shades': { handle: 'custom-willow-gray-green-w07-2-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=6693a7b617771b55892c56344d820b73' },
    'custom-willow-light-brown-w07-6-woven-bamboo-shades': { handle: 'custom-willow-light-brown-w07-6-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=898426feff583e9e789e9173102c6f97' },
    'custom-willow-marble-white-w07-9-woven-bamboo-shades': { handle: 'custom-willow-marble-white-w07-9-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=b4a2c179ef1d15c57809145e5cfc23eb' },
    'custom-willow-oat-w07-8-woven-bamboo-shades': { handle: 'custom-willow-oat-w07-8-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=6609ec88f40bfc68d82ae02f199500e0' },
    'custom-willow-olive-w07-5-woven-bamboo-shades': { handle: 'custom-willow-olive-w07-5-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=c69778c8591401b94c21bd18773bc165' },
    'custom-willow-sand-w07-10-woven-bamboo-shades': { handle: 'custom-willow-sand-w07-10-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=d7b4347a9fc23d7590bd87055f533826' },
    'custom-willow-straw-w07-3-woven-bamboo-shades': { handle: 'custom-willow-straw-w07-3-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=15b3f490e985f82b5803b118d5341381' },
    'custom-willow-wheat-w07-1-woven-bamboo-shades': { handle: 'custom-willow-wheat-w07-1-top-down-bottom-up-bamboo-shades', preview: 'https://9kggj04ksm50npen-70861750522.shopifypreview.com/products_preview?preview_key=b3515e85943835ef0765ccfb1ac4cebc' },
  };

  const isNeutralBambooUploadHandle = (value) => {
    const handle = String(value || '').trim();
    return /^custom-(?:hazel|ivy|natural|nomi|ramie|willow)-/i.test(handle)
      || /^(?:hazel|ivy|nomi|ramie|reed|willow)-bamboo-shade-sample-book$/i.test(handle);
  };

  const handleize = (value) => String(value || '')
    .toLowerCase()
    .replace(/[^a-z0-9]+/g, '-')
    .replace(/^-+|-+$/g, '');

  const uniqueKeys = (keys) => {
    const seen = new Set();
    return keys
      .map((key) => String(key || '').trim())
      .filter((key) => {
        if (!key || seen.has(key)) return false;
        seen.add(key);
        return true;
      });
  };

  const getColorCodeKeys = (value) => {
    const text = String(value || '');
    const keys = [];
    const matcher = /#?\b([a-z]{1,5}\d{2,5})(?:[-_\s]*(\d{1,2}))?\b/gi;
    let match = matcher.exec(text);
    while (match) {
      const family = String(match[1] || '').toUpperCase();
      const suffix = match[2] ? `-${Number(match[2])}` : '';
      const code = `${family}${suffix}`;
      keys.push(`#${code}`, code, code.toLowerCase(), handleize(code));
      match = matcher.exec(text);
    }
    return uniqueKeys(keys);
  };

  const cleanGeneratedColorKey = (value) => String(value || '')
    .replace(/[-_]+/g, ' ')
    .replace(/\s*\(\s*$/, '')
    .replace(/\s+/g, ' ')
    .trim();

  const getLabelKeyCandidates = (value) => {
    const text = String(value || '').trim();
    if (!text) return [];
    const withoutHash = text.replace(/^#/, '');
    const withoutColorCode = cleanGeneratedColorKey(text.replace(/\s*\([^)]*#?[a-z]{1,5}\d{2,5}[^)]*\)\s*$/i, ''));
    const keys = [
      text,
      text.toLowerCase(),
      handleize(text),
      withoutHash,
      withoutHash.toLowerCase(),
      handleize(withoutHash),
      withoutColorCode,
      withoutColorCode.toLowerCase(),
      handleize(withoutColorCode),
      ...getColorCodeKeys(text)
    ];
    return uniqueKeys(keys);
  };

  const findImageByLabel = (map, label) => {
    const candidates = getLabelKeyCandidates(label);
    for (const candidate of candidates) {
      const image = map.get(candidate);
      if (image) return image;
    }
    return '';
  };

  const isBrandedJ401SwatchMedia = (src) => {
    const value = String(src || '').toLowerCase();
    if (!value) return false;
    return value.includes('/fredesigner-')
      && value.includes('-j401-')
      && value.includes('.png');
  };

  const getVariantOptions = (variant) => {
    if (Array.isArray(variant.options)) return variant.options;
    return [variant.option1, variant.option2, variant.option3].filter(Boolean);
  };

  const formatMoney = (cents) => {
    if (window.theme && window.theme.Currency && typeof window.theme.Currency.formatMoney === 'function') {
      return window.theme.Currency.formatMoney(cents, window.theme.settings && window.theme.settings.moneyFormat);
    }
    if (window.Shopify && typeof window.Shopify.formatMoney === 'function') {
      return window.Shopify.formatMoney(cents);
    }
    return `$${(Number(cents || 0) / 100).toFixed(2)} USD`;
  };

  const resizeCloudfrontImageUrl = (src, width, allowUpsize) => {
    const value = String(src || '');
    if (!value || typeof window.atob !== 'function' || typeof window.btoa !== 'function') return '';

    try {
      const url = new URL(value, window.location.href);
      if (!url.hostname.includes('d17fzo7x83uajt.cloudfront.net')) return '';
      const payload = JSON.parse(window.atob(url.pathname.replace(/^\//, '')));
      payload.edits = payload.edits || {};
      payload.edits.resize = payload.edits.resize || {};
      payload.edits.resize.width = allowUpsize
        ? Math.max(Number(payload.edits.resize.width || 0), width)
        : width;
      return `${url.origin}/${window.btoa(JSON.stringify(payload))}`;
    } catch (error) {
      return '';
    }
  };

  const expandBcpoImageUrl = (src) => {
    const value = String(src || '');
    if (!value) return value;
    return resizeCloudfrontImageUrl(value, 1200, true) || value;
  };

  const getBcpoSwatchImageUrl = (src) => {
    if (window.__fdLegacyColorThumbnail) return window.__fdLegacyColorThumbnail(src, '', 260);
    const value = String(src || '');
    if (!value) return value;
    const imageSrc = resizeCloudfrontImageUrl(value, 260, false) || expandBcpoImageUrl(value);
    try {
      const url = new URL(imageSrc, window.location.href);
      const hostname = url.hostname.toLowerCase();
      const pathname = url.pathname.toLowerCase();
      const isShopifyFile = hostname === 'cdn.shopify.com'
        || hostname.includes('shopifycdn')
        || pathname.includes('/cdn/shop/files/');
      if (isShopifyFile && (pathname.includes('/files/') || pathname.includes('/cdn/shop/files/'))) {
        const currentWidth = Number(url.searchParams.get('width') || 0);
        if (!currentWidth || currentWidth > 260) url.searchParams.set('width', '260');
        return url.toString();
      }
    } catch (error) {
      return imageSrc;
    }
    return imageSrc;
  };

  const getImageFileName = (src) => {
    const value = expandBcpoImageUrl(src);
    if (!value) return '';
    try {
      const url = new URL(value, window.location.href);
      return decodeURIComponent(url.pathname.split('/').pop() || '').toLowerCase();
    } catch (error) {
      return String(value).split('?')[0].split('/').pop().toLowerCase();
    }
  };

  const addColorImageKey = (map, key, src, replaceExisting) => {
    const value = String(key || '').trim();
    if (!value || !src) return;
    const imageSrc = expandBcpoImageUrl(src);
    const withoutHash = value.replace(/^#/, '');
    const withoutStyleCode = withoutHash
      .replace(/^style#?\d+[-\s]*\d*\s*/i, '')
      .replace(/^[a-z]{1,5}\d{0,4}[-\s]*\d+\s*/i, '')
      .trim();
    const withoutColorSuffix = withoutStyleCode.replace(/\s+color$/i, '').trim();
    [value, value.toLowerCase(), handleize(value), withoutHash, withoutHash.toLowerCase(), handleize(withoutHash), withoutStyleCode, withoutStyleCode.toLowerCase(), handleize(withoutStyleCode), withoutColorSuffix, withoutColorSuffix.toLowerCase(), handleize(withoutColorSuffix), ...getColorCodeKeys(value)]
      .filter(Boolean)
      .forEach((item) => {
        if (replaceExisting || !map.has(item)) map.set(item, imageSrc);
      });
  };

  const getGeneratedMediaColorKey = (value) => {
    const text = String(value || '').trim();
    if (!text) return '';
    const altMatch = text.match(/\s-\s(.+?)\s+browser generated product photo/i);
    if (altMatch) return altMatch[1].trim();
    const optionAltMatch = text.match(/\bcolor option\s+(.+?)(?:\s+by\s+fredesigner\b|$)/i);
    if (optionAltMatch) return cleanGeneratedColorKey(optionAltMatch[1]);
    const colorCode = getColorCodeKeys(text)[0];
    if (colorCode) return colorCode;
    return text
      .replace(/-?browser-generated-product-photo$/i, '')
      .replace(/\s+browser generated product photo$/i, '')
      .trim();
  };

  products.forEach((root) => {
    const productHandle = String(root.dataset.productHandle || '').trim();
    const productId = String(root.dataset.productId || '').trim();
    const isHazelPecanRightRailPilot = productId === '9267953107194'
      && productHandle === 'custom-hazel-pecan-h11-1-woven-bamboo-shades';
    const isNeutralBambooStandardRightRailLayout = root.dataset.fdRightRailLayout === 'neutral-bamboo-standard-v1';
    const isNeutralBambooMotorizedRightRailLayout = root.dataset.fdRightRailLayout === 'neutral-bamboo-motorized-v1';
    const neutralBambooStandardRightRailUniques = Object.freeze([
      '_fd_bamboo_standard_color',
      '_fd_bamboo_standard_shade_style',
      '_fd_bamboo_standard_mount_type',
      '_fd_bamboo_standard_install_type',
      '_fd_bamboo_standard_width_inch',
      '_fd_bamboo_standard_width_eighths',
      '_fd_bamboo_standard_height_inch',
      '_fd_bamboo_standard_height_eighths',
      '_fd_bamboo_standard_guarantee_your_fit',
      '_fd_bamboo_standard_lift_style',
      '_fd_bamboo_standard_lining',
      '_fd_bamboo_standard_edge_binding',
      '_fd_bamboo_standard_warranty_options',
      '_fd_bamboo_standard_room_label'
    ]);
    const hasNeutralBambooStandardRightRailSignature = (bcpoRoot = root.querySelector('#bcpo')) => {
      if (!isNeutralBambooStandardRightRailLayout || !bcpoRoot || !root.contains(bcpoRoot)) return false;
      const uniques = Array.from(bcpoRoot.children)
        .filter((child) => child.matches?.('.selector-wrapper[data-unique]'))
        .map((child) => String(child.getAttribute('data-unique') || '').trim());
      return uniques.length === neutralBambooStandardRightRailUniques.length
        && neutralBambooStandardRightRailUniques.every((unique, index) => uniques[index] === unique);
    };
    const exactHandleProductMainImageMap = new Map();
    if (isHazelPecanRightRailPilot) {
      addColorImageKey(
        exactHandleProductMainImageMap,
        'Pecan H11-1',
        'https://cdn.shopify.com/s/files/1/0708/6175/0522/files/solenne-h11-1-standard.png',
        true
      );
    }
    const isNeutralBambooUploadedProduct = isNeutralBambooUploadHandle(productHandle);
    const isNeutralBambooBcpoColorBridgeProduct = /^(custom|fd)-(ivy|natural|willow|nomi|hazel|ramie)-/i.test(productHandle)
      && /(bamboo|woven|jute|hemp|ramie|reed|blind)/i.test(productHandle);
    if (isNeutralBambooBcpoColorBridgeProduct) {
      root.classList.add('fd-neutral-bamboo-color-bridge');
      document.body.classList.add('fd-neutral-bamboo-pdp-color-fix');
      if (!document.getElementById('fd-neutral-bamboo-offer-backdrop-fix')) {
        const offerBackdropStyle = document.createElement('style');
        offerBackdropStyle.id = 'fd-neutral-bamboo-offer-backdrop-fix';
        offerBackdropStyle.textContent = [
          'body.fd-neutral-bamboo-pdp-color-fix:not(.fd-offer-modal-open) #FdOfferModal,',
          'body.fd-neutral-bamboo-pdp-color-fix:not(.fd-offer-modal-open) #FdOfferModal .fd-offer-modal__backdrop {',
          '  pointer-events: none !important;',
          '}',
          'body.fd-neutral-bamboo-pdp-color-fix.fd-offer-modal-open #FdOfferModal,',
          'body.fd-neutral-bamboo-pdp-color-fix.fd-offer-modal-open #FdOfferModal .fd-offer-modal__backdrop {',
          '  pointer-events: auto;',
          '}'
        ].join('\n');
        document.head.appendChild(offerBackdropStyle);
      }
    }
    const preferBcpoColorImageAsMain = targetBcpoMainImageLinkHandles.has(productHandle);
    const forceBcpoColorImageAsMain = preferBcpoColorImageAsMain || isNeutralBambooBcpoColorBridgeProduct;
    const preserveInitialMainImageDuringColorSync = /^custom-ramie-reed-/i.test(productHandle);
    const forceTopGeneratedColorField = /^custom-(?:hazel|ivy|natural|nomi|ramie|willow)-/i.test(productHandle) || forceTopGeneratedColorFieldHandles.has(productHandle);
    const targetBcpoMainImageState = { src: '', alt: '', correcting: false };
    const neutralBambooColorBridgeState = { syncing: false };
    let suppressVariantImageForBcpoColor = false;
    let hasUserMainImageInteraction = false;
    let initialMainImageGuardStarted = false;
    const variantJson = root.querySelector('[data-fd-variants-json]');
    let variants = [];
    try {
      variants = JSON.parse(variantJson ? variantJson.textContent : '[]');
    } catch (error) {
      variants = [];
    }

    const form = root.querySelector('.fd-pdp-form');
    const variantInput = root.querySelector('[data-fd-variant-id]');
    const price = root.querySelector('[data-fd-price]');
    const stickyPrice = root.querySelector('[data-fd-sticky-price]');
    const comparePrice = root.querySelector('[data-fd-compare-price]');
    const atc = root.querySelector('[data-fd-atc]');
    const atcText = root.querySelector('[data-fd-atc-text]');
    const mainImage = root.querySelector('[data-fd-main-image]');
    const colorProperty = root.querySelector('[data-fd-color-property]');
    const thumbs = Array.from(root.querySelectorAll('[data-fd-thumb]'));
    const initialDefaultThumb = thumbs[0] || null;
    const quantityInput = root.querySelector('[data-fd-quantity]');
    const cordedBlocks = Array.from(root.querySelectorAll('[data-fd-corded-only]'));
    const selectedOptions = [];

    const normalizeTopCurtainHelper = () => {
      if (!/(curtain|drape|drapery|valance)/i.test(productHandle)) return;

      const existingTopLinks = root.querySelector('.fd-pdp__badges > .fd-pdp-top-links');
      if (existingTopLinks) {
        const offer = existingTopLinks.querySelector('.fd-pdp-top-links__offer') ||
          Array.from(existingTopLinks.querySelectorAll('span')).find((item) => /automatic\s+10%/i.test(item.textContent || ''));
        if (offer) {
          offer.classList.add('fd-pdp-top-links__offer');
          offer.style.setProperty('display', 'inline', 'important');
          offer.style.setProperty('font-style', 'normal', 'important');
        }
        return;
      }

      const helper = root.querySelector('.fd-pdp__badges > .fd-pdp-ad-helper');
      if (!helper) return;
      const helperText = helper.textContent || '';
      if (!/Order fabric samples/i.test(helperText) || !/Measure curtains/i.test(helperText)) return;

      const makeLink = (href, label) => {
        const link = document.createElement('a');
        link.href = href;
        link.textContent = label;
        return link;
      };
      const makeSeparator = () => {
        const separator = document.createElement('span');
        separator.setAttribute('aria-hidden', 'true');
        separator.textContent = '/';
        return separator;
      };
      const discount = document.createElement('i');
      discount.className = 'fd-pdp-top-links__offer';
      discount.textContent = 'Automatic 10% off';
      discount.style.setProperty('display', 'inline', 'important');
      discount.style.setProperty('font-style', 'normal', 'important');

      helper.className = 'fd-pdp-top-links';
      helper.replaceChildren(
        makeLink('/collections/linen-curtains-booklets', 'Order fabric samples'),
        makeSeparator(),
        makeLink('/pages/measuring-instruction-for-drapery-curtains', 'Measure curtains'),
        makeSeparator(),
        discount
      );
    };

    normalizeTopCurtainHelper();

    const installInlineGuideLinks = () => {
      const isCurtainGuideProduct = /(curtain|drape|drapery|valance)/i.test(productHandle);
      const isSampleBookProduct = /(sample-book|fabric-samples|gift-card)/i.test(productHandle);
      const isBambooGuideProduct = targetBambooGuideHandles.has(productHandle) && !isSampleBookProduct;
      if (!isCurtainGuideProduct && !isBambooGuideProduct) return;
      const hasStandardRightRailSignature = hasNeutralBambooStandardRightRailSignature();

      if (!document.getElementById('fd-inline-guide-pilot-style')) {
        const style = document.createElement('style');
        style.id = 'fd-inline-guide-pilot-style';
        style.textContent = `
          .fd-pdp[data-product-handle*="bamboo-shades"] .fd-pdp-order-helper,
          .fd-pdp[data-product-handle*="woven-bamboo"] .fd-pdp-order-helper,
          .fd-pdp[data-product-handle*="top-down-bottom-up-bamboo"] .fd-pdp-order-helper,
          .fd-pdp[data-product-handle*="bamboo-blinds"] .fd-pdp-order-helper,
          .fd-pdp[data-product-handle*="bamboo-shades"] .fd-pdp-ad-helper,
          .fd-pdp[data-product-handle*="woven-bamboo"] .fd-pdp-ad-helper,
          .fd-pdp[data-product-handle*="top-down-bottom-up-bamboo"] .fd-pdp-ad-helper,
          .fd-pdp[data-product-handle*="bamboo-blinds"] .fd-pdp-ad-helper,
          .fd-pdp[data-product-handle*="bamboo-shades"] .fd-pdp-top-links,
          .fd-pdp[data-product-handle*="woven-bamboo"] .fd-pdp-top-links,
          .fd-pdp[data-product-handle*="top-down-bottom-up-bamboo"] .fd-pdp-top-links,
          .fd-pdp[data-product-handle*="bamboo-blinds"] .fd-pdp-top-links,
          .fd-pdp[data-product-handle*="curtain"] .fd-pdp-order-helper,
          .fd-pdp[data-product-handle*="drape"] .fd-pdp-order-helper,
          .fd-pdp[data-product-handle*="drapery"] .fd-pdp-order-helper,
          .fd-pdp[data-product-handle*="valance"] .fd-pdp-order-helper { display: none !important; }
          .fd-pdp-inline-guide-row { display: block !important; margin: 26px 0 18px !important; padding: 0 !important; border: 0 !important; background: transparent !important; }
          .fd-pdp-inline-guide-row--header { margin-top: 24px !important; }
          .fd-pdp-inline-guide-row--bamboo-style { margin: 12px 0 12px !important; }
          .fd-pdp-inline-guide-row--bamboo-depth { margin: 18px 0 12px !important; }
          .fd-pdp-inline-guide-row--measurement { margin: 16px 0 12px !important; }
          .fd-pdp-inline-guide-link { color: #8a3a20 !important; font-size: 15px !important; font-weight: 500 !important; line-height: 1.45 !important; letter-spacing: 0 !important; text-decoration-line: underline !important; text-decoration-thickness: 1px !important; text-underline-offset: 4px !important; text-transform: none !important; }
          .fd-pdp-inline-guide-link:hover { color: #4f2f20 !important; text-decoration-thickness: 2px !important; }
          .fd-bcpo-color-title .fd-pdp-inline-guide-link { margin-left: 14px !important; }
          .fd-pdp-step-label .fd-pdp-inline-guide-link { margin-left: 18px !important; }
          body.fd-pdp-guide-modal-open { overflow: hidden; }
          .fd-pdp-guide-modal[hidden] { display: none !important; }
          .fd-pdp-guide-modal { position: fixed; inset: 0; z-index: 2147483000; display: flex; align-items: center; justify-content: center; padding: 24px; }
          .fd-pdp-guide-modal__backdrop { position: absolute; inset: 0; background: rgba(43, 34, 28, 0.46); }
          .fd-pdp-guide-modal__dialog { position: relative; width: min(720px, calc(100vw - 36px)); max-height: min(82vh, 760px); overflow: auto; background: #fffdf9; border: 1px solid #d8c8ba; box-shadow: 0 24px 70px rgba(43, 34, 28, 0.22); color: #2d211b; }
          .fd-pdp-guide-modal__close { position: absolute; top: 16px; right: 16px; width: 34px; height: 34px; border: 1px solid #d8c8ba; border-radius: 50%; background: #fffdf9; color: #4f2f20; font-size: 24px; line-height: 1; cursor: pointer; }
          .fd-pdp-guide-modal__inner { padding: 34px 38px 36px; }
          .fd-pdp-guide-modal__eyebrow { margin: 0 0 8px; color: #8a644d; font-size: 12px; letter-spacing: 0.08em; text-transform: uppercase; }
          .fd-pdp-guide-modal__title { margin: 0 44px 18px 0; color: #2d211b; font-size: 26px; line-height: 1.22; font-weight: 400; letter-spacing: 0; }
          .fd-pdp-guide-modal__body { display: grid; gap: 14px; color: #5b4a40; font-size: 15px; line-height: 1.65; }
          .fd-pdp-guide-modal__body p { margin: 0; }
          .fd-pdp-guide-modal__body h3,
          .fd-pdp-guide-modal__body h4 { margin: 8px 0 0; color: #2d211b; font-size: 18px; line-height: 1.35; font-weight: 400; letter-spacing: 0; }
          .fd-pdp-guide-modal__body h4 { font-size: 16px; color: #4f2f20; }
          .fd-pdp-guide-modal__body strong { color: #2d211b; font-weight: 500; }
          .fd-pdp-guide-modal__body a { color: #7b4e36; text-decoration: underline; text-underline-offset: 3px; }
          .fd-pdp-guide-modal__body img { display: block; width: min(100%, 460px); height: auto; margin: 6px 0 4px; border: 1px solid #eadfd5; background: #fff; }
          .fd-pdp-guide-modal__body img.fd-guide-image-loading { display: none !important; }
          .fd-pdp-guide-modal__body .fd-guide-panel { display: grid; gap: 10px; padding: 14px 0 2px; border-top: 1px solid #eadfd5; }
          .fd-pdp-guide-modal__body .fd-guide-note { color: #7e6a60; font-size: 14px; }
          .fd-pdp-guide-modal__body .fd-guide-formula { padding: 10px 12px; border-left: 3px solid #b8957f; background: #fbf7f1; color: #3f3028; }
          .fd-pdp-guide-modal__list { display: grid; gap: 10px; margin: 2px 0 0; padding: 0; list-style: none; }
          .fd-pdp-guide-modal__list li { position: relative; padding-left: 18px; }
          .fd-pdp-guide-modal__list li::before { content: ''; position: absolute; left: 0; top: 0.78em; width: 5px; height: 5px; border-radius: 50%; background: #b7947d; }
          .fd-pdp-guide-modal__actions { display: flex; flex-wrap: wrap; align-items: center; gap: 16px; margin-top: 24px; }
          .fd-pdp-guide-modal__actions[hidden] { display: none !important; }
          .fd-pdp-guide-modal__cta { display: inline-flex; align-items: center; justify-content: center; min-height: 42px; padding: 0 22px; border: 1px solid #5b3827; background: #5b3827; color: #fff !important; text-decoration: none; font-size: 13px; letter-spacing: 0.04em; text-transform: uppercase; }
          .fd-pdp-guide-modal__note { color: #8a7770; font-size: 13px; line-height: 1.5; }
          @media (max-width: 768px) {
            .fd-pdp-inline-guide-row { margin: 18px 0 16px !important; }
            .fd-bcpo-color-title .fd-pdp-inline-guide-link,
            .fd-pdp-step-label .fd-pdp-inline-guide-link { display: inline-block; margin-left: 0 !important; margin-top: 5px !important; }
            .fd-pdp-guide-modal { align-items: flex-end; padding: 14px; }
            .fd-pdp-guide-modal__dialog { width: 100%; max-height: 86vh; }
            .fd-pdp-guide-modal__inner { padding: 28px 22px 28px; }
            .fd-pdp-guide-modal__title { font-size: 22px; }
            .fd-pdp-guide-modal__actions { align-items: stretch; flex-direction: column; }
            .fd-pdp-guide-modal__cta { width: 100%; }
          }
        `;
        document.head.appendChild(style);
      }

      const guideModalContent = {
        samples: {
          eyebrow: 'Fabric samples',
          title: 'Shop Fabric',
          html: `
            <p><a href="/collections/linen-curtains-booklets">Click here to order Fabric Book &gt;</a></p>
            <h3>Why order fabric samples?</h3>
            <p>Fabric color, texture, opacity, and weight can look different from screen to room. Samples help you compare the real material beside your wall color, flooring, trim, and furniture before placing a custom order.</p>
            <p>Use a fabric book to review coordinated colors in natural light and evening light, then choose the best option for your window treatment.</p>
            <h3>OEKO-TEX Standard 100 &gt;</h3>
            <p class="fd-guide-note">Independent textile testing helps shoppers understand that fabrics are checked for commonly regulated harmful substances.</p>
            <img src="https://cdn.shopify.com/s/files/1/0863/4200/9130/files/2_ef63afbc-99cc-4f15-9b05-fdc7de9ac36f.jpg?v=1751535789" alt="OEKO-TEX Standard 100 textile certification reference">
          `
        },
        'bamboo-samples': {
          eyebrow: 'Material samples',
          title: 'Shop Bamboo Shade Samples',
          html: `
            <p><a href="/collections/roman-shades-booklets">Click here to order shade sample books &gt;</a></p>
            <h3>Why order samples?</h3>
            <p>Bamboo and woven shade materials can shift in tone under daylight, evening light, and different wall colors. A sample book lets you compare the real weave, texture, and opacity in the room before placing a custom order.</p>
            <p>Review samples beside your trim, flooring, and furniture, then choose the color that best matches the window treatment you want to build.</p>
          `
        },
        'bamboo-depth': {
          eyebrow: 'Mounting guide',
          title: 'Min. Window Depth & Headrail Size',
          html: `
            <p>Before choosing an inside mount, confirm that the window frame has enough flat mounting depth for the shade headrail. If the depth is limited, outside mount is usually the cleaner and more reliable choice.</p>
            <div class="fd-guide-panel">
              <h3>Inside mount</h3>
              <p>The shade sits inside the window frame for a built-in look. Measure the inside opening and make sure the frame depth can support the headrail and brackets.</p>
            </div>
            <div class="fd-guide-panel">
              <h3>Outside mount</h3>
              <p>The shade mounts above or outside the window frame. This option can cover more light gaps and is helpful when the window depth is not enough for inside mounting.</p>
            </div>
          `
        },
        'bamboo-measurement': {
          eyebrow: 'Measurement guide',
          title: 'Measurement Finder & Guide',
          html: `
            <p><a href="/pages/measuring-instruction-for-roman-shades-blinds">Measurement Finder &gt;</a></p>
            <h3>Inside mount</h3>
            <p>Measure the inside width at the top, middle, and bottom of the window opening. Use the narrowest width. Then measure the inside height at the left, center, and right, and use the tallest height.</p>
            <h3>Outside mount</h3>
            <p>Measure the area you want the shade to cover. Add extra width and height when possible to reduce side light gaps and create a fuller finished look.</p>
            <p class="fd-guide-note">Enter the exact custom size requested on the product page. Check every measurement before checkout.</p>
          `
        },
        'bamboo-lining': {
          eyebrow: 'Lining guide',
          title: 'Liner & Shading Rate',
          html: `
            <p><a href="/pages/instructions-about-the-liner">Click to know how to select liners</a></p>
            <p>Liners change privacy, light control, street-facing appearance, and the overall hand feel of the shade. Choose the level that matches the room and the amount of light you want to filter or block.</p>
            <div class="fd-guide-panel">
              <h3>Light filtering and privacy</h3>
              <p>Light filtering options keep a softer natural glow while adding privacy. They are useful for living rooms, dining rooms, and spaces where you still want daylight.</p>
            </div>
            <div class="fd-guide-panel">
              <h3>Room darkening and blackout</h3>
              <p>Darker liner options reduce stronger sunlight and improve privacy for bedrooms, media rooms, and street-facing windows.</p>
            </div>
          `
        },
        'header-styles': {
          eyebrow: 'Header styles',
          title: 'Hanging Header Style',
          html: `
            <p><a href="/pages/header-style">Click here to know more about Hanging Header Style</a></p>
          `
        },
        measurement: {
          eyebrow: 'Measurement guide',
          title: 'Measurement Guide',
          html: `
            <p><a href="/pages/measuring-instruction-for-drapery-curtains">Measurement Finder &gt;</a></p>
            <h3>Step 1: Measure the Width</h3>
            <p>If you have already installed the rod or track, measure the rod or track length and record the finished width.</p>
            <p>If the rod is not installed yet, decide where it will mount above and beyond the window frame. Most curtain rods sit 6-10 inches above the window frame and extend 6-15 inches past each side so the panels can stack neatly.</p>
            <img src="https://cdn.shopify.com/s/files/1/0863/4200/9130/files/c6d0b9e663c71dbf63c9842af7790f1.png?v=1733125694" alt="Curtain rod width measuring guide">
            <div class="fd-guide-panel">
              <h3>Step 2: Determine the Curtain Panel Width</h3>
              <p>For pleated headers such as Pinch Pleat, Tailor Pleat, Triple Tailor Pleat, Tape Pleat, Pinch Pleat with Back Tab, and French Pleat, calculate panel width from the rod or track width and desired fullness.</p>
              <p class="fd-guide-formula">Per Panel Width = Rod or track width x Pleat Fullness / Panel Quantity</p>
              <p>Common fullness choices: 1x, 1.5x, and 2x.</p>
            </div>
            <div class="fd-guide-panel">
              <h3>Step 3: Determine the Curtain Panel Length</h3>
              <p>For pleated curtains, measure from the curtain top position to the floor, then add the desired bottom finish. Choose the length style before entering custom sizes.</p>
            </div>
          `
        },
        lining: {
          eyebrow: 'Lining guide',
          title: 'Liner and shading rate',
          html: `
            <p><a href="/pages/instructions-about-the-liner">Click to Know How to Select Liners</a></p>
            <img src="https://cdn.shopify.com/s/files/1/0863/4200/9130/files/7hf8r4-_1_-ymq.png" alt="Curtain liner shading comparison">
            <h3>Recommended to You</h3>
            <div class="fd-guide-panel">
              <h4>Natural Lining</h4>
              <p><strong>Cotton 117 gsm:</strong> Made from 100% natural cotton. It keeps a soft, eco-friendly hand feel while offering about 70%-85% shading.</p>
              <p><strong>Belgian Flax 100%:</strong> Made from 100% European flax with a premium natural texture. It offers about 70%-80% shading and a sustainable feel.</p>
            </div>
            <div class="fd-guide-panel">
              <h4>Blackout Lining</h4>
              <p><strong>Premium Woven Blackout 350 gsm:</strong> An 80% polyester and 20% cotton blend that blocks over 90% of light through physical blackout construction, without chemical coating.</p>
              <img src="https://cdn.shopify.com/s/files/1/0863/4200/9130/files/1210p95-__17657682115587-ymq.png" alt="Premium woven blackout liner sample">
              <img src="https://cdn.shopify.com/s/files/1/0863/4200/9130/files/jnwjst-blackout_-ymq.webp" alt="Blackout curtain liner light control example">
              <p class="fd-guide-note"><strong>Attention:</strong> If a stitched shade or curtain style uses blackout lining, tiny stitch points may be visible in strong light. Choose the style and lining level that best matches your room needs.</p>
            </div>
          `
        }
      };

      const ensureGuideModal = () => {
        let modal = document.getElementById('fd-pdp-guide-modal');
        if (modal) return modal;

        modal = document.createElement('div');
        modal.id = 'fd-pdp-guide-modal';
        modal.className = 'fd-pdp-guide-modal';
        modal.hidden = true;
        modal.setAttribute('role', 'dialog');
        modal.setAttribute('aria-modal', 'true');
        modal.setAttribute('aria-hidden', 'true');
        modal.innerHTML = `
          <div class="fd-pdp-guide-modal__backdrop" data-fd-guide-close></div>
          <div class="fd-pdp-guide-modal__dialog" role="document">
            <button class="fd-pdp-guide-modal__close" type="button" aria-label="Close" data-fd-guide-close>&times;</button>
            <div class="fd-pdp-guide-modal__inner">
              <p class="fd-pdp-guide-modal__eyebrow"></p>
              <h2 class="fd-pdp-guide-modal__title"></h2>
              <div class="fd-pdp-guide-modal__body"></div>
              <div class="fd-pdp-guide-modal__actions">
                <a class="fd-pdp-guide-modal__cta"></a>
                <span class="fd-pdp-guide-modal__note"></span>
              </div>
            </div>
          </div>
        `;
        document.body.appendChild(modal);
        return modal;
      };

      const closeGuideModal = () => {
        const modal = document.getElementById('fd-pdp-guide-modal');
        if (!modal) return;
        modal.hidden = true;
        modal.setAttribute('aria-hidden', 'true');
        document.body.classList.remove('fd-pdp-guide-modal-open');
      };

      const openGuideModal = (key) => {
        const config = guideModalContent[key];
        if (!config) return false;

        const modal = ensureGuideModal();
        const body = modal.querySelector('.fd-pdp-guide-modal__body');
        if (config.html) {
          body.innerHTML = config.html;
          body.querySelectorAll('img').forEach((image) => {
            const revealImage = () => image.classList.remove('fd-guide-image-loading');
            const removeImage = () => image.remove();
            image.loading = 'eager';
            image.decoding = 'async';
            image.classList.add('fd-guide-image-loading');
            image.addEventListener('load', revealImage, { once: true });
            image.addEventListener('error', removeImage, { once: true });
            if (image.complete && image.naturalWidth > 0) revealImage();
          });
        } else {
          const list = document.createElement('ul');
          list.className = 'fd-pdp-guide-modal__list';
          (config.items || []).forEach((item) => {
            const li = document.createElement('li');
            li.textContent = item;
            list.appendChild(li);
          });

          body.replaceChildren(
            ...(config.body || []).map((copy) => {
              const paragraph = document.createElement('p');
              paragraph.textContent = copy;
              return paragraph;
            }),
            list
          );
        }
        modal.querySelector('.fd-pdp-guide-modal__eyebrow').textContent = config.eyebrow;
        modal.querySelector('.fd-pdp-guide-modal__title').textContent = config.title;
        const actions = modal.querySelector('.fd-pdp-guide-modal__actions');
        const cta = modal.querySelector('.fd-pdp-guide-modal__cta');
        const note = modal.querySelector('.fd-pdp-guide-modal__note');
        if (config.cta && config.href) {
          actions.hidden = false;
          cta.href = config.href;
          cta.textContent = config.cta;
          note.textContent = config.note || '';
        } else {
          actions.hidden = true;
          cta.removeAttribute('href');
          cta.textContent = '';
          note.textContent = '';
        }
        modal.hidden = false;
        modal.setAttribute('aria-hidden', 'false');
        document.body.classList.add('fd-pdp-guide-modal-open');
        window.setTimeout(() => modal.querySelector('.fd-pdp-guide-modal__close')?.focus(), 0);
        return true;
      };

      if (!document.documentElement.dataset.fdInlineGuideModalBound) {
        document.documentElement.dataset.fdInlineGuideModalBound = 'true';
        document.addEventListener('click', (event) => {
          const closeTarget = event.target.closest('[data-fd-guide-close]');
          if (closeTarget) {
            event.preventDefault();
            closeGuideModal();
            return;
          }

          const link = event.target.closest('[data-fd-inline-guide]');
          const guideKey = link && link.dataset ? link.dataset.fdInlineGuide : '';
          if (!guideKey) return;
          if (openGuideModal(guideKey)) {
            event.preventDefault();
          }
        });
        document.addEventListener('keydown', (event) => {
          if (event.key === 'Escape') closeGuideModal();
        });
      }

      root.querySelectorAll('.fd-pdp-order-helper').forEach((helper) => {
        helper.hidden = true;
        helper.style.setProperty('display', 'none', 'important');
      });

      const makeInlineLink = (href, label, key) => {
        const link = document.createElement('a');
        link.className = 'fd-pdp-inline-guide-link fd-pdp-inline-guide-link--generated';
        link.href = href;
        link.dataset.fdInlineGuide = key;
        link.setAttribute('aria-haspopup', 'dialog');
        link.textContent = label;
        return link;
      };

      const makeGuideRow = (modifier, href, label, key) => {
        const row = document.createElement('div');
        row.className = `fd-pdp-inline-guide-row fd-pdp-inline-guide-row--${modifier}`;
        row.append(makeInlineLink(href, label, key));
        return row;
      };

      const makePlainGuideRow = (modifier, href, label, key) => {
        const row = document.createElement('div');
        const link = document.createElement('a');
        row.className = `fd-pdp-inline-guide-row fd-pdp-inline-guide-row--${modifier}`;
        link.className = 'fd-pdp-inline-guide-link fd-pdp-inline-guide-link--generated';
        link.href = href;
        link.dataset.fdInlineGuideLink = key;
        link.textContent = label;
        row.append(link);
        return row;
      };

      const getBambooTdbuCrosslinkHref = () => {
        const entry = bambooTdbuCrosslinks[productHandle];
        if (!entry || !entry.handle) return '';
        if (/shopifypreview\.com$/i.test(window.location.hostname) && entry.preview) return entry.preview;
        return `/products/${entry.handle}`;
      };

      const findStepLegend = (pattern) => Array.from(root.querySelectorAll('legend.fd-pdp-step-label'))
        .find((item) => {
          const labelText = (item.querySelector('span')?.textContent || item.textContent || '').trim();
          return pattern.test(labelText);
        });

      const findBcpoWrapper = (pattern) => Array.from(root.querySelectorAll('#bcpo .selector-wrapper'))
        .find((item) => {
          const labelText = (item.querySelector('label, .bcpo-title')?.textContent || item.textContent || '').trim();
          return pattern.test(labelText);
        });

      const insertGuideBeforeLegend = (legend, modifier, href, label, key) => {
        if (!legend || root.querySelector(`.fd-pdp-inline-guide-link[data-fd-inline-guide="${key}"]`)) return;
        const fieldset = legend.closest('fieldset');
        if (!fieldset || !fieldset.parentNode) return;
        fieldset.parentNode.insertBefore(makeGuideRow(modifier, href, label, key), fieldset);
      };

      const insertPlainGuideAfterLegend = (legend, modifier, href, label, key) => {
        if (!legend || root.querySelector(`.fd-pdp-inline-guide-link[data-fd-inline-guide-link="${key}"]`)) return;
        const fieldset = legend.closest('fieldset');
        if (!fieldset || !fieldset.parentNode) return;
        fieldset.parentNode.insertBefore(makePlainGuideRow(modifier, href, label, key), fieldset.nextSibling);
      };

      const insertPlainGuideBeforeLegend = (legend, modifier, href, label, key) => {
        if (!legend || root.querySelector(`.fd-pdp-inline-guide-link[data-fd-inline-guide-link="${key}"]`)) return;
        const fieldset = legend.closest('fieldset');
        if (!fieldset || !fieldset.parentNode) return;
        fieldset.parentNode.insertBefore(makePlainGuideRow(modifier, href, label, key), fieldset);
      };

      const insertPlainGuideAfterBcpoWrapper = (wrapper, modifier, href, label, key) => {
        if (!wrapper || root.querySelector(`.fd-pdp-inline-guide-link[data-fd-inline-guide-link="${key}"]`)) return;
        if (!wrapper.parentNode) return;
        wrapper.parentNode.insertBefore(makePlainGuideRow(modifier, href, label, key), wrapper.nextSibling);
      };

      const insertPlainGuideBeforeBcpoWrapper = (wrapper, modifier, href, label, key) => {
        if (!wrapper || root.querySelector(`.fd-pdp-inline-guide-link[data-fd-inline-guide-link="${key}"]`)) return;
        if (!wrapper.parentNode) return;
        wrapper.parentNode.insertBefore(makePlainGuideRow(modifier, href, label, key), wrapper);
      };

      if (isBambooGuideProduct) {
        root.querySelectorAll('.fd-pdp-top-links').forEach((container) => {
          container.hidden = true;
          container.style.setProperty('display', 'none', 'important');
        });
      } else {
        root.querySelectorAll('.fd-pdp-top-links a').forEach((link) => {
          const href = link.getAttribute('href') || '';
          if (/linen-curtains-booklets/i.test(href)) {
            link.dataset.fdInlineGuide = 'samples';
            link.setAttribute('aria-haspopup', 'dialog');
            return;
          }
          if (/measuring-instruction-for-drapery-curtains/i.test(href)) {
            link.dataset.fdInlineGuide = 'measurement';
            link.setAttribute('aria-haspopup', 'dialog');
          }
        });
      }

      const colorTitle = root.querySelector('.fd-bcpo-color-title label, .fd-bcpo-color-title .bcpo-title, .fd-bcpo-color-title');
      if (isBambooGuideProduct && colorTitle && !colorTitle.querySelector('[data-fd-inline-guide="bamboo-samples"]')) {
        root.querySelectorAll('.fd-pdp-inline-guide-row--bamboo-samples').forEach((row) => row.remove());
        colorTitle.append(' ');
        colorTitle.append(makeInlineLink('/collections/roman-shades-booklets', 'Shop Bamboo Sample Books >', 'bamboo-samples'));
      } else if (isCurtainGuideProduct && colorTitle && !colorTitle.querySelector('[data-fd-inline-guide="samples"]')) {
        colorTitle.append(' ');
        colorTitle.append(makeInlineLink('/collections/linen-curtains-booklets', 'Order Fabric Samples >', 'samples'));
      }

      const headerWrapper = Array.from(root.querySelectorAll('#bcpo .selector-wrapper, .selector-wrapper.bcpo-simple'))
        .find((item) => /Hanging Header Style|Header Style/i.test(item.textContent || ''));
      if (headerWrapper && !root.querySelector('[data-fd-inline-guide="header-styles"]')) {
        headerWrapper.parentNode.insertBefore(makeGuideRow('header', '/pages/header-style', 'View Drapery Header Styles >', 'header-styles'), headerWrapper);
      }

      const customPanel = root.querySelector('.fd-pdp-custom');
      const firstCustomFieldset = customPanel?.querySelector('fieldset');
      if (isBambooGuideProduct && customPanel && !colorTitle && !root.querySelector('.fd-pdp-inline-guide-link[data-fd-inline-guide="bamboo-samples"]')) {
        if (firstCustomFieldset) {
          firstCustomFieldset.parentNode.insertBefore(makeGuideRow('bamboo-samples', '/collections/roman-shades-booklets', 'Shop Bamboo Sample Books >', 'bamboo-samples'), firstCustomFieldset);
        } else {
          customPanel.prepend(makeGuideRow('bamboo-samples', '/collections/roman-shades-booklets', 'Shop Bamboo Sample Books >', 'bamboo-samples'));
        }
      }

      const shadeStyleLegend = findStepLegend(/Shade Style/i);
      const bambooTdbuCrosslinkHref = isBambooGuideProduct ? getBambooTdbuCrosslinkHref() : '';
      if (isBambooGuideProduct && customPanel && bambooTdbuCrosslinkHref) {
        insertPlainGuideBeforeLegend(
          shadeStyleLegend,
          'bamboo-style',
          bambooTdbuCrosslinkHref,
          'Shop Top Down Bottom Up Bamboo Shade >',
          'bamboo-tdbu-crosslink'
        );
      }
      if (isBambooGuideProduct && bambooTdbuCrosslinkHref) {
        const shadeStyleWrapper = findBcpoWrapper(/Shade Style/i);
        if (hasStandardRightRailSignature) {
          insertPlainGuideAfterBcpoWrapper(
            shadeStyleWrapper,
            'bamboo-style',
            bambooTdbuCrosslinkHref,
            'Shop Top Down Bottom Up Bamboo Shade >',
            'bamboo-tdbu-crosslink'
          );
        } else {
          insertPlainGuideBeforeBcpoWrapper(
            shadeStyleWrapper,
            'bamboo-style',
            bambooTdbuCrosslinkHref,
            'Shop Top Down Bottom Up Bamboo Shade >',
            'bamboo-tdbu-crosslink'
          );
        }
      }
      if (isBambooGuideProduct && bambooTdbuCrosslinkHref && !root.querySelector('.fd-pdp-inline-guide-link[data-fd-inline-guide-link="bamboo-tdbu-crosslink"]')) {
        insertPlainGuideBeforeBcpoWrapper(
          findBcpoWrapper(/Mount Type|Installation Method/i),
          'bamboo-style',
          bambooTdbuCrosslinkHref,
          'Shop Top Down Bottom Up Bamboo Shade >',
          'bamboo-tdbu-crosslink'
        );
      }

      const installLegend = findStepLegend(/Installation Method|Mount Type/i);
      if (isBambooGuideProduct && customPanel) {
        insertGuideBeforeLegend(installLegend, 'bamboo-depth', '/pages/measuring-instruction-for-roman-shades-blinds', 'View Min. Window Depth & Headrail Size >', 'bamboo-depth');
      }

      const sizeLegend = findStepLegend(/^Size$|\bSize\b/i);
      if (customPanel && sizeLegend) {
        if (isBambooGuideProduct) {
          insertGuideBeforeLegend(sizeLegend, 'measurement', '/pages/measuring-instruction-for-roman-shades-blinds', 'Measurement Finder & Guide >', 'bamboo-measurement');
        } else if (isCurtainGuideProduct) {
          insertGuideBeforeLegend(sizeLegend, 'measurement', '/pages/measuring-instruction-for-drapery-curtains', 'Measurement Finder & Guide >', 'measurement');
        }
      }

      const liningLegend = findStepLegend(/Lining/i);
      const liningGuideKey = isBambooGuideProduct ? 'bamboo-lining' : 'lining';
      const hasExistingLiningGuide = hasStandardRightRailSignature
        ? root.querySelector(`[data-fd-inline-guide="${liningGuideKey}"]`)
        : liningLegend?.querySelector(`[data-fd-inline-guide="${liningGuideKey}"]`);
      if (liningLegend && !hasExistingLiningGuide) {
        const label = liningLegend.querySelector('span');
        if (label && /Lining and Edge Binding/i.test(label.textContent || '')) {
          label.textContent = 'Lining';
        }
        liningLegend.append(' ');
        liningLegend.append(isBambooGuideProduct
          ? makeInlineLink('/pages/instructions-about-the-liner', 'Liner & Shading Rate >', liningGuideKey)
          : makeInlineLink('/pages/instructions-about-the-liner', 'Liner & Shading Rate >', 'lining'));
      }

      if (hasStandardRightRailSignature) {
        const bcpoRoot = root.querySelector('#bcpo');
        const findExactWrapper = (unique) => bcpoRoot?.querySelector(`.selector-wrapper[data-unique="${unique}"]`) || null;
        const ensureGuideRow = (modifier, href, label, key) => {
          let row = root.querySelector(`[data-fd-inline-guide="${key}"]`)
            ?.closest(`.fd-pdp-inline-guide-row--${modifier}`);
          if (!row) row = makeGuideRow(modifier, href, label, key);
          return row;
        };

        const nativeLiningWrapper = findExactWrapper('_fd_bamboo_standard_lining');
        const nativeLiningTitle = nativeLiningWrapper?.querySelector('.bcpo-label');
        if (nativeLiningTitle) {
          let nativeLiningGuide = root.querySelector('[data-fd-inline-guide="bamboo-lining"]');
          if (!nativeLiningGuide) {
            nativeLiningGuide = makeInlineLink(
              '/pages/instructions-about-the-liner',
              'Liner & Shading Rate >',
              'bamboo-lining'
            );
          }
          if (nativeLiningGuide.parentNode !== nativeLiningTitle) {
            nativeLiningTitle.append(nativeLiningGuide);
          }
        }

        if (bcpoRoot) {
          const moveBefore = (node, anchor) => {
            if (!node || !anchor) return;
            if (node.parentNode === bcpoRoot && node.nextElementSibling === anchor) return;
            bcpoRoot.insertBefore(node, anchor);
          };
          const topDownGuide = root.querySelector('[data-fd-inline-guide-link="bamboo-tdbu-crosslink"]')
            ?.closest('.fd-pdp-inline-guide-row--bamboo-style');
          const depthGuide = ensureGuideRow(
            'bamboo-depth',
            '/pages/measuring-instruction-for-roman-shades-blinds',
            'View Min. Window Depth & Headrail Size >',
            'bamboo-depth'
          );
          const measurementGuide = ensureGuideRow(
            'measurement',
            '/pages/measuring-instruction-for-roman-shades-blinds',
            'Measurement Finder & Guide >',
            'bamboo-measurement'
          );
          moveBefore(topDownGuide, findExactWrapper('_fd_bamboo_standard_mount_type'));
          moveBefore(depthGuide, findExactWrapper('_fd_bamboo_standard_install_type'));
          moveBefore(measurementGuide, findExactWrapper('_fd_bamboo_standard_width_inch'));
        }
      }
    };

    // FD-CODEX-PDP-PERF-20260817: finite, scoped guide installation.
    [0, 150, 400, 900, 1800].forEach((delay) => {
      window.setTimeout(installInlineGuideLinks, delay);
    });
    const inlineGuideRoot = root.querySelector('#bcpo');
    if (inlineGuideRoot && window.MutationObserver) {
      let inlineGuideFrame = 0;
      const inlineGuideObserver = new MutationObserver(() => {
        if (inlineGuideFrame) return;
        inlineGuideFrame = window.requestAnimationFrame(() => {
          inlineGuideFrame = 0;
          installInlineGuideLinks();
        });
      });
      observeElement(inlineGuideObserver, inlineGuideRoot, { childList: true, subtree: true });
      window.setTimeout(() => inlineGuideObserver.disconnect(), 2600);
    }

    const installJennaBcpoPriceFallback = () => {
      const targetHandles = new Set([
        'custom-light-filtering-roman-shade',
        'custom-white-linen-plain-fold-roman-shade',
        'custom-textured-sheer-roman-shade'
      ]);
      const targetProductIds = new Set(['9238055649530', '9238055780602', '9238055059706']);
      const productHandle = String(root.dataset.productHandle || '').trim();
      const isTarget = () => {
        const data = window.bcpo_data || {};
        return targetHandles.has(productHandle) || targetProductIds.has(String(data.product_id || ''));
      };
      if (!isTarget()) return null;

      const normalizeOptionText = (value) => String(value || '')
        .replace(/\s+\|\s*[-+]?[$??]?\s*[\d,.]+.*$/i, '')
        .replace(/\s+/g, ' ')
        .trim()
        .toLowerCase();
      const parseAddonPrice = (value) => {
        const number = Number(String(value || '').replace(/[^-\d.]/g, ''));
        return Number.isFinite(number) ? number : 0;
      };
      const optionTitleFromControl = (control) => {
        const match = String(control && control.name ? control.name : '').match(/^properties\[(.+)\]$/);
        if (match) return match[1];
        const wrapper = control && control.closest ? control.closest('#bcpo .selector-wrapper') : null;
        const label = wrapper && (wrapper.querySelector('.bcpo-label, .bcpo-title, label') || wrapper);
        return label ? label.textContent : '';
      };
      const getBcpoOptions = () => {
        const data = window.bcpo_data || {};
        return Array.isArray(data.virtual_options) ? data.virtual_options : [];
      };
      const findBcpoValue = (title, value) => {
        const option = getBcpoOptions().find((item) => normalizeOptionText(item && item.title) === normalizeOptionText(title));
        if (!option || !Array.isArray(option.values)) return null;
        const wanted = normalizeOptionText(value);
        return option.values.find((item) => normalizeOptionText(item && item.key) === wanted) ||
          option.values.find((item) => normalizeOptionText(item && item.key).includes(wanted) || wanted.includes(normalizeOptionText(item && item.key))) ||
          null;
      };
      const getSelectedValue = (control) => {
        if (!control) return '';
        if (control.tagName === 'SELECT') {
          const selected = control.options && control.selectedIndex >= 0 ? control.options[control.selectedIndex] : null;
          return selected ? (selected.value || selected.textContent) : control.value;
        }
        return control.value;
      };
      const getSelectedControls = () => Array.from(document.querySelectorAll('#bcpo input:checked, #bcpo select, #bcpo textarea'))
        .filter((control) => !control.disabled && !control.closest('[hidden], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden, [aria-hidden="true"]'));
      const getBaseVariantPrice = () => {
        const currentId = variantInput ? String(variantInput.value || '') : '';
        const variant = variants.find((item) => String(item.id) === currentId) || variants[0] || {};
        return Number(variant.price || 0);
      };
      const getAddonTotalCents = () => getSelectedControls().reduce((sum, control) => {
        const match = findBcpoValue(optionTitleFromControl(control), getSelectedValue(control));
        const priceValue = parseAddonPrice(match && match.price);
        return sum + Math.round(priceValue * 100);
      }, 0);
      const updateDisplay = () => {
        const total = getBaseVariantPrice() + getAddonTotalCents();
        if (price) price.textContent = formatMoney(total);
        if (stickyPrice) stickyPrice.textContent = formatMoney(total);
      };
      const prepareProperties = () => {
        if (window.bcpo && window.bcpo.$) return;
        getSelectedControls().forEach((control) => {
          if (!control || control.tagName === 'TEXTAREA' || String(control.type || '').toLowerCase() === 'file') return;
          const match = findBcpoValue(optionTitleFromControl(control), getSelectedValue(control));
          const priceValue = parseAddonPrice(match && match.price);
          if (!priceValue) return;
          const baseValue = String(getSelectedValue(control) || '').replace(/\s+\|\s*[-+]?[$??]?\s*[\d,.]+.*$/i, '').trim();
          const suffixedValue = `${baseValue} | $${priceValue.toFixed(2)}`;
          if (control.tagName === 'SELECT') {
            const selected = control.options && control.selectedIndex >= 0 ? control.options[control.selectedIndex] : null;
            if (selected) selected.value = suffixedValue;
          } else {
            control.value = suffixedValue;
          }
        });
      };

      if (form) form.addEventListener('submit', prepareProperties, true);
      root.addEventListener('click', (event) => {
        const target = event.target && event.target.closest ? event.target : null;
        if (target && target.closest('[data-fd-atc], [data-fd-sticky-submit]')) prepareProperties();
        window.setTimeout(updateDisplay, 40);
      }, true);
      root.addEventListener('change', () => window.setTimeout(updateDisplay, 40), true);
      root.addEventListener('input', () => window.setTimeout(updateDisplay, 40), true);
      window.setTimeout(updateDisplay, 800);
      window.setTimeout(updateDisplay, 1800);
      return { updateDisplay, prepareProperties };
    };

    const jennaBcpoPriceFallback = installJennaBcpoPriceFallback();

    root.querySelectorAll('[data-fd-option-position]').forEach((group) => {
      const position = Number(group.dataset.fdOptionPosition || '1') - 1;
      const selected = group.querySelector('[data-fd-option-value].is-selected') || group.querySelector('[data-fd-option-value]');
      selectedOptions[position] = selected ? selected.dataset.optionValue : '';
    });

    const colorImageMap = new Map();
    const productColorImageMap = new Map();
    thumbs.forEach((thumb) => {
      if (isBrandedJ401SwatchMedia(thumb.dataset.full)) return;
      addColorImageKey(productColorImageMap, thumb.dataset.alt, thumb.dataset.full);
      addColorImageKey(productColorImageMap, getGeneratedMediaColorKey(thumb.dataset.alt), thumb.dataset.full, true);
      addColorImageKey(productColorImageMap, getGeneratedMediaColorKey(thumb.dataset.group), thumb.dataset.full, true);
    });

    const refreshThemeColorImages = () => {
      const themeMapJson = root.querySelector('[data-fd-theme-color-images]');
      if (!themeMapJson) return;
      let themeMap = {};
      try {
        themeMap = JSON.parse(themeMapJson.textContent || '{}');
      } catch (error) {
        themeMap = {};
      }

      Object.keys(themeMap).forEach((key) => {
        addColorImageKey(colorImageMap, key, themeMap[key], true);
      });

      if (isNeutralBambooStandardRightRailLayout) {
        const seriesMatch = productHandle.match(/^custom-(hazel|ivy|natural|nomi|ramie|willow)-/i);
        const seriesKey = seriesMatch ? seriesMatch[1].toLowerCase() : '';
        const sharedAssets = neutralBambooStandardSwatchAssetFilenames[seriesKey];
        const firstExactAsset = Object.values(themeMap).find((src) => String(src || '').includes('fd-own-material_closeup-'));
        if (sharedAssets && firstExactAsset) {
          try {
            const exactAssetUrl = new URL(expandBcpoImageUrl(firstExactAsset), window.location.href);
            const assetDirectory = `${exactAssetUrl.origin}${exactAssetUrl.pathname.slice(0, exactAssetUrl.pathname.lastIndexOf('/') + 1)}`;
            Object.keys(sharedAssets).forEach((key) => {
              addColorImageKey(colorImageMap, key, `${assetDirectory}${sharedAssets[key]}`, true);
            });
          } catch (error) {
            // Keep the exact per-product map and native BCPO images if the theme asset URL cannot be resolved.
          }
        }
      }
    };

    const refreshBcpoColorImages = () => {
      const sources = [];
      const bcpoData = window.__fdLegacyColorThumbnail ? (window.__fdVoFullData || window.bcpo_data) : window.bcpo_data;
      const bcpoProduct = window.bcpo_product;
      if (bcpoData && Array.isArray(bcpoData.virtual_options)) sources.push(bcpoData.virtual_options);
      if (bcpoProduct && Array.isArray(bcpoProduct.options)) sources.push(bcpoProduct.options);

      sources.forEach((options) => {
        options.forEach((option) => {
          const title = String(option && option.title ? option.title : '').toLowerCase();
          const type = String(option && option.type ? option.type : '').toLowerCase();
          if (type !== 'images' || !title.includes('color') || !Array.isArray(option.values)) return;
          option.values.forEach((item) => addColorImageKey(colorImageMap, item && item.key, item && item.value));
        });
      });
    };

    refreshBcpoColorImages();
    refreshThemeColorImages();

    const getBcpoColorOptionIndexes = () => {
      const indexes = new Set();
      const sources = [];
      const bcpoData = window.bcpo_data;
      const bcpoProduct = window.bcpo_product;
      if (bcpoData && Array.isArray(bcpoData.virtual_options)) sources.push(bcpoData.virtual_options);
      if (bcpoProduct && Array.isArray(bcpoProduct.options)) sources.push(bcpoProduct.options);

      sources.forEach((options) => {
        options.forEach((option, index) => {
          const title = String(option && option.title ? option.title : '').toLowerCase();
          const type = String(option && option.type ? option.type : '').toLowerCase();
          if (type === 'images' && (title.includes('color') || title.includes('colour') || title.includes('fabric'))) {
            indexes.add(index);
          }
        });
      });

      return indexes;
    };

    const getColorImage = (label) => {
      refreshBcpoColorImages();
      refreshThemeColorImages();
      return findImageByLabel(colorImageMap, label);
    };

    const getProductColorImage = (label) => {
      return findImageByLabel(productColorImageMap, label);
    };

    const neutralBambooProductMainImageMap = (window.fdNeutralBambooProductMainImageMap && typeof window.fdNeutralBambooProductMainImageMap === 'object')
      ? window.fdNeutralBambooProductMainImageMap
      : {};

    const verifiedBedroomPanelMainImageUrls = new Set((window.fdTwoThreeBedroomVerifiedUrls20261002 || {})[productHandle] || []);
    const ownSceneColorImageNames = new Set((window.fdOwnSceneColorImages20261015 || []).map((name) => String(name).toLowerCase()));

    const isNeutralBambooProductMainImage = (src) => {
      const value = String(src || '').toLowerCase();
      const isVerifiedHazelPecanStandardMain = value.includes('neutral_verified_seq020_seq020_hazel_pecan_h11-1_final_direct_edit.png');
      const isOwnSceneColorImage = ownSceneColorImageNames.has(value.split('?')[0].split('/').pop());
      return Boolean(value)
        && (value.includes('_main_') || isVerifiedHazelPecanStandardMain || isOwnSceneColorImage || verifiedBedroomPanelMainImageUrls.has(String(src || '')))
        && !value.includes('material_closeup')
        && !value.includes('/cm');
    };

    const findNeutralBambooImageInObject = (map, label) => {
      if (!map || typeof map !== 'object') return '';
      const candidates = getLabelKeyCandidates(label);
      for (const candidate of candidates) {
        const image = map[candidate];
        if (isNeutralBambooProductMainImage(image)) return image;
      }
      return '';
    };

    const getNeutralBambooSeriesKey = () => {
      const match = productHandle.match(/^custom-(ramie-reed|hazel|ivy|natural|nomi|ramie|willow)-/i);
      return match ? match[1].toLowerCase() : '';
    };

    const getNeutralBambooStyleKey = () => {
      const handle = productHandle.toLowerCase();
      if (handle.startsWith('custom-ramie-reed-top-down-bottom-up-alum-headrail')) return 'top-down-bottom-up-alum';
      if (handle.startsWith('custom-ramie-reed-top-down-bottom-up-wooden-headrail')) return 'top-down-bottom-up-wooden';
      if (handle.startsWith('custom-ramie-reed-wooden-headrail')) return 'standard-wooden';
      if (handle.startsWith('custom-ramie-reed-aluminum-headrail')) return 'standard';
      if (handle.includes('2-shades-on-1-headrail') || handle.includes('2-on-1-headrail')) return '2-on-1-headrail';
      if (handle.includes('3-shades-on-1-headrail') || handle.includes('3-on-1-headrail')) return '3-on-1-headrail';
      if (handle.includes('french-door')) return 'french-door';
      if (handle.includes('motorized')) return 'motorized';
      if (handle.includes('top-down-bottom-up') || handle.includes('tdbu') || handle.includes('alum-headrail') || handle.includes('wooden-headrail')) return 'top-down-bottom-up';
      return 'standard';
    };

    const getHazelAshwoodPineColorfixImage = (src) => {
      if (getNeutralBambooSeriesKey() !== 'hazel') return '';
      const value = String(src || '').toLowerCase();
      if (!value.includes('h11-8') || !value.includes('ashwood-pine') || !value.includes('_main_')) return '';
      const hazelMap = neutralBambooProductMainImageMap.hazel;
      return findNeutralBambooImageInObject(
        hazelMap && hazelMap[getNeutralBambooStyleKey()],
        'Ashwood Pine H11-8'
      );
    };

    const getNeutralBambooProductMainImage = (label) => {
      if (!isNeutralBambooBcpoColorBridgeProduct) return '';
      const exactHandleProductMainImage = findImageByLabel(exactHandleProductMainImageMap, label);
      if (exactHandleProductMainImage) return exactHandleProductMainImage;
      const seriesMap = neutralBambooProductMainImageMap[getNeutralBambooSeriesKey()];
      if (!seriesMap || typeof seriesMap !== 'object') return '';
      const currentStyle = getNeutralBambooStyleKey();
      const styleKeys = uniqueKeys([currentStyle]);
      for (const styleKey of styleKeys) {
        const styleImage = findNeutralBambooImageInObject(seriesMap[styleKey], label);
        if (styleImage) return styleImage;
      }
      const localProductImage = getProductColorImage(label);
      return isNeutralBambooProductMainImage(localProductImage) ? localProductImage : '';
    };

    const getNeutralBambooColorDisplayImage = (label) => {
      if (!isNeutralBambooBcpoColorBridgeProduct) return '';
      const swatchImage = getColorImage(label);
      if (isNeutralBambooMaterialSwatchImage(swatchImage, label)) return swatchImage;
      return getNeutralBambooProductMainImage(label);
    };

    const isNeutralBambooMaterialSwatchImage = (src, alt = '') => {
      if (!isNeutralBambooBcpoColorBridgeProduct) return false;
      const value = `${src || ''} ${alt || ''}`.toLowerCase();
      return value.includes('material_closeup')
        || value.includes('material swatch')
        || /(^|[\/_-])cm\d{2,}/i.test(value);
    };

    const isSuppressedNeutralBambooGalleryThumb = (thumb) => (
      Boolean(thumb && isNeutralBambooMaterialSwatchImage(thumb.dataset.full, thumb.dataset.alt))
    );

    const getCssBackgroundUrl = (element) => {
      if (!element || !window.getComputedStyle) return '';
      const background = window.getComputedStyle(element).backgroundImage || '';
      const match = background.match(/url\(["']?([^"')]+)["']?\)/);
      return match ? match[1] : '';
    };

    const isSceneColorSwatchImage = (src) => {
      const value = String(src || '').toLowerCase();
      return value.includes('roman-shade-color-')
        || value.includes('custom-roman-shade-color')
        || value.includes('relaxed-custom-roman-shade-color')
        || value.includes('cafe-curtain')
        || value.includes('cafe-style');
    };

    const canUseSwatchImageAsMain = (src) => {
      const value = String(src || '').toLowerCase();
      if (!value || value.includes('d17fzo7x83uajt.cloudfront.net')) return false;
      return isSceneColorSwatchImage(value);
    };

    const isBcpoColorTitle = (value) => {
      const title = String(value || '').toLowerCase();
      return title.includes('color') || title.includes('colour') || title.includes('fabric');
    };

    const getBcpoWrapperTitle = (wrapper) => {
      if (!wrapper) return '';
      const titleLabel = wrapper.querySelector('.bcpo-title, .bcpo-label label') || Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL');
      return titleLabel ? titleLabel.textContent : (wrapper.getAttribute('data-title') || wrapper.getAttribute('aria-label') || '');
    };

    const getBcpoWrapperIndex = (wrapper) => {
      const dataOption = wrapper ? (wrapper.getAttribute('data-option') || '') : '';
      const dataOptionMatch = dataOption.match(/^option(\d+)$/);
      return dataOptionMatch ? Number(dataOptionMatch[1]) - 1 : -1;
    };

    const isBcpoColorWrapper = (wrapper, colorIndexes) => {
      if (!wrapper) return false;
      if (isBcpoColorTitle(getBcpoWrapperTitle(wrapper))) return true;
      if (isColorInputName(wrapper.querySelector('input, select'))) return true;
      const index = getBcpoWrapperIndex(wrapper);
      return index >= 0 && colorIndexes.has(index);
    };

    const applyBcpoChoiceImage = (element, src) => {
      if (!element || !src) return;
      const fullImageSrc = expandBcpoImageUrl(src);
      const imageSrc = getBcpoSwatchImageUrl(src);
      const useSceneCrop = isSceneColorSwatchImage(fullImageSrc);
      const useFabricOnlyCrop = !useSceneCrop
        && fullImageSrc.toLowerCase().includes('fredesigner-')
        && fullImageSrc.toLowerCase().includes('j401-');
      const useGeneratedProductColorImage = isNeutralBambooBcpoColorBridgeProduct
        && isNeutralBambooProductMainImage(fullImageSrc);
      element.style.backgroundImage = `url("${imageSrc.replace(/"/g, '\\"')}")`;
      element.style.backgroundRepeat = 'no-repeat';
      const backgroundPosition = useSceneCrop ? '50% 35%' : (useFabricOnlyCrop ? '50% 14%' : 'center');
      const backgroundSize = useSceneCrop ? '260% 260%' : (useFabricOnlyCrop ? '180% 180%' : 'cover');
      if (element.style.setProperty) {
        element.style.setProperty('background-position', backgroundPosition, 'important');
        element.style.setProperty('background-size', backgroundSize, 'important');
      } else {
        element.style.backgroundPosition = backgroundPosition;
        element.style.backgroundSize = backgroundSize;
      }
      element.classList.toggle('fd-bcpo-scene-color-label', useSceneCrop);
      element.classList.toggle('fd-bcpo-fabric-only-color-label', useFabricOnlyCrop);
      element.classList.toggle('fd-bcpo-product-main-color-label', useGeneratedProductColorImage);
      const parent = element.closest && element.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent');
      if (parent) parent.classList.toggle('fd-bcpo-scene-color-choice', useSceneCrop);
      if (parent) parent.classList.toggle('fd-bcpo-fabric-only-color-choice', useFabricOnlyCrop);
      if (parent) parent.classList.toggle('fd-bcpo-product-main-color-choice', useGeneratedProductColorImage);
    };

    root.querySelectorAll('[data-fd-media-swatch]').forEach((swatch) => {
      if (swatch.dataset.image) return;
      const swatchImage = getColorImage(swatch.dataset.label || swatch.dataset.alt);
      if (swatchImage) swatch.dataset.image = swatchImage;
    });

    const setMainImage = (src, alt) => {
      if (!mainImage || !src) return;
      const normalizedSrc = expandBcpoImageUrl(src);
      // Preserve the browser-selected responsive hero when initialization selects the same asset.
      // Exact audited products only; color changes and gallery navigation still use the original path.
      const preserveResponsiveHero20260914 = true // theme-id gate removed 10-27 (owner): any copy of this theme behaves like live
        && ((productId === '9267998163194' && productHandle === 'custom-nomi-motorized-bamboo-shades-blinds')
          || (productId === '9267975487738' && productHandle === 'custom-nomi-sandstone-na002-top-down-bottom-up-bamboo-shades'));
      if (preserveResponsiveHero20260914 && mainImage.hasAttribute('srcset')) {
        try {
          const current = new URL(mainImage.currentSrc || mainImage.src, location.href);
          const next = new URL(normalizedSrc, location.href);
          if (current.pathname.includes('/cdn/shop/files/')) {
            current.searchParams.delete('width'); next.searchParams.delete('width');
            if (current.href === next.href) {
              if (alt) mainImage.alt = alt;
              return;
            }
          }
        } catch (_) {}
      }
      if (mainImage.getAttribute('src') === normalizedSrc) return;
      mainImage.style.opacity = '0';
      mainImage.src = normalizedSrc;
      mainImage.removeAttribute('srcset');
      if (alt) mainImage.alt = alt;
      window.setTimeout(() => {
        mainImage.style.opacity = '';
      }, 80);
    };

    const applyHazelAshwoodPineColorfixToMedia = () => {
      if (!isNeutralBambooBcpoColorBridgeProduct || getNeutralBambooSeriesKey() !== 'hazel') return;
      document.querySelectorAll('img').forEach((image) => {
        const replacement = [
          image.currentSrc,
          image.src,
          image.getAttribute('src'),
          image.getAttribute('srcset'),
          image.dataset ? image.dataset.src : '',
          image.dataset ? image.dataset.srcset : ''
        ].map(getHazelAshwoodPineColorfixImage).find(Boolean);
        if (!replacement) return;
        image.src = replacement;
        image.removeAttribute('srcset');
        if (image.dataset) {
          image.dataset.src = replacement;
          image.dataset.srcset = replacement;
          image.dataset.full = replacement;
        }
      });
      document.querySelectorAll('[data-fd-thumb]').forEach((thumb) => {
        const replacement = getHazelAshwoodPineColorfixImage(thumb.dataset.full);
        if (!replacement) return;
        thumb.dataset.full = replacement;
        const thumbImage = thumb.querySelector('img');
        if (thumbImage) {
          thumbImage.src = replacement;
          thumbImage.removeAttribute('srcset');
        }
      });
    };

    const clearTargetBcpoMainImage = () => {
      if (!forceBcpoColorImageAsMain) return;
      targetBcpoMainImageState.src = '';
      targetBcpoMainImageState.alt = '';
    };

    const enforceTargetBcpoMainImage = () => {
      if (!forceBcpoColorImageAsMain || !mainImage || !targetBcpoMainImageState.src || targetBcpoMainImageState.correcting) return;
      const currentFile = getImageFileName(mainImage.getAttribute('src') || mainImage.currentSrc || mainImage.src);
      const targetFile = getImageFileName(targetBcpoMainImageState.src);
      if (!targetFile || currentFile === targetFile) return;
      targetBcpoMainImageState.correcting = true;
      setMainImage(targetBcpoMainImageState.src, targetBcpoMainImageState.alt);
      window.setTimeout(() => {
        targetBcpoMainImageState.correcting = false;
      }, 0);
    };

    const activateThumb = (thumb) => {
      thumbs.forEach((item) => item.classList.toggle('is-active', item === thumb));
      if (thumb) setMainImage(getHazelAshwoodPineColorfixImage(thumb.dataset.full) || thumb.dataset.full, thumb.dataset.alt);
    };

    const markUserMainImageInteraction = () => {
      hasUserMainImageInteraction = true;
    };

    const isDirectUserClick = (event) => Boolean(event && event.isTrusted && event.detail > 0);

    const restoreInitialActiveThumbImage = () => {
      if (!preserveInitialMainImageDuringColorSync || hasUserMainImageInteraction || root.dataset.fdUserSelectedBcpoColor || !mainImage) return false;
      const activeThumb = initialDefaultThumb || thumbs.find((thumb) => thumb.classList.contains('is-active')) || thumbs[0];
      if (!activeThumb || !activeThumb.dataset.full) return false;
      const currentFile = getImageFileName(mainImage.getAttribute('src') || mainImage.currentSrc || mainImage.src);
      const targetFile = getImageFileName(activeThumb.dataset.full);
      if (!targetFile || currentFile === targetFile) return false;
      thumbs.forEach((thumb) => thumb.classList.toggle('is-active', thumb === activeThumb));
      setMainImage(activeThumb.dataset.full, activeThumb.dataset.alt);
      return true;
    };

    const scheduleInitialActiveThumbRestore = () => {
      if (!preserveInitialMainImageDuringColorSync || hasUserMainImageInteraction || root.dataset.fdUserSelectedBcpoColor) return;
      if (isNeutralBambooStandardRightRailLayout && initialMainImageGuardStarted) return;
      [0, 80, 260, 800, 1600].forEach((delay) => {
        window.setTimeout(restoreInitialActiveThumbImage, delay);
      });
      if (initialMainImageGuardStarted) return;
      initialMainImageGuardStarted = true;
      const startedAt = Date.now();
      const guardTick = () => {
        if (!preserveInitialMainImageDuringColorSync || hasUserMainImageInteraction) return;
        restoreInitialActiveThumbImage();
        if (Date.now() - startedAt < 9000) {
          window.setTimeout(guardTick, 300);
        }
      };
      guardTick();
    };

    const updateCordedControls = (value) => {
      const isCorded = String(value || '').trim().toLowerCase() === 'corded';
      cordedBlocks.forEach((block) => {
        const shouldShow = isCorded && block.dataset.fdVoUnavailable !== 'true';
        block.hidden = !shouldShow;
        block.querySelectorAll('[data-fd-vo-sync]').forEach((control) => {
          control.disabled = !shouldShow;
        });
      });
      refreshTemplateStepNumbers();
    };

    const updateQuantity = (direction) => {
      if (!quantityInput) return;
      const current = Math.max(Number(quantityInput.value || 1), 1);
      const next = direction === 'plus' ? current + 1 : Math.max(current - 1, 1);
      quantityInput.value = String(next);
      quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
    };

    const groupMatchesValue = (group, handle) => {
      if (!group || group === 'all') return false;
      return group === handle || group === `color-${handle}` || group.endsWith(`-${handle}`) || group.includes(handle);
    };

    const revealDefaultGallery = () => {
      const seeMore = root.querySelector('[data-fd-see-more]');
      const expanded = Boolean(seeMore && seeMore.hidden);
      thumbs.forEach((thumb) => {
        thumb.hidden = isSuppressedNeutralBambooGalleryThumb(thumb)
          || (!expanded && thumb.classList.contains('is-extra'));
      });
    };

    const updateGalleryGroup = (handle, fallbackImage) => {
      if (!handle) return;
      const matchingThumbs = thumbs.filter((thumb) => (
        !isSuppressedNeutralBambooGalleryThumb(thumb) && groupMatchesValue(thumb.dataset.group, handle)
      ));

      if (matchingThumbs.length < 2) {
        revealDefaultGallery();
        if (fallbackImage) setMainImage(fallbackImage);
        return;
      }

      let firstVisible = null;
      thumbs.forEach((thumb) => {
        const visible = !isSuppressedNeutralBambooGalleryThumb(thumb) && groupMatchesValue(thumb.dataset.group, handle);
        thumb.hidden = !visible;
        if (visible && !firstVisible) firstVisible = thumb;
      });

      activateThumb(firstVisible);
    };

    const findSelectedVariant = () => {
      return variants.find((variant) => {
        const options = getVariantOptions(variant);
        return selectedOptions.every((value, index) => !value || options[index] === value);
      });
    };

    const updateVariant = (variant) => {
      if (!variant) {
        if (atc) atc.disabled = true;
        if (atcText) atcText.textContent = 'Unavailable';
        return;
      }

      if (variantInput) variantInput.value = variant.id;
      if (price) price.textContent = formatMoney(variant.price);
      if (stickyPrice) stickyPrice.textContent = formatMoney(variant.price);

      if (comparePrice) {
        if (variant.compare_at_price && variant.compare_at_price > variant.price) {
          comparePrice.hidden = false;
          comparePrice.textContent = formatMoney(variant.compare_at_price);
        } else {
          comparePrice.hidden = true;
        }
      }

      if (jennaBcpoPriceFallback) {
        window.setTimeout(jennaBcpoPriceFallback.updateDisplay, 40);
      }

      if (atc) atc.disabled = !variant.available;
      if (atcText) atcText.textContent = variant.available ? 'Add to Cart' : 'Sold Out';

      const variantImage = variant.featured_image || variant.featured_media;
      if (variantImage && variantImage.src && !suppressVariantImageForBcpoColor && !targetBcpoMainImageState.src) {
        setMainImage(variantImage.src, variantImage.alt);
      }

      if (window.history && variant.id) {
        const url = new URL(window.location.href);
        url.searchParams.set('variant', variant.id);
        window.history.replaceState({}, '', url.toString());
      }
    };

    const getBcpoInput = (target, scope) => {
      if (!target || !target.closest) return null;
      const directInput = target.closest('#bcpo input');
      if (directInput) return directInput;
      const label = target.closest('#bcpo label');
      if (label) {
        const nestedInput = label.querySelector('input');
        if (nestedInput) return nestedInput;
        const controlId = label.getAttribute('for');
        const control = controlId ? document.getElementById(controlId) : null;
        if (control && control.closest && control.closest('#bcpo')) return control;
      }
      return scope ? scope.querySelector('.bcpo-front-image-option, .bcpo-front-color-option, input') : null;
    };

    const isColorInputName = (input) => {
      const inputName = String(input ? input.name : '').toLowerCase();
      return inputName.includes('[color]') || inputName.includes('[colour]') || inputName.includes('[fabric]');
    };

    const getBcpoLabel = (target, input, parent) => {
      if (!target || !target.closest) return null;
      const directLabel = target.closest('#bcpo .bcpo-front-image-label, #bcpo .bcpo-front-color-label, #bcpo label');
      if (directLabel) return directLabel;
      const parentLabel = parent ? parent.querySelector('.bcpo-front-image-label, .bcpo-front-color-label, label') : null;
      if (parentLabel) return parentLabel;
      if (!input || !input.id) return null;
      return Array.from(document.querySelectorAll('#bcpo label')).find((label) => label.getAttribute('for') === input.id) || null;
    };

    const decorateBcpoColorChoice = (choice) => {
      if (!choice || !choice.closest) return;
      const parent = choice.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent') || choice;
      const input = getBcpoInput(choice, parent);
      const labelElement = getBcpoLabel(choice, input, parent) || (choice.matches('label') ? choice : null);
      const selectedColor = input ? input.value : (labelElement ? labelElement.textContent : '');
      const swatchImage = getNeutralBambooColorDisplayImage(selectedColor)
        || getColorImage(selectedColor)
        || getCssBackgroundUrl(labelElement)
        || getCssBackgroundUrl(parent);

      parent.classList.add('fd-bcpo-color-choice');
      if (selectedColor) {
        const colorName = String(selectedColor).replace(/\s+/g, ' ').trim();
        parent.dataset.fdColorName = colorName;
        parent.setAttribute('title', colorName);
        parent.setAttribute('aria-label', colorName);
      }
      if (labelElement) {
        labelElement.classList.add('fd-bcpo-color-label');
        if (selectedColor) labelElement.setAttribute('title', selectedColor);
        if (swatchImage) applyBcpoChoiceImage(labelElement, swatchImage);
      } else if (swatchImage) {
        applyBcpoChoiceImage(parent, swatchImage);
      }

      const classText = `${parent.className || ''} ${labelElement ? labelElement.className : ''}`;
      const isSelected = Boolean(input && input.checked) || /\b(active|selected|checked)\b/i.test(classText);
      parent.classList.toggle('fd-bcpo-is-selected', isSelected);
    };

    const getNeutralBambooSingleColorValue = (wrapper) => {
      if (!wrapper) return '';
      const title = getBcpoWrapperTitle(wrapper);
      const text = String(wrapper.textContent || '')
        .replace(/\s+/g, ' ')
        .trim();
      const titlePattern = title ? new RegExp(`^${title.replace(/[.*+?^${}()|[\]\\]/g, '\\$&')}\\s*:?\\s*`, 'i') : /^color\s*:\s*/i;
      return text
        .replace(titlePattern, '')
        .replace(/Lighting, screen, and batch variations.*$/i, '')
        .replace(/\bShop Samples\s*>?.*$/i, '')
        .trim();
    };

    const decorateNeutralBambooSingleColorWrapper = (wrapper) => {
      if (!isNeutralBambooBcpoColorBridgeProduct || !wrapper) return false;
      if (wrapper.querySelector('.bcpo-image-parent:not(.fd-neutral-bamboo-single-color-card), .bcpo-color-parent:not(.fd-neutral-bamboo-single-color-card)')) return false;
      const colorName = getNeutralBambooSingleColorValue(wrapper);
      if (!colorName) return false;
      const mainSrc = mainImage ? (mainImage.currentSrc || mainImage.src || mainImage.getAttribute('src') || '') : '';
      const colorImage = getNeutralBambooColorDisplayImage(colorName) || (isNeutralBambooProductMainImage(mainSrc) ? mainSrc : '');
      if (!colorImage) return false;

      let holder = wrapper.querySelector('.fd-neutral-bamboo-single-color-card-list');
      if (!holder) {
        holder = document.createElement('div');
        holder.className = 'fd-neutral-bamboo-single-color-card-list';
        const note = wrapper.querySelector('.fd-bcpo-color-note');
        if (note && note.parentNode === wrapper) note.insertAdjacentElement('afterend', holder);
        else wrapper.append(holder);
      }

      let card = holder.querySelector('.fd-neutral-bamboo-single-color-card');
      if (!card) {
        card = document.createElement('div');
        card.className = 'bcpo-image-parent fd-bcpo-color-choice fd-bcpo-is-selected fd-neutral-bamboo-single-color-card';
        card.setAttribute('role', 'button');
        card.setAttribute('aria-selected', 'true');
        card.setAttribute('aria-checked', 'true');
        card.setAttribute('tabindex', '0');

        const label = document.createElement('span');
        label.className = 'bcpo-front-image-label fd-bcpo-color-label fd-bcpo-is-selected';
        card.append(label);

        const caption = document.createElement('span');
        caption.className = 'fd-neutral-bamboo-single-color-card__caption';
        card.append(caption);
        holder.append(card);
      }

      const label = card.querySelector('.bcpo-front-image-label') || card;
      const caption = card.querySelector('.fd-neutral-bamboo-single-color-card__caption');
      card.dataset.fdColorName = colorName;
      card.setAttribute('title', colorName);
      card.setAttribute('aria-label', colorName);
      card.style.display = 'inline-flex';
      card.style.flexDirection = 'column';
      card.style.alignItems = 'center';
      card.style.justifyContent = 'flex-start';
      card.style.width = '96px';
      card.style.minHeight = '132px';
      card.style.margin = '0 8px 12px 0';
      card.style.padding = '6px 6px 8px';
      card.style.border = '1px solid #8b5a3c';
      card.style.borderRadius = '5px';
      card.style.boxSizing = 'border-box';
      card.style.background = '#fff';
      if (label && label.style) {
        label.style.display = 'block';
        label.style.width = '82px';
        label.style.height = '82px';
        label.style.border = '1px solid #eee';
        label.style.borderRadius = '3px';
        label.style.boxSizing = 'border-box';
        applyBcpoChoiceImage(label, colorImage);
      }
      if (caption) {
        if (caption.textContent !== colorName) caption.textContent = colorName;
        caption.style.display = 'block';
        caption.style.marginTop = '6px';
        caption.style.fontSize = '11px';
        caption.style.lineHeight = '1.2';
        caption.style.textAlign = 'center';
        caption.style.color = '#2f1d12';
      }
      return true;
    };

    const getBcpoColorChoice = (target) => {
      return target && target.closest ? target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent') : null;
    };

    const getBcpoColorChoiceValue = (choice) => {
      if (!choice) return '';
      const input = getBcpoInput(choice, choice);
      if (input && input.value) return input.value;
      return choice.dataset.fdColorName || choice.textContent || '';
    };

    const getBcpoColorTargetValue = (target) => {
      if (!target || !target.closest) return '';
      const wrapper = target.closest('#bcpo .selector-wrapper');
      const parent = getBcpoColorChoice(target);
      const input = getBcpoInput(target, parent || wrapper || target.closest('#bcpo'));
      return String((input && input.value) || getBcpoColorChoiceValue(parent) || '').trim();
    };

    const findBcpoColorChoiceByValue = (wrapper, value) => {
      const selectedValue = String(value || '').trim();
      if (!wrapper || !selectedValue) return null;
      return Array.from(wrapper.querySelectorAll('.bcpo-image-parent, .bcpo-color-parent')).find((choice) => (
        isSameBcpoColorValue(getBcpoColorChoiceValue(choice), selectedValue)
      )) || null;
    };

    const isSameBcpoColorValue = (first, second) => {
      const firstValue = String(first || '').trim();
      const secondValue = String(second || '').trim();
      return Boolean(firstValue && secondValue) && (
        firstValue === secondValue
        || firstValue.toLowerCase() === secondValue.toLowerCase()
        || handleize(firstValue) === handleize(secondValue)
      );
    };

    const setBcpoColorChoiceSelected = (choice, selected) => {
      if (!choice || !choice.classList) return;
      const stateNodes = [
        choice,
        ...choice.querySelectorAll('.bcpo-front-image-label, .bcpo-front-color-label, .bcpo-front-image-option, .bcpo-front-color-option, label, input')
      ];
      const staleSelectedClasses = [
        'active',
        'selected',
        'checked',
        'is-active',
        'is-selected',
        'is-checked',
        'bcpo-active',
        'bcpo-selected',
        'bcpo-checked',
        'bcpo-is-selected',
        'fd-bcpo-is-selected'
      ];

      stateNodes.forEach((node) => {
        if (!node || !node.classList) return;
        if (selected && (node === choice || node.matches('.bcpo-front-image-label, .bcpo-front-color-label, label'))) {
          node.classList.add('fd-bcpo-is-selected');
        } else if (!selected) {
          staleSelectedClasses.forEach((className) => node.classList.remove(className));
        }
        if (node.setAttribute) {
          const nextState = selected ? 'true' : 'false';
          if (!isNeutralBambooStandardRightRailLayout || node.getAttribute('aria-selected') !== nextState) {
            node.setAttribute('aria-selected', nextState);
          }
          if (!isNeutralBambooStandardRightRailLayout || node.getAttribute('aria-checked') !== nextState) {
            node.setAttribute('aria-checked', nextState);
          }
          if (!isNeutralBambooStandardRightRailLayout || node.getAttribute('aria-pressed') !== nextState) {
            node.setAttribute('aria-pressed', nextState);
          }
        }
      });
    };

    const clearNeutralBambooBcpoColorSelectionState = () => {
      if (!isNeutralBambooBcpoColorBridgeProduct) return;
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      if (!bcpoRoot) return;
      bcpoRoot.querySelectorAll('.bcpo-image-parent, .bcpo-color-parent').forEach((choice) => {
        setBcpoColorChoiceSelected(choice, false);
        const input = getBcpoInput(choice, choice);
        if (input && /^(radio|checkbox)$/i.test(input.type || '')) {
          input.checked = false;
          input.removeAttribute('checked');
        }
      });
      bcpoRoot.querySelectorAll('input').forEach((input) => {
        if (!isColorInputName(input) && !input.matches('.bcpo-front-image-option, .bcpo-front-color-option')) return;
        if (/^(radio|checkbox)$/i.test(input.type || '')) {
          input.checked = false;
          input.removeAttribute('checked');
        }
        const choice = getBcpoColorChoice(input);
        if (choice) setBcpoColorChoiceSelected(choice, false);
      });
    };

    const syncBcpoColorSelection = (wrapper, activeTarget, expectedValue = '') => {
      if (!wrapper || !wrapper.querySelectorAll) return;
      const choices = Array.from(wrapper.querySelectorAll('.bcpo-image-parent, .bcpo-color-parent'));
      if (!choices.length) return;

      const activeChoice = findBcpoColorChoiceByValue(wrapper, expectedValue) || getBcpoColorChoice(activeTarget);
      if (isNeutralBambooBcpoColorBridgeProduct && activeChoice) {
        choices.forEach((choice) => {
          setBcpoColorChoiceSelected(choice, false);
          const input = getBcpoInput(choice, choice);
          if (input && /^(radio|checkbox)$/i.test(input.type || '')) {
            input.checked = false;
            input.removeAttribute('checked');
          }
        });
      }
      const checkedChoices = choices.filter((choice) => {
        const input = getBcpoInput(choice, choice);
        return Boolean(input && input.checked);
      });
      const currentColorLabel = root.querySelector('[data-fd-color-label]');
      const currentColor = (colorProperty && colorProperty.value) || (currentColorLabel ? currentColorLabel.textContent : '');
      const currentColorChoice = currentColor
        ? choices.find((choice) => isSameBcpoColorValue(getBcpoColorChoiceValue(choice), currentColor))
        : null;
      const selectedByClass = choices.filter((choice) => {
        const labelElement = getBcpoLabel(choice, getBcpoInput(choice, choice), choice);
        const classText = `${choice.className || ''} ${labelElement ? labelElement.className : ''}`;
        return /\b(active|selected|checked|fd-bcpo-is-selected)\b/i.test(classText);
      });
      const fallbackChoice = checkedChoices[checkedChoices.length - 1]
        || (activeChoice && wrapper.contains(activeChoice) ? activeChoice : null)
        || currentColorChoice
        || (selectedByClass.length === 1 ? selectedByClass[0] : null);

      choices.forEach((choice) => {
        const input = getBcpoInput(choice, choice);
        const selected = activeChoice && wrapper.contains(activeChoice)
          ? choice === activeChoice
          : checkedChoices.length
          ? Boolean(input && input.checked)
          : choice === fallbackChoice;
        if (input && /^(radio|checkbox)$/i.test(input.type || '')) {
          input.checked = selected;
          if (selected) input.setAttribute('checked', 'checked');
          else input.removeAttribute('checked');
        }
        setBcpoColorChoiceSelected(choice, selected);
      });
    };

    const decorateBcpoColorOptions = () => {
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      if (!bcpoRoot) return;
      const colorIndexes = getBcpoColorOptionIndexes();

      bcpoRoot.querySelectorAll('.selector-wrapper').forEach((wrapper) => {
        if (!isBcpoColorWrapper(wrapper, colorIndexes)) return;
        wrapper.classList.add('fd-bcpo-color-option');
        const titleLabel = wrapper.querySelector('.bcpo-label') || wrapper.querySelector('.bcpo-title') || Array.from(wrapper.children || []).find((child) => child.tagName === 'LABEL');
        if (titleLabel) titleLabel.classList.add('fd-bcpo-color-title');
        if (!wrapper.querySelector('.fd-bcpo-color-note')) {
          const note = document.createElement('div');
          note.className = 'fd-bcpo-color-note';
          note.textContent = 'Lighting, screen, and batch variations may affect color -- swatches recommended first.';
          if (titleLabel && titleLabel.parentNode === wrapper) {
            titleLabel.insertAdjacentElement('afterend', note);
          } else {
            wrapper.insertBefore(note, wrapper.firstChild);
          }
        }

        if (!wrapper.querySelector('.bcpo-image-parent, .bcpo-color-parent')) {
          decorateNeutralBambooSingleColorWrapper(wrapper);
        }
        wrapper.querySelectorAll('.bcpo-image-parent, .bcpo-color-parent').forEach((choice) => {
          decorateBcpoColorChoice(choice);
        });
        const lockedColor = isNeutralBambooBcpoColorBridgeProduct
          ? (neutralBambooUserSelectedBcpoColor || root.dataset.fdUserSelectedBcpoColor || '')
          : '';
        syncBcpoColorSelection(wrapper, null, lockedColor);
      });
    };

    const isBcpoColorTarget = (target) => {
      if (!target || !target.closest) return false;
      const wrapper = target.closest('#bcpo .selector-wrapper');
      const scope = wrapper || target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent, #bcpo label, #bcpo');
      const input = getBcpoInput(target, scope);

      if (isColorInputName(input)) return true;

      const colorIndexes = getBcpoColorOptionIndexes();
      const nameMatch = input && String(input.name || '').match(/^name(\d+)$/);
      if (nameMatch && colorIndexes.has(Number(nameMatch[1]))) return true;

      if (wrapper && isBcpoColorWrapper(wrapper, colorIndexes)) return true;

      return Boolean(input && input.matches && input.matches('.bcpo-front-image-option, .bcpo-front-color-option') && getColorImage(input.value));
    };

    const updateBcpoColorImage = (target, options = {}) => {
      if (!isBcpoColorTarget(target)) return false;
      const shouldUpdateMainImage = options.updateMainImage !== false && !neutralBambooThumbMainImageOverride;
      const wrapper = target.closest('#bcpo .selector-wrapper');
      const lockedColor = String(options.selectedValue || '').trim();
      syncBcpoColorSelection(wrapper, target, lockedColor);
      const parent = getBcpoColorChoice(target);
      const input = getBcpoInput(target, parent || wrapper || target.closest('#bcpo'));
      const labelElement = getBcpoLabel(target, input, parent);
      const selectedColor = lockedColor || (input ? input.value : '');
      const productImage = getNeutralBambooProductMainImage(selectedColor) || (!isNeutralBambooBcpoColorBridgeProduct ? getProductColorImage(selectedColor) : '');
      const swatchImage = getColorImage(selectedColor) || getCssBackgroundUrl(labelElement) || getCssBackgroundUrl(parent);
      const forcedMainImage = productImage || (!isNeutralBambooBcpoColorBridgeProduct ? swatchImage : '');
      if (shouldUpdateMainImage && forceBcpoColorImageAsMain && forcedMainImage) {
        targetBcpoMainImageState.src = expandBcpoImageUrl(forcedMainImage);
        targetBcpoMainImageState.alt = selectedColor || '';
      }
      const mainImageSrc = shouldUpdateMainImage
        ? ((forceBcpoColorImageAsMain && forcedMainImage)
          ? forcedMainImage
          : (productImage || (!isNeutralBambooBcpoColorBridgeProduct && canUseSwatchImageAsMain(swatchImage) ? swatchImage : '')))
        : '';

      if (!selectedColor && !swatchImage && !productImage) return false;
      root.querySelectorAll('[data-fd-color-label]').forEach((label) => {
        if (isHazelPecanRightRailPilot || isNeutralBambooStandardRightRailLayout) {
          if (label.textContent !== selectedColor) label.textContent = selectedColor;
        } else {
          label.textContent = selectedColor;
        }
      });
      if (colorProperty && selectedColor) colorProperty.value = selectedColor;
      if (mainImageSrc) {
        setMainImage(mainImageSrc, selectedColor);
        enforceTargetBcpoMainImage();
      }
      decorateBcpoColorOptions();
      syncBcpoColorSelection(wrapper, target, selectedColor);
      return true;
    };

    const scheduleBcpoColorImageUpdate = (target) => {
      const selectedValue = getBcpoColorTargetValue(target);
      const sourceWrapper = target && target.closest ? target.closest('#bcpo .selector-wrapper') : null;
      const delays = forceBcpoColorImageAsMain ? [0, 80, 250, 600, 1200, 2200, 4200, 7600] : [0, 80, 250, 600];
      delays.forEach((delay) => {
        window.setTimeout(() => {
          if (
            isNeutralBambooBcpoColorBridgeProduct
            && neutralBambooUserSelectedBcpoColor
            && !isSameBcpoColorValue(neutralBambooUserSelectedBcpoColor, selectedValue)
          ) {
            return;
          }
          const currentWrapper = (sourceWrapper && document.documentElement.contains(sourceWrapper))
            ? sourceWrapper
            : (target && target.closest ? target.closest('#bcpo .selector-wrapper') : null);
          const lockedChoice = findBcpoColorChoiceByValue(currentWrapper, selectedValue);
          const updateTarget = lockedChoice || target;
          if (lockedChoice) activateNativeBcpoColorChoice(lockedChoice, { dispatch: false });
          decorateBcpoColorOptions();
          updateBcpoColorImage(updateTarget, {
            selectedValue,
            updateMainImage: !neutralBambooThumbMainImageOverride
          });
          if (!neutralBambooThumbMainImageOverride) enforceTargetBcpoMainImage();
        }, delay);
      });
    };

    const normalizeVoText = (value) => String(value || '')
      .toLowerCase()
      .replace(/&/g, ' and ')
      .replace(/[^a-z0-9]+/g, ' ')
      .trim();

    const getBcpoOptions = () => {
      const bcpoData = window.bcpo_data;
      return bcpoData && Array.isArray(bcpoData.virtual_options) ? bcpoData.virtual_options : [];
    };

    const getBcpoOptionByIndex = (index) => {
      const options = getBcpoOptions();
      if (index >= 0 && options[index]) return options[index];
      if (index > 0 && options[index - 1]) return options[index - 1];
      return null;
    };

    const getBcpoWrapperOption = (wrapper) => {
      if (!wrapper) return null;
      const control = wrapper.querySelector('input, select, textarea');
      const nameMatch = control && String(control.name || '').match(/^name(\d+)$/);
      if (nameMatch) return getBcpoOptionByIndex(Number(nameMatch[1]));

      const propertyMatch = control && String(control.name || '').match(/^properties\[(.+)\]$/);
      if (propertyMatch) {
        const propertyTitle = propertyMatch[1];
        const matchingOption = getBcpoOptions().find((option) => voTitleMatches(option && option.title, propertyTitle));
        if (matchingOption) return matchingOption;
      }

      const dataOption = String(wrapper.getAttribute('data-option') || '');
      const dataMatch = dataOption.match(/^option(\d+)$/i);
      if (dataMatch) return getBcpoOptionByIndex(Number(dataMatch[1]));

      const title = normalizeVoText(getBcpoWrapperTitle(wrapper));
      return getBcpoOptions().find((option) => normalizeVoText(option && option.title) === title) || null;
    };

    const getBcpoWrapperOptionTitle = (wrapper) => {
      const option = getBcpoWrapperOption(wrapper);
      return option && option.title ? option.title : getBcpoWrapperTitle(wrapper);
    };

    const getBcpoWrappers = () => {
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      const scope = bcpoRoot || root;
      return Array.from(new Set(Array.from(scope.querySelectorAll('.selector-wrapper, [data-option], .bcpo-selector-wrapper, .bold_option'))))
        .filter((wrapper) => wrapper !== root && wrapper !== form);
    };

    const isForceHiddenFractionText = (title) => {
      const titleText = normalizeVoText(title);
      return titleText === 'width fraction'
        || titleText.startsWith('width fraction ')
        || titleText === 'height fraction'
        || titleText.startsWith('height fraction ');
    };

    const isForceHiddenBcpoTitle = (title) => isForceHiddenFractionText(title);

    const isForceHiddenBcpoControl = (control) => {
      if (!control) return false;
      const controlText = normalizeVoText(`${control.name || ''} ${control.id || ''}`);
      return controlText.includes('width fraction') || controlText.includes('height fraction');
    };

    const isForceHiddenBcpoWrapper = (wrapper) => {
      if (!wrapper) return false;
      if (isForceHiddenBcpoTitle(getBcpoWrapperOptionTitle(wrapper))) return true;
      if (isForceHiddenFractionText(wrapper.innerText || wrapper.textContent)) return true;
      return Array.from(wrapper.querySelectorAll('input, select, textarea')).some(isForceHiddenBcpoControl);
    };

    const setForceHiddenBcpoDefault = (control) => {
      if (!control) return;
      if (control.tagName === 'BUTTON') return;
      const type = String(control.type || '').toLowerCase();
      if (control.tagName === 'SELECT') {
        const options = Array.from(control.options || []);
        const isPlaceholderOption = (option) => {
          const text = normalizeVoText(option ? option.textContent : '');
          const value = normalizeVoText(option ? option.value : '');
          return !value || value === 'choose one' || text === 'choose one' || text === 'select one' || text === 'select';
        };
        let changed = false;
        if (isPlaceholderOption(options[control.selectedIndex])) {
          const preferred = options.find((option) => {
            const text = normalizeVoText(`${option.value || ''} ${option.textContent || ''}`);
            return !isPlaceholderOption(option) && (text === '0' || text.includes('no fraction') || text.includes('none'));
          }) || options.find((option) => !isPlaceholderOption(option));
          if (preferred && control.value !== preferred.value) {
            control.value = preferred.value;
            changed = true;
          }
        }
        if (changed) dispatchVoChange(control);
        return;
      }
      if (type === 'radio' || type === 'checkbox') {
        const group = control.name
          ? Array.from((control.form || document).querySelectorAll(`input[type="${type}"][name="${CSS.escape(control.name)}"]`))
          : [control];
        if (!group.some((item) => item.checked)) {
          const choice = group.find((item) => !item.disabled) || control;
          choice.checked = true;
          dispatchVoChange(choice);
        }
        return;
      }
      if (!String(control.value || '').trim()) {
        control.value = '0';
        dispatchVoChange(control);
      }
    };

    const setForceHiddenBcpoWrapper = (wrapper, shouldHide) => {
      if (!wrapper) return;
      wrapper.classList.toggle('fd-bcpo-force-hidden', shouldHide);
      if (shouldHide) {
        wrapper.setAttribute('aria-hidden', 'true');
        if (!Object.prototype.hasOwnProperty.call(wrapper.dataset, 'fdForceHiddenDisplay')) {
          wrapper.dataset.fdForceHiddenDisplay = wrapper.style.display || '';
        }
        wrapper.style.display = 'none';
        wrapper.querySelectorAll('input, select, textarea, button').forEach((control) => {
          if (!Object.prototype.hasOwnProperty.call(control.dataset, 'fdForceHiddenDisabled')) {
            control.dataset.fdForceHiddenDisabled = control.disabled ? 'true' : 'false';
          }
          setForceHiddenBcpoDefault(control);
          control.dataset.fdForceHiddenBcpo = 'true';
          control.removeAttribute('required');
          control.disabled = control.dataset.fdForceHiddenDisabled === 'true';
          control.setAttribute('aria-hidden', 'true');
        });
      } else if (!wrapper.classList.contains('fd-bcpo-template-hidden')) {
        wrapper.removeAttribute('aria-hidden');
        if (Object.prototype.hasOwnProperty.call(wrapper.dataset, 'fdForceHiddenDisplay')) {
          wrapper.style.display = wrapper.dataset.fdForceHiddenDisplay;
          delete wrapper.dataset.fdForceHiddenDisplay;
        }
        wrapper.querySelectorAll('[data-fd-force-hidden-bcpo]').forEach((control) => {
          delete control.dataset.fdForceHiddenBcpo;
          if (Object.prototype.hasOwnProperty.call(control.dataset, 'fdForceHiddenDisabled')) {
            control.disabled = control.dataset.fdForceHiddenDisabled === 'true';
            delete control.dataset.fdForceHiddenDisabled;
          }
          control.removeAttribute('aria-hidden');
        });
      }
    };

    const applyForceHiddenBcpoOptions = () => {
      getBcpoWrappers().forEach((wrapper) => {
        setForceHiddenBcpoWrapper(wrapper, isForceHiddenBcpoWrapper(wrapper));
      });
    };

    const refreshDuplicateThemeColorOptions = () => {
      if (root.dataset.windowTreatment === 'true' && !isNeutralBambooBcpoColorBridgeProduct) return false;
      const colorIndexes = getBcpoColorOptionIndexes();
      const hasBcpoColor = getBcpoWrappers().some((wrapper) => (
        isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(getBcpoWrapperOptionTitle(wrapper))
      ));
      root.querySelectorAll('[data-fd-theme-color-option]').forEach((field) => {
        field.hidden = hasBcpoColor;
        if (hasBcpoColor) field.setAttribute('aria-hidden', 'true');
        else field.removeAttribute('aria-hidden');
      });
      return hasBcpoColor;
    };

    const voTitleMatches = (title, query) => {
      const titleText = normalizeVoText(title);
      const queryText = normalizeVoText(query);
      if (!titleText || !queryText) return false;
      return titleText === queryText || titleText.includes(queryText) || queryText.includes(titleText);
    };

    const findBcpoOption = (query) => {
      const optionQuery = String(query || '').trim();
      if (!optionQuery) return null;
      return getBcpoOptions().find((option) => voTitleMatches(option && option.title, optionQuery)) || null;
    };

    const getBcpoColorOption = () => {
      return getBcpoOptions().find((option) => {
        const type = String(option && option.type ? option.type : '').toLowerCase();
        return type === 'images'
          && isBcpoColorTitle(option && option.title)
          && Array.isArray(option && option.values)
          && option.values.some((item) => String(item && item.key ? item.key : '').trim());
      }) || null;
    };

    const hasNativeBcpoColorWrapper = () => {
      const colorIndexes = getBcpoColorOptionIndexes();
      return getBcpoWrappers().some((wrapper) => {
        const title = getBcpoWrapperOptionTitle(wrapper);
        return isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
      });
    };

    const isVisibleBcpoNode = (element) => {
      if (!element || element.hidden || element.getAttribute('aria-hidden') === 'true') return false;
      if (element.closest('[hidden], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden, [aria-hidden="true"]')) return false;
      if (!window.getComputedStyle) return true;
      const style = window.getComputedStyle(element);
      if (!style || style.display === 'none' || style.visibility === 'hidden' || Number(style.opacity || 1) <= 0.01) return false;
      const rect = element.getBoundingClientRect ? element.getBoundingClientRect() : null;
      return !rect || (rect.width > 2 && rect.height > 2);
    };

    const hasVisibleNativeBcpoColorMedia = (wrapper) => {
      if (!isVisibleBcpoNode(wrapper)) return false;
      const mediaItems = Array.from(wrapper.querySelectorAll([
        'img',
        'picture',
        '[style*="background-image"]',
        '[data-image]',
        '[data-img]',
        '.bcpo-image',
        '.bcpo-image-option',
        '.bcpo-option-image',
        '.bcpo_color',
        '.swatch',
        '.color-swatch'
      ].join(',')));

      return mediaItems.some((item) => {
        if (!isVisibleBcpoNode(item)) return false;
        const tag = String(item.tagName || '').toLowerCase();
        if (tag === 'img' || tag === 'picture') return true;
        if (item.querySelector && item.querySelector('img, picture')) return true;
        if (item.getAttribute('data-image') || item.getAttribute('data-img')) return true;
        const bg = window.getComputedStyle ? window.getComputedStyle(item).backgroundImage : '';
        return /url\(/i.test(bg || '');
      });
    };

    const hasRenderableNativeBcpoColorWrapper = () => {
      const colorIndexes = getBcpoColorOptionIndexes();
      return getBcpoWrappers().some((wrapper) => {
        const title = getBcpoWrapperOptionTitle(wrapper);
        const isColorWrapper = isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
        return isColorWrapper && hasVisibleNativeBcpoColorMedia(wrapper);
      });
    };

    const findBcpoWrapperForOption = (option) => {
      if (!option) return null;
      const title = normalizeVoText(option.title);
      return getBcpoWrappers().find((wrapper) => {
        const wrapperOption = getBcpoWrapperOption(wrapper);
        if (wrapperOption && wrapperOption === option) return true;
        return voTitleMatches(getBcpoWrapperOptionTitle(wrapper), title);
      }) || null;
    };

    const valueMatches = (candidate, desired) => {
      const candidateText = normalizeVoText(candidate);
      const desiredText = normalizeVoText(desired);
      if (!candidateText || !desiredText) return false;
      return candidateText === desiredText || candidateText.includes(desiredText) || desiredText.includes(candidateText);
    };

    const getBcpoValueKey = (item) => String(item && item.key ? item.key : '').trim();

    const createColorSwatchButton = (item, index) => {
      const key = getBcpoValueKey(item);
      const rawImage = item && item.value ? item.value : getColorImage(key);
      const image = expandBcpoImageUrl(window.__fdLegacyColorThumbnail ? (getColorImage(key) || rawImage) : rawImage);
      const swatchImage = getBcpoSwatchImageUrl(rawImage);
      const button = document.createElement('button');
      button.type = 'button';
      button.className = 'fd-pdp-option__value fd-pdp-swatch fd-pdp-vo-color-swatch';
      button.dataset.fdTemplateBcpoColor = 'true';
      button.dataset.label = key;
      button.dataset.alt = key;
      button.dataset.value = key;
      button.dataset.valueHandle = handleize(key);
      if (image) button.dataset.image = image;
      button.setAttribute('aria-pressed', index === 0 ? 'true' : 'false');
      button.innerHTML = [
        `<span class="fd-pdp-swatch__chip" ${swatchImage ? `style="background-image:url('${swatchImage.replace(/'/g, '%27')}');"` : ''}></span>`,
        `<span>${key}</span>`
      ].join('');
      return button;
    };

    const syncBcpoColorValue = (option, value) => {
      const wrapper = findBcpoWrapperForOption(option);
      if (!wrapper || !value) return false;

      const select = wrapper.querySelector('select');
      if (select) {
        const match = Array.from(select.options).find((item) => valueMatches(item.value || item.textContent, value));
        if (match) {
          if (isNeutralBambooStandardRightRailLayout && select.value === match.value) return true;
          select.value = match.value;
          dispatchVoChange(select);
          return true;
        }
      }

      const inputs = Array.from(wrapper.querySelectorAll('input, textarea'));
      const choice = inputs.find((input) => valueMatches(input.value || input.getAttribute('value'), value));
      if (choice) {
        if (choice.type === 'radio' || choice.type === 'checkbox') {
          if (isNeutralBambooStandardRightRailLayout) {
            if (choice.checked) return true;
            choice.click();
            if (!choice.checked) {
              choice.checked = true;
              dispatchVoChange(choice);
            }
            return true;
          }
          if (!choice.checked) choice.click();
          choice.checked = true;
        } else {
          if (isNeutralBambooStandardRightRailLayout && choice.value === value) return true;
          choice.value = value;
        }
        dispatchVoChange(choice);
        return true;
      }

      const openInput = inputs.find((input) => !/^(radio|checkbox|hidden)$/i.test(input.type || ''));
      if (openInput) {
        if (isNeutralBambooStandardRightRailLayout && openInput.value === value) return true;
        openInput.value = value;
        dispatchVoChange(openInput);
        return true;
      }

      return false;
    };

    const activateNativeBcpoColorChoice = (target, options = {}) => {
      const wrapper = target && target.closest ? target.closest('#bcpo .selector-wrapper') : null;
      const parent = getBcpoColorChoice(target);
      const input = getBcpoInput(target, parent || wrapper || (target && target.closest ? target.closest('#bcpo') : null));
      if (!input || input.disabled) return false;

      const type = String(input.type || '').toLowerCase();
      if (type === 'radio' || type === 'checkbox') {
        if (type === 'radio' && input.name) {
          Array.from((input.form || document).querySelectorAll(`input[type="radio"][name="${CSS.escape(input.name)}"]`)).forEach((item) => {
            if (item !== input) item.checked = false;
          });
        }
        input.checked = true;
      }

      if (options.dispatch !== false) dispatchVoChange(input);
      return true;
    };

    const findNeutralBambooNativeColorField = () => {
      if (!isNeutralBambooBcpoColorBridgeProduct) return null;
      return root.querySelector('.fd-pdp-form > [data-fd-theme-color-option].fd-pdp-option--color[data-fd-option-position]')
        || root.querySelector('[data-fd-theme-color-option].fd-pdp-option--color[data-fd-option-position]');
    };

    const setNeutralBambooHiddenField = (field, hidden) => {
      if (!field) return;
      field.hidden = hidden;
      if (hidden) field.setAttribute('aria-hidden', 'true');
      else field.removeAttribute('aria-hidden');
    };

    const setNeutralBambooBcpoWrapperHidden = (wrapper, hidden) => {
      if (!wrapper) return;
      const wasHiddenByBridge = wrapper.dataset.fdNeutralBambooHiddenColor === 'true';
      wrapper.classList.toggle('fd-bcpo-neutral-hidden-color-control', hidden);
      if (hidden) {
        if (!wasHiddenByBridge) {
          wrapper.dataset.fdNeutralBambooHiddenColor = 'true';
          wrapper.dataset.fdNeutralBambooDisplay = wrapper.style.display || '';
        }
        wrapper.style.display = 'none';
        wrapper.setAttribute('aria-hidden', 'true');
      } else {
        wrapper.classList.remove('fd-bcpo-template-hidden');
        if (wasHiddenByBridge) {
          delete wrapper.dataset.fdNeutralBambooHiddenColor;
          wrapper.style.display = wrapper.dataset.fdNeutralBambooDisplay || '';
          delete wrapper.dataset.fdNeutralBambooDisplay;
        }
        wrapper.removeAttribute('aria-hidden');
      }
    };

    const getNeutralBambooNativeColorButtons = () => {
      const field = findNeutralBambooNativeColorField();
      return field ? Array.from(field.querySelectorAll('[data-fd-option-value]')) : [];
    };

    const getNeutralBambooNativeColorValue = () => {
      const selected = getNeutralBambooNativeColorButtons().find((button) => button.classList.contains('is-selected'));
      return selected ? String(selected.dataset.optionValue || '').trim() : '';
    };

    const findNeutralBambooNativeColorButton = (value) => {
      const selectedValue = String(value || '').trim();
      if (!selectedValue) return null;
      return getNeutralBambooNativeColorButtons().find((button) => (
        isSameBcpoColorValue(button.dataset.optionValue, selectedValue)
      )) || null;
    };

    const findNeutralBambooColorVariant = (value) => {
      const selectedValue = String(value || '').trim();
      const field = findNeutralBambooNativeColorField();
      const position = field ? Number(field.dataset.fdOptionPosition || '1') - 1 : -1;
      if (!selectedValue || position < 0) return null;
      return variants.find((variant) => (
        isSameBcpoColorValue(getVariantOptions(variant)[position], selectedValue)
      )) || null;
    };

    const syncNeutralBambooVariantColor = (value) => {
      if (!isNeutralBambooBcpoColorBridgeProduct || neutralBambooColorBridgeState.syncing) return false;
      const selectedValue = String(value || '').trim();
      if (!selectedValue) return false;

      const nativeButton = findNeutralBambooNativeColorButton(selectedValue);
      neutralBambooColorBridgeState.syncing = true;
      try {
        if (nativeButton) {
          const position = Number(nativeButton.dataset.optionPosition || '1') - 1;
          const group = nativeButton.closest('[data-fd-option-position]');
          if (position >= 0) selectedOptions[position] = nativeButton.dataset.optionValue;
          if (group) {
            group.querySelectorAll('[data-fd-option-value]').forEach((button) => {
              button.classList.toggle('is-selected', button === nativeButton);
            });
          }
          const matchingVariant = findSelectedVariant() || findNeutralBambooColorVariant(selectedValue);
          if (matchingVariant) {
            suppressVariantImageForBcpoColor = true;
            updateVariant(matchingVariant);
            suppressVariantImageForBcpoColor = false;
          }
          return true;
        }

        const variant = findNeutralBambooColorVariant(selectedValue);
        if (variant) {
          const field = findNeutralBambooNativeColorField();
          const position = field ? Number(field.dataset.fdOptionPosition || '1') - 1 : -1;
          if (position >= 0) selectedOptions[position] = getVariantOptions(variant)[position];
          suppressVariantImageForBcpoColor = true;
          updateVariant(variant);
          suppressVariantImageForBcpoColor = false;
          return true;
        }
      } finally {
        suppressVariantImageForBcpoColor = false;
        neutralBambooColorBridgeState.syncing = false;
      }
      return false;
    };

    const getNeutralBambooVisibleBcpoColorWrapper = () => {
      if (!isNeutralBambooBcpoColorBridgeProduct) return null;
      const colorIndexes = getBcpoColorOptionIndexes();
      const wrappers = getBcpoWrappers().filter((wrapper) => {
        const title = getBcpoWrapperOptionTitle(wrapper);
        const isColorWrapper = isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
        if (!isColorWrapper) return false;
        return Boolean(wrapper.querySelector('.bcpo-image-parent, .bcpo-color-parent, .bcpo-front-image-label, .bcpo-front-color-label, .bcpo-front-image-option, .bcpo-front-color-option'));
      });
      if (!wrappers.length) return null;
      return wrappers.find((wrapper) => isVisibleBcpoNode(wrapper) && wrapper.querySelector('input:checked'))
        || wrappers.find((wrapper) => isVisibleBcpoNode(wrapper))
        || wrappers[0];
    };

    const syncNeutralBambooVisibleBcpoColor = (value) => {
      const selectedValue = String(value || '').trim();
      if (!selectedValue) return false;
      const wrapper = getNeutralBambooVisibleBcpoColorWrapper();
      const choice = findBcpoColorChoiceByValue(wrapper, selectedValue);
      if (!choice) return false;
      activateNativeBcpoColorChoice(choice, { dispatch: false });
      updateBcpoColorImage(choice, { selectedValue, updateMainImage: false });
      return true;
    };

    let neutralBambooUserSelectedBcpoColor = '';
    let neutralBambooUserColorGuardTimer = 0;
    let neutralBambooUserColorGuardGeneration = 0;
    let neutralBambooThumbMainImageOverride = false;

    const forceNeutralBambooUserColorValue = (value, options = {}) => {
      const selectedValue = String(value || '').trim();
      if (!isNeutralBambooBcpoColorBridgeProduct || !selectedValue) return false;
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      if (!bcpoRoot) return false;

      const colorInputs = Array.from(bcpoRoot.querySelectorAll('input')).filter((input) => (
        isColorInputName(input) || isBcpoColorTarget(input)
      ));
      const colorChoices = Array.from(bcpoRoot.querySelectorAll('.bcpo-image-parent, .bcpo-color-parent')).filter((choice) => (
        isBcpoColorTarget(choice)
      ));
      const activeInputs = colorInputs.filter((input) => isSameBcpoColorValue(input.value, selectedValue));
      const activeChoice = colorChoices.find((choice) => isSameBcpoColorValue(getBcpoColorChoiceValue(choice), selectedValue))
        || (activeInputs[0] ? getBcpoColorChoice(activeInputs[0]) : null);

      if (!activeInputs.length && !activeChoice) return false;

      if (!isNeutralBambooStandardRightRailLayout) clearNeutralBambooBcpoColorSelectionState();

      colorInputs.forEach((input) => {
        const selected = isSameBcpoColorValue(input.value, selectedValue);
        if (/^(radio|checkbox)$/i.test(input.type || '')) {
          input.checked = selected;
          if (selected) input.setAttribute('checked', 'checked');
          else input.removeAttribute('checked');
        }

        const choice = getBcpoColorChoice(input);
        if (choice) setBcpoColorChoiceSelected(choice, selected);
      });

      colorChoices.forEach((choice) => {
        const selected = isSameBcpoColorValue(getBcpoColorChoiceValue(choice), selectedValue);
        const input = getBcpoInput(choice, choice);
        if (input && /^(radio|checkbox)$/i.test(input.type || '')) {
          input.checked = selected;
          if (selected) input.setAttribute('checked', 'checked');
          else input.removeAttribute('checked');
        }
        setBcpoColorChoiceSelected(choice, selected);
      });

      const wrapper = (activeChoice && activeChoice.closest('#bcpo .selector-wrapper'))
        || (activeInputs[0] && activeInputs[0].closest('#bcpo .selector-wrapper'))
        || getNeutralBambooVisibleBcpoColorWrapper();
      if (wrapper && activeChoice && !isNeutralBambooStandardRightRailLayout) {
        syncBcpoColorSelection(wrapper, activeChoice, selectedValue);
      }

      root.querySelectorAll('[data-fd-color-label]').forEach((label) => {
        if (isHazelPecanRightRailPilot || isNeutralBambooStandardRightRailLayout) {
          if (label.textContent !== selectedValue) label.textContent = selectedValue;
        } else {
          label.textContent = selectedValue;
        }
      });
      if (colorProperty) colorProperty.value = selectedValue;

      const productImage = getNeutralBambooProductMainImage(selectedValue);
      if (options.updateMainImage !== false && !neutralBambooThumbMainImageOverride && productImage) {
        targetBcpoMainImageState.src = expandBcpoImageUrl(productImage);
        targetBcpoMainImageState.alt = selectedValue;
        setMainImage(productImage, selectedValue);
        enforceTargetBcpoMainImage();
      }

      return true;
    };

    const startNeutralBambooUserColorGuard = () => {
      if (!isNeutralBambooBcpoColorBridgeProduct || !neutralBambooUserSelectedBcpoColor) return;
      window.clearInterval(neutralBambooUserColorGuardTimer);
      neutralBambooUserColorGuardTimer = 0;
      neutralBambooUserColorGuardGeneration += 1;
      const generation = neutralBambooUserColorGuardGeneration;
      const selectedValue = neutralBambooUserSelectedBcpoColor;
      const restore = () => {
        if (
          generation !== neutralBambooUserColorGuardGeneration
          || !neutralBambooUserSelectedBcpoColor
          || !isSameBcpoColorValue(neutralBambooUserSelectedBcpoColor, selectedValue)
        ) return;
        forceNeutralBambooUserColorValue(selectedValue, {
          updateMainImage: !neutralBambooThumbMainImageOverride
        });
      };
      window.requestAnimationFrame(restore);
      [120, 360, 900].forEach((delay) => window.setTimeout(restore, delay));
    };

    const rememberNeutralBambooUserSelectedColor = (target) => {
      if (!target || !isBcpoColorTarget(target)) return '';
      const selectedValue = getBcpoColorTargetValue(target);
      if (!selectedValue) return '';
      neutralBambooThumbMainImageOverride = false;
      neutralBambooUserSelectedBcpoColor = selectedValue;
      root.dataset.fdUserSelectedBcpoColor = selectedValue;
      startNeutralBambooUserColorGuard();
      return selectedValue;
    };

    const restoreNeutralBambooUserSelectedColor = (options = {}) => {
      const selectedValue = neutralBambooUserSelectedBcpoColor || root.dataset.fdUserSelectedBcpoColor || '';
      if (!selectedValue) return false;
      const wrapper = getNeutralBambooVisibleBcpoColorWrapper();
      const choice = findBcpoColorChoiceByValue(wrapper, selectedValue);
      if (!choice) return forceNeutralBambooUserColorValue(selectedValue, options);
      activateNativeBcpoColorChoice(choice, { dispatch: false });
      syncBcpoColorSelection(wrapper, choice, selectedValue);
      const shouldRestoreMainImage = options.updateMainImage !== false && !neutralBambooThumbMainImageOverride;
      updateBcpoColorImage(choice, {
        selectedValue,
        updateMainImage: shouldRestoreMainImage
      });
      syncBcpoColorSelection(wrapper, choice, selectedValue);
      forceNeutralBambooUserColorValue(selectedValue, {
        ...options,
        updateMainImage: shouldRestoreMainImage
      });
      return true;
    };

    const scheduleNeutralBambooUserSelectedColorRestore = () => {
      if (!neutralBambooUserSelectedBcpoColor) return;
      startNeutralBambooUserColorGuard();
    };

    const refreshNeutralBambooColorBridge = (options = {}) => {
      if (!isNeutralBambooBcpoColorBridgeProduct) return false;
      root.classList.add('fd-neutral-bamboo-color-bridge');

      const colorIndexes = getBcpoColorOptionIndexes();
      getBcpoWrappers().forEach((wrapper) => {
        const title = getBcpoWrapperOptionTitle(wrapper);
        const isColorWrapper = isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
        if (!isColorWrapper) return;
        const hasVisibleImageChoices = Boolean(wrapper.querySelector('.bcpo-image-parent, .bcpo-color-parent, .bcpo-front-image-label, .bcpo-front-color-label, .bcpo-front-image-option, .bcpo-front-color-option'));
        setNeutralBambooBcpoWrapperHidden(wrapper, !hasVisibleImageChoices);
      });

      root.querySelectorAll('[data-fd-theme-color-option].fd-pdp-option--color, [data-fd-template-color-field]').forEach((field) => {
        if (field.hasAttribute('data-fd-template-color-field')) {
          field.remove();
        } else {
          setNeutralBambooHiddenField(field, true);
        }
      });

      if (options.syncVisible !== false) {
        syncNeutralBambooVisibleBcpoColor(getNeutralBambooNativeColorValue());
      }
      return true;
    };

    const syncNeutralBambooBridgeFromBcpoTarget = (target, options = {}) => {
      if (!isNeutralBambooBcpoColorBridgeProduct) return false;
      const selectedValue = getBcpoColorTargetValue(target);
      if (!selectedValue) return false;
      neutralBambooThumbMainImageOverride = false;
      neutralBambooUserSelectedBcpoColor = selectedValue;
      root.dataset.fdUserSelectedBcpoColor = selectedValue;
      if (options.startGuard !== false) startNeutralBambooUserColorGuard();
      updateBcpoColorImage(target, { selectedValue, updateMainImage: true });
      const synced = syncNeutralBambooVariantColor(selectedValue);
      forceNeutralBambooUserColorValue(selectedValue, { updateMainImage: true });
      refreshNeutralBambooColorBridge({ syncVisible: false });
      return synced;
    };

    const selectTemplateBcpoColor = (button, shouldSyncVo, options = {}) => {
      if (!button) return false;
      const shouldUpdateMainImage = options.updateMainImage !== false;
      const field = button.closest('[data-fd-template-color-field]');
      const value = String(button.dataset.value || button.dataset.label || '').trim();
      if (!field || !value) return false;

      field.querySelectorAll('[data-fd-template-bcpo-color]').forEach((item) => {
        const selected = item === button;
        item.classList.toggle('is-selected', selected);
        item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      });

      const label = field.querySelector('[data-fd-generated-color-label]');
      if (label) {
        if (isHazelPecanRightRailPilot || isNeutralBambooStandardRightRailLayout) {
          if (label.textContent !== value) label.textContent = value;
        } else {
          label.textContent = value;
        }
      }
      const hidden = field.querySelector('[data-fd-template-color-property]');
      if (hidden) hidden.value = value;
      field.dataset.fdCurrentColorValue = value;
      root.querySelectorAll('[data-fd-color-label]').forEach((item) => {
        if (isHazelPecanRightRailPilot || isNeutralBambooStandardRightRailLayout) {
          if (item.textContent !== value) item.textContent = value;
        } else {
          item.textContent = value;
        }
      });

      const option = getBcpoColorOption();
      if (shouldSyncVo && option) syncBcpoColorValue(option, value);

      const swatchImage = button.dataset.image || getColorImage(value);
      const productImage = getNeutralBambooProductMainImage(value) || (!isNeutralBambooBcpoColorBridgeProduct ? getProductColorImage(value) : '');
      if (shouldUpdateMainImage && productImage) {
        setMainImage(productImage, value);
        updateGalleryGroup(button.dataset.valueHandle || handleize(value), productImage);
      } else if (shouldUpdateMainImage && !isNeutralBambooBcpoColorBridgeProduct && canUseSwatchImageAsMain(swatchImage)) {
        setMainImage(swatchImage, value);
      }

      return true;
    };

    const getInitialSkuColorValue = (option) => {
      if (!preserveInitialMainImageDuringColorSync || hasUserMainImageInteraction || !option || !Array.isArray(option.values)) return '';
      const skuMatch = productHandle.match(/(?:^|-)rs\d+-\d+(?:-|$)/i);
      if (!skuMatch) return '';
      const sku = skuMatch[0].replace(/^-|-$/g, '').toUpperCase();
      const match = option.values.find((item) => String(getBcpoValueKey(item) || '').toUpperCase().includes(sku));
      return match ? getBcpoValueKey(match) : '';
    };

    const ensureTemplateBcpoColorField = () => {
      const template = root.querySelector('[data-fd-vo-template]');
      if (isNeutralBambooStandardRightRailLayout) {
        const existingField = root.querySelector('[data-fd-template-color-field]');
        if (existingField) existingField.remove();
        return null;
      }
      const option = getBcpoColorOption();
      if (!template || !option || !Array.isArray(option.values) || !option.values.length) return null;

      if ((!isNeutralBambooUploadedProduct || isNeutralBambooBcpoColorBridgeProduct) && hasNativeBcpoColorWrapper()) {
        const existingField = template.querySelector('[data-fd-template-color-field]');
        if (existingField) existingField.remove();
        return null;
      }

      const usableValues = option.values.filter((item) => getBcpoValueKey(item));
      if (!usableValues.length) return null;

      const getGeneratedColorFieldAnchor = (currentField) => {
        if (forceTopGeneratedColorField && form) {
          const bcpoRoot = root.querySelector('#bcpo') || form.querySelector('#bcpo');
          if (bcpoRoot && bcpoRoot.parentNode === form) return bcpoRoot;
        }
        return Array.from(template.querySelectorAll('[data-fd-vo-template-field]'))
          .find((candidate) => candidate !== currentField && !candidate.hasAttribute('data-fd-template-color-field')) || null;
      };

      const insertGeneratedColorField = (colorField, anchor) => {
        if (anchor && anchor.parentNode) anchor.parentNode.insertBefore(colorField, anchor);
        else template.appendChild(colorField);
      };

      let field = (forceTopGeneratedColorField && form ? form.querySelector('[data-fd-template-color-field]') : null)
        || template.querySelector('[data-fd-template-color-field]');
      const hadField = Boolean(field);
      if (!field) {
        field = document.createElement('fieldset');
        field.className = 'fd-pdp-option fd-pdp-option--color fd-pdp-option--media fd-pdp-option--vo-color';
        field.setAttribute('data-fd-vo-template-field', '');
        field.setAttribute('data-fd-template-color-field', '');
        const anchor = getGeneratedColorFieldAnchor(field);
        insertGeneratedColorField(field, anchor);
      }

      if (forceTopGeneratedColorField) {
        const anchor = getGeneratedColorFieldAnchor(field);
        if (anchor && anchor.previousElementSibling !== field) insertGeneratedColorField(field, anchor);
      }

      const signature = usableValues.map((item) => `${getBcpoValueKey(item)}=${item && item.value ? item.value : ''}`).join('|');
      if (field.dataset.fdColorSignature !== signature) {
        const firstValue = getBcpoValueKey(usableValues[0]);
        field.innerHTML = [
          '<legend class="fd-pdp-step-label"><b></b><span>Color: <em data-fd-generated-color-label data-fd-color-label></em></span></legend>',
          '<div class="fd-pdp-color-note">Lighting, screen, and batch variations may affect color. Swatches recommended first.</div>',
          `<input type="hidden" name="properties[Color]" value="${firstValue.replace(/"/g, '&quot;')}" data-fd-template-color-property>`,
          '<div class="fd-pdp-option__values fd-pdp-vo-color-values"></div>'
        ].join('');
        const valuesRoot = field.querySelector('.fd-pdp-vo-color-values');
        usableValues.forEach((item, index) => {
          valuesRoot.appendChild(createColorSwatchButton(item, index));
        });
        field.dataset.fdColorSignature = signature;
      }

      field.hidden = false;
      field.dataset.fdVoUnavailable = 'false';

      const currentSelected = hadField ? field.querySelector('[data-fd-template-bcpo-color].is-selected') : null;
      const currentHidden = hadField ? field.querySelector('[data-fd-template-color-property]') : null;
      const currentValue = field.dataset.fdCurrentColorValue
        || (currentHidden ? String(currentHidden.value || '').trim() : '')
        || (currentSelected ? String(currentSelected.dataset.value || '').trim() : '');
      const selectedValue = currentValue || getInitialSkuColorValue(option) || String(option.preselect_value || '').trim();
      const selectedButton = Array.from(field.querySelectorAll('[data-fd-template-bcpo-color]')).find((button) => (
        valueMatches(button.dataset.value, selectedValue)
      )) || field.querySelector('[data-fd-template-bcpo-color].is-selected') || field.querySelector('[data-fd-template-bcpo-color]');
      selectTemplateBcpoColor(selectedButton, true, { updateMainImage: false });
      return field;
    };

    const fdLastVoDispatch = new WeakMap();
    const dispatchVoChange = (control) => {
      if (!control) return;
      const signature = `${control.name || control.dataset.fdVoOption || ''}:${control.value || ''}`;
      if (fdLastVoDispatch.get(control) === signature) return;
      fdLastVoDispatch.set(control, signature);
      control.dispatchEvent(new Event('change', { bubbles: true }));
      window.setTimeout(() => {
        if (fdLastVoDispatch.get(control) === signature) fdLastVoDispatch.delete(control);
      }, 0);
    };

    const syncTemplateRadioGroup = (control) => {
      if (!control || control.type !== 'radio') return;
      const field = control.closest('[data-fd-vo-template-field]') || control.closest('[data-fd-vo-template]');
      if (!field) return;
      const optionName = control.dataset.fdVoOption || '';
      field.querySelectorAll('input[type="radio"][data-fd-vo-sync]').forEach((input) => {
        if ((input.dataset.fdVoOption || '') === optionName) input.checked = input === control;
      });
    };

    const setTemplateControlToVoMode = (control, enabled) => {
      if (!control) return;
      const shell = control.closest('label');
      if (shell && shell.closest('[data-fd-vo-template-field]')) shell.hidden = !enabled;
      if (enabled) {
        if (!control.dataset.fdOriginalName && control.name) control.dataset.fdOriginalName = control.name;
        control.removeAttribute('name');
        control.disabled = false;
        control.dataset.fdVoReady = 'true';
      } else {
        if (control.dataset.fdOriginalName) control.name = control.dataset.fdOriginalName;
        control.disabled = true;
        delete control.dataset.fdVoReady;
      }
    };

    const refreshCompositeTemplateLabels = (template) => {
      if (!template) return;
      const useIdempotentStandardSync = isHazelPecanRightRailPilot
        || isNeutralBambooStandardRightRailLayout;
      template.querySelectorAll('[data-fd-vo-template-field]').forEach((field) => {
        const fieldsGrid = field.querySelector('.fd-pdp-fields');
        if (fieldsGrid) {
          const visibleFields = Array.from(fieldsGrid.children || []).filter((child) => !child.hidden);
          fieldsGrid.classList.toggle('fd-pdp-fields--single', visibleFields.length === 1);
        }

        const title = field.querySelector('.fd-pdp-step-label span');
        if (!title || normalizeVoText(title.dataset.fdOriginalLabel || title.textContent) !== 'lining and edge binding') return;
        if (!title.dataset.fdOriginalLabel) title.dataset.fdOriginalLabel = title.textContent;

        const controls = Array.from(field.querySelectorAll('[data-fd-vo-sync]'));
        const hasLining = controls.some((control) => control.dataset.fdVoReady === 'true' && normalizeVoText(control.dataset.fdVoOption).includes('lining'));
        const hasEdgeBinding = controls.some((control) => control.dataset.fdVoReady === 'true' && normalizeVoText(control.dataset.fdVoOption).includes('edge binding'));

        if (useIdempotentStandardSync) {
          let nextTitle = title.dataset.fdOriginalLabel;
          if (hasLining && !hasEdgeBinding) nextTitle = 'Lining';
          else if (!hasLining && hasEdgeBinding) nextTitle = 'Edge Binding';
          if (title.textContent !== nextTitle) title.textContent = nextTitle;
        } else if (hasLining && hasEdgeBinding) title.textContent = title.dataset.fdOriginalLabel;
        else if (hasLining) title.textContent = 'Lining';
        else if (hasEdgeBinding) title.textContent = 'Edge Binding';
        else title.textContent = title.dataset.fdOriginalLabel;
      });
    };

    const syncSelectOptionsFromVo = (control, option) => {
      if (!control || control.tagName !== 'SELECT' || !option || !Array.isArray(option.values) || !option.values.length) return;
      if (control.dataset.fdVoOptionsLoaded === normalizeVoText(option.title)) return;
      const currentValue = control.value;
      control.innerHTML = '';
      option.values.forEach((item) => {
        const key = String(item && item.key ? item.key : '').trim();
        if (!key) return;
        const optionElement = document.createElement('option');
        optionElement.value = key;
        optionElement.textContent = key;
        control.appendChild(optionElement);
      });
      const matchingOption = Array.from(control.options).find((item) => valueMatches(item.value, currentValue));
      if (matchingOption) control.value = matchingOption.value;
      control.dataset.fdVoOptionsLoaded = normalizeVoText(option.title);
    };

    const syncNumberConstraintsFromVo = (control, option) => {
      if (!control || control.type !== 'number' || !option || !Array.isArray(option.values) || !option.values.length) return;
      const numbers = option.values
        .map((item) => Number.parseFloat(String(item && item.key ? item.key : '').trim()))
        .filter((value) => Number.isFinite(value))
        .sort((a, b) => a - b);
      if (!numbers.length) return;

      const min = numbers[0];
      const max = numbers[numbers.length - 1];
      control.min = String(min);
      control.max = String(max);
      control.step = '1';

      const placeholder = Number.parseFloat(control.getAttribute('placeholder') || '');
      if (Number.isFinite(placeholder) && (placeholder < min || placeholder > max)) {
        control.setAttribute('placeholder', String(max));
      }
    };

    const syncTemplateControlToVo = (control) => {
      if (!control || control.disabled || control.closest('[hidden]') || control.dataset.fdVoReady !== 'true') return false;
      const option = findBcpoOption(control.dataset.fdVoOption);
      const wrapper = findBcpoWrapperForOption(option);
      const value = String(control.dataset.fdVoValue || control.value || '').trim();
      if (!option || !wrapper || !value) return false;
      const useIdempotentStandardSync = isHazelPecanRightRailPilot
        || isNeutralBambooStandardRightRailLayout;

      const select = wrapper.querySelector('select');
      if (select) {
        const match = Array.from(select.options).find((item) => valueMatches(item.value || item.textContent, value));
        if (match) {
          if (useIdempotentStandardSync) {
            if (select.value !== match.value) {
              select.value = match.value;
              dispatchVoChange(select);
            }
          } else {
            select.value = match.value;
            dispatchVoChange(select);
          }
          return true;
        }
      }

      const inputs = Array.from(wrapper.querySelectorAll('input, textarea'));
      const choice = inputs.find((input) => {
        const inputValue = input.value || input.getAttribute('value') || '';
        return valueMatches(inputValue, value);
      });
      if (choice) {
        if (useIdempotentStandardSync) {
          if (choice.type === 'radio' || choice.type === 'checkbox') {
            if (!choice.checked) choice.click();
          } else {
            if (choice.value === value) return true;
            choice.value = value;
            dispatchVoChange(choice);
          }
        } else {
          if (choice.type === 'radio' || choice.type === 'checkbox') {
            if (!choice.checked) choice.click();
            choice.checked = true;
          } else {
            choice.value = value;
          }
          dispatchVoChange(choice);
        }
        return true;
      }

      const openInput = inputs.find((input) => !/^(radio|checkbox|hidden)$/i.test(input.type || ''));
      if (openInput) {
        if (useIdempotentStandardSync && openInput.value === value) return true;
        openInput.value = value;
        dispatchVoChange(openInput);
        return true;
      }

      return false;
    };

    const refreshTemplateStepNumbers = () => {
      const template = root.querySelector('[data-fd-vo-template]');
      if (!template) return;
      const useIdempotentStandardSync = isHazelPecanRightRailPilot
        || isNeutralBambooStandardRightRailLayout;
      let number = 0;
      template.querySelectorAll('[data-fd-vo-template-field]').forEach((field) => {
        if (field.hidden || field.dataset.fdVoUnavailable === 'true') return;
        const badge = field.querySelector('.fd-pdp-step-label b');
        if (badge) {
          number += 1;
          const nextNumber = String(number);
          if (useIdempotentStandardSync) {
            if (badge.textContent !== nextNumber) badge.textContent = nextNumber;
          } else {
            badge.textContent = nextNumber;
          }
        }
      });
    };

    const hazelNeutralExactCardAssets = {
      '_fd_bamboo_standard_lift_style': {
        'Cordless Lift': 'fd-neutral-hazel-lift-cordless.png',
        'Corded Lift': 'fd-neutral-hazel-lift-corded.png'
      },
      '_fd_bamboo_standard_edge_binding': {
        Yes: 'fd-neutral-hazel-edge-yes.png',
        No: 'fd-neutral-hazel-edge-no.png'
      },
      '_fd_bamboo_standard_warranty_options': {
        '1-Year Limited Warranty': 'fd-neutral-hazel-warranty-1-year.jpg',
        '3-Year Limited Warranty': 'fd-neutral-hazel-warranty-3-years.jpg',
        '5-Year Limited Warranty': 'fd-neutral-hazel-warranty-5-years.jpg'
      }
    };

    const getHazelNeutralExactAssetUrl = (filename) => {
      const themeAssetAnchor = Array.from(document.querySelectorAll('link[href], script[src]')).find((element) => {
        const source = element.href || element.src || '';
        return source.includes('/assets/fd-hazel-pecan-right-rail-pilot.css')
          || source.includes('/assets/fd-product-twopages-livefix-20260624-v18.js');
      });
      const source = themeAssetAnchor && (themeAssetAnchor.href || themeAssetAnchor.src);
      if (!source) return '';
      try {
        const url = new URL(filename, source);
        url.search = '';
        url.hash = '';
        return url.href;
      } catch (error) {
        return '';
      }
    };

    const decorateHazelNeutralExactCards = (bcpoRoot) => {
      if (!hasNeutralBambooStandardRightRailSignature(bcpoRoot)) return;

      Object.entries(hazelNeutralExactCardAssets).forEach(([unique, valueAssets]) => {
        const wrapper = bcpoRoot.querySelector(`[data-unique="${unique}"]`);
        if (!wrapper) return;

        const expectedValues = Object.keys(valueAssets);
        const cards = expectedValues.map((value) => {
          const input = Array.from(wrapper.querySelectorAll('input[type="radio"]')).find((candidate) => (
            candidate.value === value
          ));
          const label = input && input.id
            ? wrapper.querySelector(`label[for="${CSS.escape(input.id)}"]`)
            : null;
          const filename = valueAssets[value];
          const assetUrl = getHazelNeutralExactAssetUrl(filename);
          if (!input || !label || !assetUrl) return null;
          return { input, label, filename, assetUrl, value };
        });

        if (cards.some((card) => !card)) {
          wrapper.removeAttribute('data-fd-neutral-exact-card-group');
          return;
        }

        cards.forEach(({ input, label, filename, assetUrl, value }) => {
          if (label.dataset.fdNeutralExactCardAsset === filename) return;

          const media = document.createElement('span');
          media.className = 'fd-neutral-exact-card__media';

          const image = document.createElement('img');
          image.className = 'fd-neutral-exact-card__image';
          image.src = assetUrl;
          image.alt = '';
          image.width = 91;
          image.height = 91;
          image.loading = 'lazy';
          image.decoding = 'async';

          const check = document.createElement('span');
          check.className = 'fd-neutral-exact-card__check';
          check.setAttribute('aria-hidden', 'true');
          check.innerHTML = '<svg viewBox="0 0 16 16" focusable="false" aria-hidden="true"><path d="M3.5 8.2 6.6 11.2 12.5 4.8"></path></svg>';

          const caption = document.createElement('span');
          caption.className = 'fd-neutral-exact-card__caption';

          const text = document.createElement('span');
          text.className = 'fd-neutral-exact-card__text';
          text.textContent = value;
          caption.appendChild(text);

          const price = Number(input.dataset.price || 0);
          if (Number.isFinite(price) && price > 0) {
            const priceText = document.createElement('span');
            priceText.className = 'fd-neutral-exact-card__price';
            priceText.textContent = `(+$${price.toFixed(2)})`;
            caption.appendChild(priceText);
          }

          media.append(image, check);
          label.replaceChildren(media, caption);
          label.dataset.fdNeutralExactCardAsset = filename;
        });

        wrapper.setAttribute('data-fd-neutral-exact-card-group', '');
      });
    };

    const refreshVoTemplate = () => {
      const template = root.querySelector('[data-fd-vo-template]');
      const bcpoRoot = root.querySelector('#bcpo') || document.querySelector('#bcpo');
      const bcpoWrappers = getBcpoWrappers();
      const hasStandardRightRailSignature = hasNeutralBambooStandardRightRailSignature(bcpoRoot);
      if (isNeutralBambooStandardRightRailLayout && bcpoRoot) {
        bcpoRoot.classList.toggle('fd-bcpo-layout-grid', hasStandardRightRailSignature);
      }
      if (!template || !getBcpoOptions().length) {
        root.classList.remove('fd-neutral-bamboo-standard-right-rail-ready');
        if (isHazelPecanRightRailPilot) root.classList.remove('fd-hazel-pecan-right-rail-ready');
        bcpoWrappers.forEach((wrapper) => {
          wrapper.removeAttribute('data-fd-neutral-bamboo-standard-native-card');
          if (isHazelPecanRightRailPilot) wrapper.removeAttribute('data-fd-hazel-pecan-native-card');
        });
        return false;
      }

      const generatedColorField = ensureTemplateBcpoColorField();
      if (!bcpoRoot && !bcpoWrappers.length) {
        refreshCompositeTemplateLabels(template);
        refreshTemplateStepNumbers();
        return Boolean(generatedColorField);
      }

      const matchedTitles = new Set();
      const fields = Array.from(template.querySelectorAll('[data-fd-vo-template-field]'));
      fields.forEach((field) => {
        const controls = Array.from(field.querySelectorAll('[data-fd-vo-sync]'));
        let hasMappedControl = false;

        controls.forEach((control) => {
          const option = findBcpoOption(control.dataset.fdVoOption);
          const normalizedOptionTitle = normalizeVoText(option && option.title);
          const keepNativePilotOption = hasStandardRightRailSignature
            && (normalizedOptionTitle === 'lining' || normalizedOptionTitle === 'edge binding');
          const hasOption = Boolean(option) && !keepNativePilotOption;
          setTemplateControlToVoMode(control, hasOption);
          if (!hasOption) return;

          hasMappedControl = true;
          matchedTitles.add(normalizeVoText(option.title));
          syncSelectOptionsFromVo(control, option);
          syncNumberConstraintsFromVo(control, option);
        });

        if (controls.length) {
          field.dataset.fdVoUnavailable = hasMappedControl ? 'false' : 'true';
          field.hidden = !hasMappedControl;
          field.querySelectorAll('input, select, textarea').forEach((control) => {
            if (!controls.includes(control)) control.disabled = !hasMappedControl;
          });
        } else if (field.dataset.fdVoOptionalField === 'true' || field.hasAttribute('data-fd-vo-optional-field')) {
          field.dataset.fdVoUnavailable = 'true';
          field.hidden = true;
          field.querySelectorAll('input, select, textarea').forEach((control) => {
            control.disabled = true;
          });
        }
      });

      const colorIndexes = getBcpoColorOptionIndexes();
      bcpoWrappers.forEach((wrapper) => {
        const title = getBcpoWrapperOptionTitle(wrapper);
        const forceHidden = isForceHiddenBcpoWrapper(wrapper);
        const isColorWrapper = isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
        const normalizedTitle = normalizeVoText(title);
        const isStandardNativeCard = hasStandardRightRailSignature
          && (normalizedTitle === 'lining' || normalizedTitle === 'edge binding');
        wrapper.toggleAttribute('data-fd-neutral-bamboo-standard-native-card', isStandardNativeCard);
        if (isHazelPecanRightRailPilot) {
          wrapper.toggleAttribute('data-fd-hazel-pecan-native-card', isStandardNativeCard);
        }
        const shouldHideGeneratedColorNative = Boolean(generatedColorField && isNeutralBambooUploadedProduct && isColorWrapper);
        const shouldHide = shouldHideGeneratedColorNative || (!forceHidden && !isColorWrapper && Array.from(matchedTitles).some((matchedTitle) => (
          normalizedTitle === matchedTitle || normalizedTitle.includes(matchedTitle) || matchedTitle.includes(normalizedTitle)
        )));
        setForceHiddenBcpoWrapper(wrapper, forceHidden);
        wrapper.classList.toggle('fd-bcpo-template-hidden', shouldHide);
        if (shouldHide || forceHidden) wrapper.setAttribute('aria-hidden', 'true');
        else wrapper.removeAttribute('aria-hidden');
      });

      decorateHazelNeutralExactCards(bcpoRoot);

      if (hasStandardRightRailSignature) {
        const nativeLiningReady = Boolean(
          bcpoRoot?.querySelector('.selector-wrapper[data-unique="_fd_bamboo_standard_lining"][data-fd-neutral-bamboo-standard-native-card]:not(.fd-bcpo-template-hidden)')
        );
        const nativeEdgeReady = Boolean(
          bcpoRoot?.querySelector('.selector-wrapper[data-unique="_fd_bamboo_standard_edge_binding"][data-fd-neutral-bamboo-standard-native-card]:not(.fd-bcpo-template-hidden)')
        );
        const proxyControls = Array.from(template.querySelectorAll('[data-fd-vo-sync]'));
        const proxyDisabled = proxyControls.length > 0 && proxyControls.every((control) => control.disabled);
        const rightRailReady = nativeLiningReady && nativeEdgeReady && proxyDisabled;
        root.classList.toggle('fd-neutral-bamboo-standard-right-rail-ready', rightRailReady);
        if (isHazelPecanRightRailPilot) {
          root.classList.toggle('fd-hazel-pecan-right-rail-ready', rightRailReady);
        }
      } else {
        root.classList.remove('fd-neutral-bamboo-standard-right-rail-ready');
        if (isHazelPecanRightRailPilot) root.classList.remove('fd-hazel-pecan-right-rail-ready');
      }

      refreshDuplicateThemeColorOptions();

      const checkedLift = template.querySelector('[data-fd-lift-input]:checked');
      if (checkedLift) updateCordedControls(checkedLift.value);

      template.querySelectorAll('[data-fd-vo-sync]').forEach((control) => {
        if ((control.type === 'radio' || control.type === 'checkbox') && !control.checked) return;
        syncTemplateControlToVo(control);
      });
      refreshCompositeTemplateLabels(template);
      refreshTemplateStepNumbers();
      return true;
    };

    const isHiddenForValidation = (element) => {
      if (!element) return true;
      if (element.hidden || element.getAttribute('aria-hidden') === 'true') return true;
      if (element.closest('[hidden], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden, [aria-hidden="true"]')) return true;
      if (!window.getComputedStyle) return false;
      const style = window.getComputedStyle(element);
      return style.display === 'none' || style.visibility === 'hidden';
    };

    const isPlaceholderChoice = (control) => {
      if (!control || control.tagName !== 'SELECT') return false;
      const selected = control.options[control.selectedIndex];
      const valueText = normalizeVoText(control.value || (selected ? selected.textContent : ''));
      const optionText = normalizeVoText(selected ? selected.textContent : '');
      return !valueText || valueText === 'choose one' || optionText === 'choose one' || optionText === 'select one' || optionText === 'select';
    };

    const isHiddenControlForValidation = (control) => {
      if (!control) return true;
      const type = String(control.type || '').toLowerCase();
      if ((type === 'radio' || type === 'checkbox') && !control.closest('[hidden], .fd-bcpo-template-hidden, .fd-bcpo-force-hidden, [aria-hidden="true"]')) {
        return false;
      }
      return isHiddenForValidation(control);
    };

    const getFieldControls = (field) => Array.from(field ? field.querySelectorAll('input, select, textarea') : [])
      .filter((control) => control.type !== 'hidden' && !control.disabled && !isHiddenControlForValidation(control));

    const getChoiceGroupKey = (control, controls) => {
      const key = control.name || control.dataset.fdOriginalName || control.dataset.fdVoOption || control.id || '';
      if (key) return `${control.type}:${key}`;
      return `${control.type}:field:${controls.indexOf(control)}`;
    };

    const controlHasValue = (control, controls) => {
      if (!control || control.disabled || isHiddenForValidation(control)) return true;
      const type = String(control.type || '').toLowerCase();
      if (type === 'radio' || type === 'checkbox') {
        const groupKey = getChoiceGroupKey(control, controls);
        const group = controls.filter((item) => item.type === control.type && getChoiceGroupKey(item, controls) === groupKey);
        return group.some((item) => item.checked);
      }
      if (control.tagName === 'SELECT') return !isPlaceholderChoice(control);
      if (type === 'file') return Boolean(control.files && control.files.length);
      const value = String(control.value || '').trim();
      if (!value) return false;
      return typeof control.checkValidity === 'function' ? control.checkValidity() : true;
    };

    const getFieldLabelText = (field, fallback) => {
      const label = field && (field.querySelector('.fd-pdp-step-label span, .bcpo-title, .bcpo-label, label') || field);
      return String(label ? label.textContent : fallback || 'this option').replace(/\s+/g, ' ').trim() || fallback || 'this option';
    };

    const getValidationError = () => {
      let error = form.querySelector('[data-fd-pdp-form-error]');
      if (error) return error;
      error = document.createElement('div');
      error.className = 'fd-pdp-form-error';
      error.setAttribute('role', 'alert');
      error.setAttribute('data-fd-pdp-form-error', '');
      error.hidden = true;
      if (atc && atc.parentNode === form) form.insertBefore(error, atc);
      else form.appendChild(error);
      return error;
    };

    const setInvalidField = (field, invalid) => {
      if (!field) return;
      field.classList.toggle('is-fd-invalid', invalid);
      if (invalid) field.setAttribute('aria-invalid', 'true');
      else field.removeAttribute('aria-invalid');
    };

    const clearValidationState = () => {
      root.querySelectorAll('.is-fd-invalid').forEach((field) => setInvalidField(field, false));
      document.querySelectorAll('#bcpo .is-fd-invalid').forEach((field) => setInvalidField(field, false));
      const error = form ? form.querySelector('[data-fd-pdp-form-error]') : null;
      if (error) error.hidden = true;
    };

    const validateRequiredField = (field) => {
      if (!field || isHiddenForValidation(field)) return null;
      const controls = getFieldControls(field);
      if (!controls.length) return null;
      const checkedGroups = new Set();
      const invalidControl = controls.find((control) => {
        const type = String(control.type || '').toLowerCase();
        if (type === 'radio' || type === 'checkbox') {
          const groupKey = getChoiceGroupKey(control, controls);
          if (checkedGroups.has(groupKey)) return false;
          checkedGroups.add(groupKey);
        }
        return !controlHasValue(control, controls);
      });
      return invalidControl ? { field, control: invalidControl, label: getFieldLabelText(field) } : null;
    };

    const validateCustomizationBeforeSubmit = () => {
      if (!form || root.dataset.windowTreatment !== 'true') return true;
      clearValidationState();
      applyForceHiddenBcpoOptions();
      refreshVoTemplate();

      const invalidFields = [];
      root.querySelectorAll('[data-fd-vo-template-field]').forEach((field) => {
        if (field.dataset.fdVoOptionalField === 'true' || field.hasAttribute('data-fd-vo-optional-field')) return;
        if (field.dataset.fdVoUnavailable === 'true') return;
        const invalid = validateRequiredField(field);
        if (invalid) invalidFields.push(invalid);
      });

      const colorIndexes = getBcpoColorOptionIndexes();
      getBcpoWrappers().forEach((wrapper) => {
        if (isHiddenForValidation(wrapper)) return;
        const title = getBcpoWrapperOptionTitle(wrapper);
        if (isForceHiddenBcpoWrapper(wrapper)) return;
        const option = getBcpoWrapperOption(wrapper);
        const shouldRequire = (option && option.required === 'on') || isBcpoColorWrapper(wrapper, colorIndexes) || isBcpoColorTitle(title);
        if (!shouldRequire) return;
        const invalid = validateRequiredField(wrapper);
        if (invalid) invalidFields.push(invalid);
      });

      if (!invalidFields.length) return true;

      invalidFields.forEach((item) => setInvalidField(item.field, true));
      const first = invalidFields[0];
      const error = getValidationError();
      error.textContent = `Please complete ${first.label} before adding to cart.`;
      error.hidden = false;

      const focusTarget = first.control && typeof first.control.focus === 'function' ? first.control : first.field;
      if (focusTarget && typeof focusTarget.focus === 'function') focusTarget.focus({ preventScroll: true });
      window.requestAnimationFrame(() => {
        first.field.scrollIntoView({ behavior: 'smooth', block: 'center' });
      });
      return false;
    };

    const pdpTabs = Array.from(root.querySelectorAll('.fd-pdp-tabs a[href^="#"]'));
    const getScrollOffset = () => {
      const header = document.querySelector('[data-fd-global-header], .site-header, header');
      return (header ? header.getBoundingClientRect().height : 0) + 18;
    };
    const activateDetailTab = (link, shouldPushState) => {
      if (!link) return false;
      const hash = link.getAttribute('href');
      if (!hash || hash.charAt(0) !== '#') return false;
      const target = document.getElementById(hash.slice(1));
      if (!target) return false;

      if (target.tagName === 'DETAILS') target.open = true;
      pdpTabs.forEach((tab) => tab.classList.toggle('is-active', tab === link));

      if (shouldPushState && window.history && window.history.pushState) {
        window.history.pushState(null, '', hash);
      }

      window.requestAnimationFrame(() => {
        const top = target.getBoundingClientRect().top + window.pageYOffset - getScrollOffset();
        window.scrollTo({ top: Math.max(top, 0), behavior: 'smooth' });
      });

      return true;
    };

    const blockInvalidCustomization = (event) => {
      if (validateCustomizationBeforeSubmit()) return false;
      if (event) {
        event.preventDefault();
        event.stopImmediatePropagation();
      }
      return true;
    };

    const initMobileStickyAtc = () => {
      const sticky = root.querySelector('[data-fd-sticky-atc]');
      const stickyButton = sticky ? sticky.querySelector('[data-fd-sticky-submit]') : null;
      const getCurrentAtc = () => root.querySelector('[data-fd-atc]');
      const getCurrentAtcText = () => root.querySelector('[data-fd-atc-text]');
      if (!sticky || !stickyButton || !form) return;

      const mobileQuery = window.matchMedia ? window.matchMedia('(max-width: 768px)') : null;
      let frame = 0;
      let updateTimer = 0;

      sticky.removeAttribute('aria-hidden');
      sticky.inert = false;
      stickyButton.tabIndex = -1;
      const formId = form.getAttribute('id');
      if (formId) stickyButton.setAttribute('aria-controls', formId);

      const isMobile = () => !mobileQuery || mobileQuery.matches;

      const syncButtonState = () => {
        const currentAtc = getCurrentAtc();
        const currentAtcText = getCurrentAtcText();
        const label = currentAtcText && currentAtcText.textContent ? currentAtcText.textContent.trim() : '';
        if (label && stickyButton.textContent !== label) stickyButton.textContent = label;
        stickyButton.disabled = Boolean(currentAtc && currentAtc.disabled);
        if (currentAtc && currentAtc.disabled) stickyButton.setAttribute('aria-disabled', 'true');
        else stickyButton.removeAttribute('aria-disabled');
      };

      const setVisible = (visible) => {
        sticky.classList.toggle('is-visible', visible);
        root.classList.toggle('fd-pdp-sticky-visible', visible);
        document.body.classList.toggle('fd-pdp-sticky-visible', visible);
        sticky.dataset.fdStickyState = visible ? 'visible' : 'hidden';
        sticky.removeAttribute('aria-hidden');
        sticky.inert = false;
        delete sticky.dataset.fdAriaHiddenInertApplied;
        delete sticky.dataset.fdAriaHiddenInertWas;
        stickyButton.tabIndex = visible ? 0 : -1;
      };

      const syncPreviewOffset = () => {
        const previewBar = document.getElementById('PBarNextFrameWrapper') || document.getElementById('PBarNextFrame');
        let offset = 0;
        if (previewBar && window.getComputedStyle) {
          const rect = previewBar.getBoundingClientRect();
          const style = window.getComputedStyle(previewBar);
          const isBottomBar = rect.height > 20 && rect.bottom > window.innerHeight - 8 && style.display !== 'none' && style.visibility !== 'hidden';
          if (isBottomBar) offset = Math.min(Math.ceil(rect.height), 96);
        }
        sticky.style.setProperty('--fd-pdp-sticky-bottom-offset', `${offset}px`);
        document.body.style.setProperty('--fd-pdp-sticky-bottom-offset', `${offset}px`);
      };

      const updateSticky = () => {
        frame = 0;
        updateTimer = 0;
        syncButtonState();
        syncPreviewOffset();
        if (!isMobile()) {
          setVisible(false);
          return;
        }

        const currentAtc = getCurrentAtc();
        if (!currentAtc) {
          setVisible(false);
          return;
        }
        const atcRect = currentAtc.getBoundingClientRect();
        const formRect = form.getBoundingClientRect();
        const scrollTop = window.pageYOffset || document.documentElement.scrollTop || 0;
        const inlineAtcVisible = atcRect.top < window.innerHeight - 16 && atcRect.bottom > 16;
        const hasEnteredDecisionPath = formRect.top < window.innerHeight * 0.82 && scrollTop > 320;
        setVisible(hasEnteredDecisionPath && !inlineAtcVisible);
      };

      const scheduleUpdate = () => {
        if (frame && window.cancelAnimationFrame) window.cancelAnimationFrame(frame);
        if (updateTimer) window.clearTimeout(updateTimer);
        if (window.requestAnimationFrame) frame = window.requestAnimationFrame(updateSticky);
        updateTimer = window.setTimeout(updateSticky, 80);
      };

      window.addEventListener('scroll', scheduleUpdate, { passive: true });
      window.addEventListener('resize', scheduleUpdate);
      if (mobileQuery && mobileQuery.addEventListener) mobileQuery.addEventListener('change', scheduleUpdate);
      else if (mobileQuery && mobileQuery.addListener) mobileQuery.addListener(scheduleUpdate);

      if (window.IntersectionObserver) {
        const scrollObserver = new IntersectionObserver(scheduleUpdate, { threshold: [0, 0.01, 1] });
        const currentAtc = getCurrentAtc();
        if (currentAtc) observeElement(scrollObserver, currentAtc);
        observeElement(scrollObserver, form);
      }

      if (window.MutationObserver) {
        const buttonObserver = new MutationObserver(scheduleUpdate);
        const currentAtc = getCurrentAtc();
        const currentAtcText = getCurrentAtcText();
        if (currentAtc) {
          observeElement(buttonObserver, currentAtc, {
            attributes: true,
            attributeFilter: ['disabled', 'aria-disabled'],
            childList: true,
            characterData: true,
            subtree: true
          });
        }
        if (currentAtcText && currentAtcText !== currentAtc) {
          observeElement(buttonObserver, currentAtcText, { childList: true, characterData: true, subtree: true });
        }
      }

      scheduleUpdate();
      window.setTimeout(scheduleUpdate, 700);
      window.setTimeout(scheduleUpdate, 1800);
    };

    if (form) {
      form.addEventListener('submit', blockInvalidCustomization, true);
    }

    initMobileStickyAtc();

    document.addEventListener('click', (event) => {
      if (!isNeutralBambooUploadedProduct && !isNeutralBambooBcpoColorBridgeProduct) return;
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      const nativeBcpoColorChoice = target.closest('#bcpo .fd-bcpo-color-choice, #bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent');
      if (!nativeBcpoColorChoice || !isBcpoColorTarget(nativeBcpoColorChoice)) return;
      const nativeBcpoColorInput = getBcpoInput(nativeBcpoColorChoice, nativeBcpoColorChoice);
      if (!nativeBcpoColorInput || nativeBcpoColorInput.disabled) return;

      event.preventDefault();
      event.stopImmediatePropagation();
      clearValidationState();
      if (isDirectUserClick(event)) markUserMainImageInteraction();
      rememberNeutralBambooUserSelectedColor(nativeBcpoColorChoice);
      forceNeutralBambooUserColorValue(neutralBambooUserSelectedBcpoColor, { updateMainImage: true });
      activateNativeBcpoColorChoice(nativeBcpoColorChoice, { dispatch: false });
      syncNeutralBambooBridgeFromBcpoTarget(nativeBcpoColorChoice, { startGuard: false });
      updateBcpoColorImage(nativeBcpoColorChoice);
      scheduleBcpoColorImageUpdate(nativeBcpoColorChoice);
      scheduleNeutralBambooUserSelectedColorRestore();
      if (isNeutralBambooStandardRightRailLayout) dispatchVoChange(nativeBcpoColorInput);
    }, true);

    root.addEventListener('click', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      if (target.closest('[data-fd-atc], [data-fd-sticky-submit]')) blockInvalidCustomization(event);
    }, true);

    root.addEventListener('click', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;

      const detailTab = target.closest('.fd-pdp-tabs a[href^="#"]');
      if (detailTab) {
        event.preventDefault();
        activateDetailTab(detailTab, true);
        return;
      }

      const qtyButton = target.closest('[data-fd-qty-action]');
      if (qtyButton) {
        updateQuantity(qtyButton.dataset.fdQtyAction);
        return;
      }

      const generatedColor = target.closest('[data-fd-template-bcpo-color]');
      if (generatedColor) {
        clearValidationState();
        if (isDirectUserClick(event)) markUserMainImageInteraction();
        selectTemplateBcpoColor(generatedColor, true);
        return;
      }

      const nativeBcpoColorChoice = target.closest('#bcpo .fd-bcpo-color-choice, #bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent');
      if ((event.isTrusted || isNeutralBambooBcpoColorBridgeProduct) && nativeBcpoColorChoice && isBcpoColorTarget(nativeBcpoColorChoice)) {
        const nativeBcpoColorInput = getBcpoInput(nativeBcpoColorChoice, nativeBcpoColorChoice);
        if (nativeBcpoColorInput && !nativeBcpoColorInput.disabled && !nativeBcpoColorInput.checked) {
          event.preventDefault();
          clearValidationState();
          if (isDirectUserClick(event)) markUserMainImageInteraction();
          activateNativeBcpoColorChoice(nativeBcpoColorChoice, isNeutralBambooBcpoColorBridgeProduct ? { dispatch: false } : {});
          syncNeutralBambooBridgeFromBcpoTarget(nativeBcpoColorChoice);
          scheduleBcpoColorImageUpdate(nativeBcpoColorChoice);
          return;
        }
      }

      const bcpoColorTarget = target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent, #bcpo .bcpo-front-image-label, #bcpo .bcpo-front-color-label, #bcpo .bcpo-front-image-option, #bcpo .bcpo-front-color-option, #bcpo input, #bcpo label');
      if ((event.isTrusted || isNeutralBambooBcpoColorBridgeProduct) && bcpoColorTarget && isBcpoColorTarget(bcpoColorTarget)) {
        if (isDirectUserClick(event)) markUserMainImageInteraction();
        activateNativeBcpoColorChoice(bcpoColorTarget, isNeutralBambooBcpoColorBridgeProduct ? { dispatch: false } : {});
        syncNeutralBambooBridgeFromBcpoTarget(bcpoColorTarget);
        scheduleBcpoColorImageUpdate(bcpoColorTarget);
        return;
      }

      const mediaSwatch = target.closest('[data-fd-media-swatch]');
      if (mediaSwatch) {
        if (isDirectUserClick(event)) markUserMainImageInteraction();
        const selectedColor = mediaSwatch.dataset.label || mediaSwatch.dataset.alt || '';
        const group = mediaSwatch.closest('.fd-pdp-option--media');
        if (group) {
          group.querySelectorAll('[data-fd-media-swatch]').forEach((button) => {
            button.classList.toggle('is-selected', button === mediaSwatch);
          });
        }
        root.querySelectorAll('[data-fd-color-label]').forEach((label) => {
          if (isHazelPecanRightRailPilot || isNeutralBambooStandardRightRailLayout) {
            if (label.textContent !== selectedColor) label.textContent = selectedColor;
          } else {
            label.textContent = selectedColor;
          }
        });
        if (colorProperty && selectedColor) colorProperty.value = selectedColor;
        const swatchImage = mediaSwatch.dataset.image || getColorImage(selectedColor);
        if (swatchImage) mediaSwatch.dataset.image = swatchImage;
        const mediaMainImage = getNeutralBambooProductMainImage(selectedColor) || (!isNeutralBambooBcpoColorBridgeProduct ? swatchImage : '');
        if (mediaMainImage) setMainImage(mediaMainImage, mediaSwatch.dataset.alt || selectedColor);
        return;
      }

      const thumb = target.closest('[data-fd-thumb]');
      if (thumb) {
        if (isDirectUserClick(event)) markUserMainImageInteraction();
        if (isNeutralBambooBcpoColorBridgeProduct) {
          neutralBambooThumbMainImageOverride = true;
          window.clearInterval(neutralBambooUserColorGuardTimer);
          neutralBambooUserColorGuardTimer = 0;
        }
        clearTargetBcpoMainImage();
        activateThumb(thumb);
        return;
      }

      const valueButton = target.closest('[data-fd-option-value]');
      if (valueButton) {
        const position = Number(valueButton.dataset.optionPosition || '1') - 1;
        const group = valueButton.closest('[data-fd-option-position]');
        selectedOptions[position] = valueButton.dataset.optionValue;

        if (group) {
          group.querySelectorAll('[data-fd-option-value]').forEach((button) => {
            button.classList.toggle('is-selected', button === valueButton);
          });
        }

        if (group && group.classList.contains('fd-pdp-option--color')) {
          if (isDirectUserClick(event)) markUserMainImageInteraction();
          updateVariant(findSelectedVariant());

          root.querySelectorAll('[data-fd-color-label]').forEach((label) => {
            if (isHazelPecanRightRailPilot || isNeutralBambooStandardRightRailLayout) {
              if (label.textContent !== valueButton.dataset.optionValue) {
                label.textContent = valueButton.dataset.optionValue;
              }
            } else {
              label.textContent = valueButton.dataset.optionValue;
            }
          });
          const optionImage = valueButton.dataset.image || getColorImage(valueButton.dataset.optionValue);
          if (optionImage) {
            valueButton.dataset.image = optionImage;
            setMainImage(optionImage, valueButton.dataset.optionValue);
          }
          updateGalleryGroup(valueButton.dataset.valueHandle, optionImage);
        } else {
          updateVariant(findSelectedVariant());
        }
        return;
      }

      const seeMore = target.closest('[data-fd-see-more]');
      if (seeMore) {
        thumbs.forEach((item) => {
          if (isSuppressedNeutralBambooGalleryThumb(item)) {
            item.hidden = true;
          } else if (item.classList.contains('is-extra')) {
            item.hidden = false;
          }
        });
        seeMore.hidden = true;
        return;
      }

      const copyButton = target.closest('[data-fd-copy]');
      if (copyButton) {
        const value = copyButton.dataset.fdCopy;
        if (navigator.clipboard && value) {
          navigator.clipboard.writeText(value).catch(() => {});
        }
        copyButton.classList.add('is-copied');
        window.setTimeout(() => copyButton.classList.remove('is-copied'), 1200);
        return;
      }

      const stickySubmit = target.closest('[data-fd-sticky-submit]');
      if (stickySubmit && form) {
        event.preventDefault();
        event.stopPropagation();
        const submit = root.querySelector('[data-fd-atc]') || form.querySelector('[data-fd-atc], button[type="submit"], input[type="submit"], [type="submit"]');
        if (submit) {
          if (typeof form.requestSubmit === 'function' && submit.form === form) form.requestSubmit(submit);
          else submit.click();
        }
        return;
      }

      const cookieClose = target.closest('[data-fd-cookie-close]');
      if (cookieClose) {
        const cookie = root.querySelector('[data-fd-cookie]');
        if (cookie) cookie.hidden = true;
      }
    });

    document.addEventListener('click', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      const bcpoColorTarget = target.closest('#bcpo .bcpo-image-parent, #bcpo .bcpo-color-parent, #bcpo .bcpo-front-image-label, #bcpo .bcpo-front-color-label, #bcpo .bcpo-front-image-option, #bcpo .bcpo-front-color-option, #bcpo input, #bcpo label');
      if ((event.isTrusted || isNeutralBambooBcpoColorBridgeProduct) && bcpoColorTarget && isBcpoColorTarget(bcpoColorTarget)) {
        if (isDirectUserClick(event)) markUserMainImageInteraction();
        activateNativeBcpoColorChoice(bcpoColorTarget, isNeutralBambooBcpoColorBridgeProduct ? { dispatch: false } : {});
        syncNeutralBambooBridgeFromBcpoTarget(bcpoColorTarget);
        scheduleBcpoColorImageUpdate(bcpoColorTarget);
      }
    }, true);

    root.addEventListener('change', (event) => {
      const liftInput = event.target && event.target.closest ? event.target.closest('[data-fd-lift-input]') : null;
      if (liftInput) {
        updateCordedControls(liftInput.value);
      }

      const voTemplateControl = event.target && event.target.closest ? event.target.closest('[data-fd-vo-sync]') : null;
      if (voTemplateControl) {
        clearValidationState();
        syncTemplateRadioGroup(voTemplateControl);
        syncTemplateControlToVo(voTemplateControl);
      }

      if (event.target === quantityInput && quantityInput) {
        quantityInput.value = String(Math.max(Number(quantityInput.value || 1), 1));
      }

      const bcpoInput = event.target && event.target.closest ? event.target.closest('#bcpo input, #bcpo .bcpo-front-image-option, #bcpo .bcpo-front-color-option') : null;
      if (event.isTrusted && bcpoInput && isBcpoColorTarget(bcpoInput)) {
        const incomingColor = getBcpoColorTargetValue(bcpoInput);
        if (isNeutralBambooBcpoColorBridgeProduct && neutralBambooUserSelectedBcpoColor && incomingColor && !isSameBcpoColorValue(incomingColor, neutralBambooUserSelectedBcpoColor)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          forceNeutralBambooUserColorValue(neutralBambooUserSelectedBcpoColor, { updateMainImage: true });
          return;
        }
        clearValidationState();
        syncNeutralBambooBridgeFromBcpoTarget(bcpoInput);
        scheduleBcpoColorImageUpdate(bcpoInput);
      }
    });

    root.addEventListener('input', (event) => {
      const voTemplateControl = event.target && event.target.closest ? event.target.closest('[data-fd-vo-sync]') : null;
      if (!voTemplateControl || !/^(number|text|search|tel|url|email)?$/i.test(voTemplateControl.type || '')) return;
      clearValidationState();
      window.clearTimeout(voTemplateControl.fdVoSyncTimer);
      voTemplateControl.fdVoSyncTimer = window.setTimeout(() => {
        syncTemplateControlToVo(voTemplateControl);
      }, 200);
    });

    document.addEventListener('change', (event) => {
      const target = event.target && event.target.closest ? event.target : null;
      if (!target) return;
      const bcpoInput = target.closest('#bcpo input, #bcpo .bcpo-front-image-option, #bcpo .bcpo-front-color-option');
      if (event.isTrusted && bcpoInput && isBcpoColorTarget(bcpoInput)) {
        const incomingColor = getBcpoColorTargetValue(bcpoInput);
        if (isNeutralBambooBcpoColorBridgeProduct && neutralBambooUserSelectedBcpoColor && incomingColor && !isSameBcpoColorValue(incomingColor, neutralBambooUserSelectedBcpoColor)) {
          event.preventDefault();
          event.stopImmediatePropagation();
          forceNeutralBambooUserColorValue(neutralBambooUserSelectedBcpoColor, { updateMainImage: true });
          return;
        }
        clearValidationState();
        syncNeutralBambooBridgeFromBcpoTarget(bcpoInput);
        scheduleBcpoColorImageUpdate(bcpoInput);
      }
    }, true);

    thumbs.forEach((thumb) => {
      if (thumb.classList.contains('is-active')) activateThumb(thumb);
    });
    applyHazelAshwoodPineColorfixToMedia();
    [250, 900, 1800, 3600].forEach((delay) => {
      window.setTimeout(applyHazelAshwoodPineColorfixToMedia, delay);
    });

    const checkedLift = root.querySelector('[data-fd-lift-input]:checked');
    if (checkedLift) {
      updateCordedControls(checkedLift.value);
    }

    const initialColor = root.querySelector('.fd-pdp-option--color:not([hidden]) [data-fd-option-value].is-selected');
    if (initialColor) {
      updateGalleryGroup(initialColor.dataset.valueHandle, initialColor.dataset.image);
    }

    if (window.location.hash) {
      const initialTab = pdpTabs.find((tab) => tab.getAttribute('href') === window.location.hash);
      if (initialTab) window.setTimeout(() => activateDetailTab(initialTab, false), 300);
    }

    const syncSelectedBcpoColor = () => {
      applyForceHiddenBcpoOptions();
      decorateBcpoColorOptions();
      refreshDuplicateThemeColorOptions();
      refreshVoTemplate();
      refreshNeutralBambooColorBridge({ syncVisible: !neutralBambooUserSelectedBcpoColor });
      revealDefaultGallery();
      if (restoreNeutralBambooUserSelectedColor({ updateMainImage: true })) {
        scheduleInitialActiveThumbRestore();
        return;
      }
      const initialColorOption = getBcpoColorOption();
      const initialSkuColorValue = getInitialSkuColorValue(initialColorOption);
      const selectedBcpoColorBeforeSkuSync = Array.from(document.querySelectorAll('#bcpo input:checked')).find((input) => isBcpoColorTarget(input));
      if (initialSkuColorValue && !selectedBcpoColorBeforeSkuSync) syncBcpoColorValue(initialColorOption, initialSkuColorValue);
      const selectedBcpoColor = Array.from(document.querySelectorAll('#bcpo input:checked')).find((input) => isBcpoColorTarget(input));
      if (selectedBcpoColor) updateBcpoColorImage(selectedBcpoColor, { updateMainImage: false });
      scheduleInitialActiveThumbRestore();
    };
    syncSelectedBcpoColor();
    window.setTimeout(syncSelectedBcpoColor, 600);
    window.setTimeout(syncSelectedBcpoColor, 1800);
    window.setTimeout(syncSelectedBcpoColor, 3200);
    if (isNeutralBambooUploadedProduct) {
      let neutralBambooColorRetryCount = 0;
      const retryNeutralBambooColorField = () => {
        neutralBambooColorRetryCount += 1;
        syncSelectedBcpoColor();
        const hasColorData = Boolean(getBcpoColorOption());
        const hasGeneratedColorField = Boolean(root.querySelector('[data-fd-template-color-field]'));
        const hasNativeColorWrapper = hasNativeBcpoColorWrapper();
        if ((!hasColorData || (!hasGeneratedColorField && !hasNativeColorWrapper)) && neutralBambooColorRetryCount < 25) {
          window.setTimeout(retryNeutralBambooColorField, 1000);
        }
      };
      window.setTimeout(retryNeutralBambooColorField, 500);
    }
    if (window.MutationObserver) {
      let decorateFrame = 0;
      const standardRightRailMutationSelector = '#bcpo, .selector-wrapper, [data-fd-vo-template], [data-fd-template-color-field]';
      const isStandardRightRailMutationNode = (node) => {
        const element = node && node.nodeType === 1 ? node : (node && node.parentElement ? node.parentElement : null);
        if (!element) return false;
        return Boolean(
          (element.matches && element.matches(standardRightRailMutationSelector))
          || (element.closest && element.closest(standardRightRailMutationSelector))
          || (element.querySelector && element.querySelector(standardRightRailMutationSelector))
        );
      };
      const hasRelevantStandardRightRailMutation = (mutations) => Array.from(mutations || []).some((mutation) => (
        mutation.type === 'attributes'
        || isStandardRightRailMutationNode(mutation.target)
        || Array.from(mutation.addedNodes || []).some(isStandardRightRailMutationNode)
        || Array.from(mutation.removedNodes || []).some(isStandardRightRailMutationNode)
      ));
      const motorizedRightRailMutationSelector = [
        '[data-unique$="_motorized_color"]',
        '[data-fd-vo-template]',
        '[data-fd-template-color-field]',
        '.fd-bcpo-color-choice',
        '.bcpo-image-parent',
        '.bcpo-color-parent'
      ].join(', ');
      const isMotorizedRightRailMutationNode = (node) => {
        const element = node && node.nodeType === 1 ? node : (node && node.parentElement ? node.parentElement : null);
        if (!element) return false;
        return Boolean(
          (element.matches && element.matches(motorizedRightRailMutationSelector))
          || (element.closest && element.closest(motorizedRightRailMutationSelector))
          || (element.querySelector && element.querySelector(motorizedRightRailMutationSelector))
        );
      };
      const hasRelevantMotorizedRightRailMutation = (mutations) => Array.from(mutations || []).some((mutation) => (
        isMotorizedRightRailMutationNode(mutation.target)
        || Array.from(mutation.addedNodes || []).some(isMotorizedRightRailMutationNode)
        || Array.from(mutation.removedNodes || []).some(isMotorizedRightRailMutationNode)
      ));
      const scheduleDecorate = (mutations) => {
        if (
          isNeutralBambooStandardRightRailLayout
          && mutations
          && !hasRelevantStandardRightRailMutation(mutations)
        ) {
          return;
        }
        if (
          isNeutralBambooMotorizedRightRailLayout
          && mutations
          && !hasRelevantMotorizedRightRailMutation(mutations)
        ) {
          return;
        }
        if (decorateFrame) return;
        decorateFrame = window.requestAnimationFrame(() => {
          decorateFrame = 0;
          applyForceHiddenBcpoOptions();
          decorateBcpoColorOptions();
          refreshDuplicateThemeColorOptions();
          refreshVoTemplate();
          refreshNeutralBambooColorBridge({ syncVisible: !neutralBambooUserSelectedBcpoColor });
          restoreNeutralBambooUserSelectedColor({ updateMainImage: true });
          enforceTargetBcpoMainImage();
          scheduleInitialActiveThumbRestore();
        });
      };
      const observer = new MutationObserver(scheduleDecorate);
      const bcpoMutationRoot = root.querySelector('#bcpo');
      const templateMutationRoot = root.querySelector('[data-fd-vo-template]');
      if (bcpoMutationRoot) observeElement(observer, bcpoMutationRoot, { childList: true, subtree: true });
      if (templateMutationRoot && templateMutationRoot !== bcpoMutationRoot) {
        observeElement(observer, templateMutationRoot, { childList: true, subtree: true });
      }
      if ((preferBcpoColorImageAsMain || preserveInitialMainImageDuringColorSync) && mainImage) {
        observeElement(observer, mainImage, { attributes: true, attributeFilter: ['src', 'srcset'] });
      }
    }
  });
})();
